// AUTO-GENERATED by tools/build-bundle.ts — do not edit by hand.
// Source: src/raw/*.jsx (and screens/*.jsx). Regenerate via `bun run bundle`.
/* eslint-disable */
import React from "react";
import * as ReactDOMClient from "react-dom/client";

const ReactDOM = { createRoot: ReactDOMClient.createRoot };

if (typeof window !== "undefined") {
  // Some prototype helpers expect React on window (e.g. inline React.useState in tweaks-panel).
  window.React = React;
  window.ReactDOM = ReactDOM;
}

const {
  useState, useEffect, useMemo, useRef, useCallback, useLayoutEffect, Fragment,
  useState: useStateNM, useMemo: useMemoNM,
  useState: useStateCB, useMemo: useMemoCB,
  useState: useStateCmp,
  useState: useStateConv,
  useState: useStateLog,
  useState: useStateTpl,
  useState: useStateWh,
} = React;


// ───── src/raw/icons.jsx ─────
// Lightweight inline-SVG icon set. Each component returns a React element.
// Sized via parent CSS (we set width/height on the SVG).

const I = ({ d, viewBox = "0 0 24 24", size, stroke = 2, ...rest }) => (
  <svg viewBox={viewBox} fill="none" stroke="currentColor" strokeWidth={stroke}
       strokeLinecap="round" strokeLinejoin="round"
       width={size || undefined} height={size || undefined} {...rest}>
    {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
  </svg>
);

const Icons = {
  Logo: (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
      <path d="M4 8c0-2.2 1.8-4 4-4h8c2.2 0 4 1.8 4 4v6c0 2.2-1.8 4-4 4h-3l-4 3v-3H8c-2.2 0-4-1.8-4-4V8z" fill="white" opacity="0.95"/>
      <circle cx="9" cy="11" r="1.2" fill="#5B3FFF"/>
      <circle cx="13" cy="11" r="1.2" fill="#5B3FFF"/>
    </svg>
  ),
  Dashboard: (p) => <I {...p} d={["M3 13h7V3H3v10z","M14 21h7V11h-7v10z","M3 21h7v-6H3v6z","M14 9h7V3h-7v6z"]} />,
  Inbox: (p) => <I {...p} d={["M22 12l-6 0a4 4 0 0 1-8 0H2","M5 7l2-4h10l2 4","M2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6"]} />,
  Megaphone: (p) => <I {...p} d={["M3 11l15-7v16L3 13v-2z","M3 11v2a2 2 0 0 0 2 2h2v3a2 2 0 0 0 4 0v-3","M18 8a4 4 0 0 1 0 8"]} />,
  Card: (p) => <I {...p} d={["M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z","M3 10h18","M7 15h4"]} />,
  Users: (p) => <I {...p} d={["M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2","M22 21v-2a4 4 0 0 0-3-3.87","M16 3.13a4 4 0 0 1 0 7.75","M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"]} />,
  Chart: (p) => <I {...p} d={["M3 3v18h18","M7 15l4-6 4 3 5-8"]} />,
  Logs: (p) => <I {...p} d={["M4 6h16","M4 12h16","M4 18h10","M20 18l1.5-1.5L20 15"]} />,
  Agent: (p) => <I {...p} d={["M12 8V4H8","M3 12a9 9 0 0 1 18 0v6a2 2 0 0 1-2 2h-3v-7h5","M3 12v6a2 2 0 0 0 2 2h3v-7H3"]} />,
  Webhook: (p) => <I {...p} d={["M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17a3.95 3.95 0 0 1 1.66-3.17","M7.14 14.74l1.95-3.39A4 4 0 1 1 16 9.55a3.94 3.94 0 0 1-2.05.55l-2.04 3.51","M14.42 9.34l3.18 5.51A4 4 0 1 1 12 19.13"]} />,
  Settings: (p) => <I {...p} d={["M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z","M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h0a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v0a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"]} />,
  Search: (p) => <I {...p} d={["M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z","M21 21l-4.35-4.35"]} />,
  Bell: (p) => <I {...p} d={["M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9","M13.73 21a2 2 0 0 1-3.46 0"]} />,
  Help: (p) => <I {...p} d={["M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10z","M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3","M12 17h.01"]} />,
  Plus: (p) => <I {...p} d={["M12 5v14","M5 12h14"]} />,
  ChevDown: (p) => <I {...p} d="M6 9l6 6 6-6" />,
  ChevRight: (p) => <I {...p} d="M9 18l6-6-6-6" />,
  ChevLeft: (p) => <I {...p} d="M15 18l-6-6 6-6" />,
  ArrowUp: (p) => <I {...p} d={["M12 19V5","M5 12l7-7 7 7"]} />,
  ArrowDn: (p) => <I {...p} d={["M12 5v14","M19 12l-7 7-7-7"]} />,
  Check: (p) => <I {...p} d="M20 6L9 17l-5-5" />,
  X: (p) => <I {...p} d={["M18 6L6 18","M6 6l12 12"]} />,
  More: (p) => <I {...p} d={["M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z","M19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z","M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"]} stroke={3} />,
  Filter: (p) => <I {...p} d="M22 3H2l8 9.5V19l4 2v-8.5L22 3z" />,
  Download: (p) => <I {...p} d={["M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4","M7 10l5 5 5-5","M12 15V3"]} />,
  Upload: (p) => <I {...p} d={["M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4","M17 8l-5-5-5 5","M12 3v12"]} />,
  Send: (p) => <I {...p} d={["M22 2L11 13","M22 2l-7 20-4-9-9-4 20-7z"]} />,
  Refresh: (p) => <I {...p} d={["M23 4v6h-6","M1 20v-6h6","M3.51 9a9 9 0 0 1 14.85-3.36L23 10","M1 14l4.64 4.36A9 9 0 0 0 20.49 15"]} />,
  Phone: (p) => <I {...p} d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />,
  Image: (p) => <I {...p} d={["M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z","M8.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z","M21 15l-5-5L5 21"]} />,
  Link: (p) => <I {...p} d={["M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71","M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"]} />,
  Calendar: (p) => <I {...p} d={["M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6z","M16 2v4","M8 2v4","M3 10h18"]} />,
  Clock: (p) => <I {...p} d={["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z","M12 6v6l4 2"]} />,
  Eye: (p) => <I {...p} d={["M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z","M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"]} />,
  Edit: (p) => <I {...p} d={["M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7","M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"]} />,
  Trash: (p) => <I {...p} d={["M3 6h18","M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6","M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"]} />,
  Copy: (p) => <I {...p} d={["M20 9h-9a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2z","M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"]} />,
  ExternalLink: (p) => <I {...p} d={["M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6","M15 3h6v6","M10 14L21 3"]} />,
  Tag: (p) => <I {...p} d={["M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z","M7 7h.01"]} />,
  Play: (p) => <I {...p} d="M5 3l14 9-14 9V3z" />,
  Pause: (p) => <I {...p} d={["M6 4h4v16H6z","M14 4h4v16h-4z"]} />,
  Globe: (p) => <I {...p} d={["M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10z","M2 12h20","M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"]} />,
  Code: (p) => <I {...p} d={["M16 18l6-6-6-6","M8 6l-6 6 6 6"]} />,
  Sparkles: (p) => <I {...p} d={["M12 2l2 6 6 2-6 2-2 6-2-6-6-2 6-2 2-6z","M18 14l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z"]} />,
  Pin: (p) => <I {...p} d={["M12 2v6","M12 22l-3-7h6l-3 7z","M9 8h6a2 2 0 0 1 2 2v2H7v-2a2 2 0 0 1 2-2z"]} />,
  Lock: (p) => <I {...p} d={["M5 11a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-8z","M8 9V6a4 4 0 0 1 8 0v3"]} />,
  Mail: (p) => <I {...p} d={["M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z","M3 7l9 6 9-6"]} />,
  Bot: (p) => <I {...p} d={["M12 8V4H8","M3 10a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8z","M8 14h.01","M16 14h.01","M2 14h2","M22 14h-2"]} />,
  Verified: (p) => <I {...p} d="M12 1.5l2.39 2.51 3.46-.56 1.41 3.21 3.13 1.6-1.06 3.32 1.06 3.32-3.13 1.6-1.41 3.21-3.46-.56L12 21.5l-2.39-2.51-3.46.56-1.41-3.21L1.61 14.74l1.06-3.32L1.61 8.1l3.13-1.6 1.41-3.21 3.46.56L12 1.5z" stroke={1.5} />,
  Star: (p) => <I {...p} d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />,
  Layers: (p) => <I {...p} d={["M12 2L2 7l10 5 10-5-10-5z","M2 17l10 5 10-5","M2 12l10 5 10-5"]} />,
  Bolt: (p) => <I {...p} d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />,
  Heart: (p) => <I {...p} d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21l8.84-8.61a5.5 5.5 0 0 0 0-7.78z" />,
  Coin: (p) => <I {...p} d={["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z","M15 9.5a3 3 0 0 0-2.5-1.5h-1A2.5 2.5 0 0 0 9 10.5 2.5 2.5 0 0 0 11.5 13h1a2.5 2.5 0 0 1 0 5h-1A3 3 0 0 1 9 16.5","M12 6v2","M12 16v2"]} />,
  Truck: (p) => <I {...p} d={["M1 3h15v13H1z","M16 8h4l3 3v5h-7","M5.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z","M18.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"]} />,
  Tablet: (p) => <I {...p} d={["M5 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5z","M12 18h.01"]} />,
  Brand: (p) => <I {...p} d={["M2 8a6 6 0 0 1 12 0v4l-2 2H4l-2-2V8z","M14 12a2 2 0 0 0 2 2h2a4 4 0 0 0 0-8h-2"]} />,
  Filter2: (p) => <I {...p} d="M4 6h16M7 12h10M10 18h4" />,
  Menu: (p) => <I {...p} d={["M3 6h18","M3 12h18","M3 18h18"]} />,
  Sidebar: (p) => <I {...p} d={["M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5z","M9 3v18"]} />,
  Sun: (p) => <I {...p} d={["M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z","M12 1v2","M12 21v2","M4.22 4.22l1.42 1.42","M18.36 18.36l1.42 1.42","M1 12h2","M21 12h2","M4.22 19.78l1.42-1.42","M18.36 5.64l1.42-1.42"]} />,
  Moon: (p) => <I {...p} d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />,
  Pulse: (p) => <I {...p} d="M22 12h-4l-3 9L9 3l-3 9H2" />,
  Cart: (p) => <I {...p} d={["M9 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2z","M20 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2z","M1 1h4l2.68 13.39A2 2 0 0 0 9.66 16h9.72a2 2 0 0 0 2-1.61L23 6H6"]} />,
  Folder: (p) => <I {...p} d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2v11z" />,
};



// ───── src/raw/data.jsx ─────
// Sample data for the RCS console — 電商情境

const DATA = {
  // KPI tiles
  kpis: [
    { label: "Sent", value: "1,284,510", delta: "+12.4%", dir: "up", spark: [12,18,16,22,28,24,30,34,32,38,42,46,44,50] },
    { label: "Delivered", value: "1,231,084", delta: "+11.8%", dir: "up", sub: "95.83% delivery rate", spark: [10,14,18,22,26,30,28,32,36,40,38,44,46,48] },
    { label: "Read", value: "904,872", delta: "+8.1%", dir: "up", sub: "73.51% read rate", spark: [8,12,14,18,22,20,26,28,32,30,34,38,40,42] },
    { label: "CTR", value: "18.4%", delta: "-1.2%", dir: "dn", sub: "vs last 30 days", spark: [22,24,20,18,16,18,20,17,16,18,16,17,15,18] },
    { label: "Spend", value: "$23,847", delta: "+4.6%", dir: "up", sub: "this period", spark: [4,5,6,8,9,11,13,15,16,18,20,22,23,24] },
    { label: "Revenue Attributed", value: "$284,510", delta: "+34.2%", dir: "up", sub: "11.9× ROAS", spark: [20,28,30,32,38,44,50,58,62,70,80,92,100,112] },
  ],

  // Recent campaigns
  campaigns: [
    { id: "cmp_8h2k", name: "618 年中慶 — 早鳥推播", type: "Promotional", status: "live", audience: "VIP × 高活躍", sent: 184502, delivered: 178304, read: 142810, ctr: 23.4, revenue: 84210, schedule: "2026-05-19 09:00", agent: "ShopMart 官方", channel: "rcs" },
    { id: "cmp_4j9p", name: "訂單出貨通知 (自動化)", type: "Transactional", status: "live", audience: "下單客 (Webhook)", sent: 642110, delivered: 638910, read: 502304, ctr: 12.1, revenue: 0, schedule: "Always-on", agent: "ShopMart 官方", channel: "rcs" },
    { id: "cmp_2k4q", name: "夏季新品 Carousel", type: "Promotional", status: "scheduled", audience: "近 30 日瀏覽女裝", sent: 0, delivered: 0, read: 0, ctr: 0, revenue: 0, schedule: "2026-05-22 19:00", agent: "ShopMart 官方", channel: "rcs" },
    { id: "cmp_1f7r", name: "棄購挽回 (24h)", type: "Triggered", status: "live", audience: "棄購 24h 未結帳", sent: 28401, delivered: 27392, read: 21240, ctr: 31.2, revenue: 42810, schedule: "Trigger-based", agent: "ShopMart 官方", channel: "rcs" },
    { id: "cmp_9b3t", name: "母親節滿額禮", type: "Promotional", status: "completed", audience: "全會員", sent: 412840, delivered: 401920, read: 312045, ctr: 19.8, revenue: 128400, schedule: "2026-05-10 10:00", agent: "ShopMart 官方", channel: "rcs" },
    { id: "cmp_5x6n", name: "App 註冊 OTP", type: "Transactional", status: "live", audience: "註冊流程", sent: 84210, delivered: 83942, read: 78231, ctr: 0, revenue: 0, schedule: "Always-on", agent: "ShopMart Auth", channel: "rcs" },
    { id: "cmp_7g2v", name: "週末閃購提醒", type: "Promotional", status: "draft", audience: "—", sent: 0, delivered: 0, read: 0, ctr: 0, revenue: 0, schedule: "—", agent: "ShopMart 官方", channel: "rcs" },
    { id: "cmp_3w8m", name: "會員等級升等通知", type: "Triggered", status: "paused", audience: "Tier 升級", sent: 4210, delivered: 4180, read: 3920, ctr: 8.4, revenue: 8400, schedule: "Trigger-based", agent: "ShopMart 官方", channel: "rcs" },
  ],

  // Templates
  templates: [
    { id: "tpl_001", name: "訂單確認 - 含追蹤", type: "Rich Card", category: "Transactional", language: "zh-TW", lastUsed: "2 hours ago", uses: 84210, status: "approved" },
    { id: "tpl_002", name: "出貨通知 - 物流追蹤", type: "Rich Card", category: "Transactional", language: "zh-TW", lastUsed: "5 min ago", uses: 124820, status: "approved" },
    { id: "tpl_003", name: "促銷活動 - 三品輪播", type: "Carousel", category: "Promotional", language: "zh-TW", lastUsed: "1 day ago", uses: 42810, status: "approved" },
    { id: "tpl_004", name: "棄購挽回 - 文字+按鈕", type: "Text + Suggested", category: "Triggered", language: "zh-TW", lastUsed: "12 hours ago", uses: 28401, status: "approved" },
    { id: "tpl_005", name: "OTP 驗證碼", type: "Text", category: "Transactional", language: "zh-TW", lastUsed: "1 min ago", uses: 184210, status: "approved" },
    { id: "tpl_006", name: "618 主題 - 大圖卡", type: "Rich Card", category: "Promotional", language: "zh-TW", lastUsed: "Editing", uses: 0, status: "pending" },
    { id: "tpl_007", name: "客服首次回覆 (EN)", type: "Text + Suggested", category: "Conversational", language: "en-US", lastUsed: "3 days ago", uses: 12840, status: "approved" },
    { id: "tpl_008", name: "退貨流程引導", type: "Carousel", category: "Conversational", language: "zh-TW", lastUsed: "1 week ago", uses: 8410, status: "approved" },
    { id: "tpl_009", name: "節慶問候 - 中秋", type: "Rich Card", category: "Promotional", language: "zh-TW", lastUsed: "Sep 2025", uses: 84210, status: "archived" },
  ],

  // Conversations
  threads: [
    { id: "t1", name: "陳怡君", phone: "+886 912 345 678", preview: "謝謝你！那我先試 M 號的，等等下單～", time: "12:42", unread: 0, channel: "rcs", status: "open", assignee: "我", tag: ["VIP","女裝"] },
    { id: "t2", name: "Marcus Liu", phone: "+886 933 248 991", preview: "請問訂單 #SM2026-0918 什麼時候會到？", time: "12:38", unread: 2, channel: "rcs", status: "open", assignee: "我", tag: ["物流"] },
    { id: "t3", name: "黃慧珍", phone: "+886 988 102 332", preview: "好的，我會去信箱確認驗證碼。", time: "12:28", unread: 0, channel: "rcs", status: "open", assignee: "Lisa C.", tag: ["OTP"] },
    { id: "t4", name: "張育豪", phone: "+886 921 700 415", preview: "可以幫我換成藍色 L 號嗎？", time: "11:52", unread: 1, channel: "rcs", status: "open", assignee: "未指派", tag: ["換貨"] },
    { id: "t5", name: "Sasha Wang", phone: "+886 939 521 880", preview: "已收到，超開心 ❤️ 包裝好可愛！", time: "11:14", unread: 0, channel: "rcs", status: "resolved", assignee: "我", tag: ["VIP"] },
    { id: "t6", name: "林俊宏", phone: "+886 970 348 002", preview: "我想取消這個訂單，可以嗎？", time: "10:48", unread: 3, channel: "rcs", status: "open", assignee: "未指派", tag: ["取消"] },
    { id: "t7", name: "Emily Tsai", phone: "+886 952 144 880", preview: "Thanks! Can I get the invoice in English?", time: "10:22", unread: 0, channel: "rcs", status: "open", assignee: "Alex K.", tag: ["發票"] },
    { id: "t8", name: "周文凱", phone: "+886 918 552 091", preview: "我看到 618 活動，那個項鍊還有貨嗎？", time: "Yesterday", unread: 0, channel: "rcs", status: "open", assignee: "我", tag: ["商品詢問"] },
    { id: "t9", name: "Sophia Yang", phone: "+886 909 882 314", preview: "OK noted! See you on Saturday 👍", time: "Yesterday", unread: 0, channel: "rcs", status: "resolved", assignee: "Lisa C.", tag: [] },
    { id: "t10", name: "Kevin Lin", phone: "+886 968 110 472", preview: "請寄發票到 kevin.lin@example.com 感恩", time: "Yesterday", unread: 0, channel: "rcs", status: "resolved", assignee: "我", tag: ["發票"] },
  ],

  // Messages for the active thread (t1)
  activeMessages: [
    { from: "in", text: "嗨～想問你們上週推的那件亞麻襯衫還有 M 號的米色嗎？", time: "12:14" },
    { from: "out", text: "您好，我是 ShopMart 助理 😊 幫您查詢中…", time: "12:14" },
    { from: "out", kind: "card", card: {
      media: "亞麻寬版襯衫 - 米色",
      title: "Linen Oversized Shirt — 米色",
      desc: "亞麻 100% / M、L 現貨。618 早鳥 8 折 NT$ 1,490",
      actions: ["立即購買","查看尺寸表","加入購物車"]
    }, time: "12:15" },
    { from: "in", text: "看起來好穿！L 號顯瘦嗎？我 165cm 53kg", time: "12:20" },
    { from: "out", text: "您的身型建議選 M 號喔，版型偏寬鬆，肩線會自然落肩 👚", time: "12:21" },
    { from: "out", kind: "carousel", time: "12:22" },
    { from: "in", text: "謝謝你！那我先試 M 號的，等等下單～", time: "12:42" },
  ],

  // Audience segments + contacts
  segments: [
    { id: "seg_1", name: "VIP 會員 (LTV > NT$30k)", size: 8240, growth: "+124 / 週", lastSync: "5 分前", source: "Snowflake" },
    { id: "seg_2", name: "近 30 日棄購", size: 14821, growth: "+1.2k / 週", lastSync: "即時", source: "Webhook" },
    { id: "seg_3", name: "女裝瀏覽 - 30d", size: 92140, growth: "+8.4k / 週", lastSync: "1 小時前", source: "Snowflake" },
    { id: "seg_4", name: "RCS 開通用戶", size: 482914, growth: "+24k / 週", lastSync: "即時", source: "Twilio Lookup" },
    { id: "seg_5", name: "母親節未開信", size: 28140, growth: "—", lastSync: "1 天前", source: "Manual CSV" },
    { id: "seg_6", name: "新註冊 7 天內", size: 4128, growth: "+512 / 天", lastSync: "即時", source: "Webhook" },
  ],

  contacts: [
    { name: "陳怡君", phone: "+886 912 345 678", country: "TW", tier: "VIP", optIn: true, rcs: true, lastSeen: "5 min", spend: "$842" },
    { name: "Marcus Liu", phone: "+886 933 248 991", country: "TW", tier: "Gold", optIn: true, rcs: true, lastSeen: "8 min", spend: "$1,204" },
    { name: "黃慧珍", phone: "+886 988 102 332", country: "TW", tier: "Silver", optIn: true, rcs: true, lastSeen: "12 min", spend: "$321" },
    { name: "張育豪", phone: "+886 921 700 415", country: "TW", tier: "Gold", optIn: true, rcs: true, lastSeen: "1 h", spend: "$1,820" },
    { name: "Sasha Wang", phone: "+886 939 521 880", country: "TW", tier: "VIP", optIn: true, rcs: true, lastSeen: "2 h", spend: "$4,128" },
    { name: "林俊宏", phone: "+886 970 348 002", country: "TW", tier: "Silver", optIn: true, rcs: false, lastSeen: "3 h", spend: "$120" },
    { name: "Emily Tsai", phone: "+886 952 144 880", country: "TW", tier: "Gold", optIn: true, rcs: true, lastSeen: "4 h", spend: "$2,310" },
    { name: "周文凱", phone: "+886 918 552 091", country: "TW", tier: "Silver", optIn: true, rcs: true, lastSeen: "yesterday", spend: "$80" },
    { name: "Sophia Yang", phone: "+886 909 882 314", country: "TW", tier: "Gold", optIn: false, rcs: true, lastSeen: "yesterday", spend: "$1,440" },
    { name: "Kevin Lin", phone: "+886 968 110 472", country: "TW", tier: "Silver", optIn: true, rcs: true, lastSeen: "2 d", spend: "$210" },
  ],

  // Send log entries
  logs: [
    { ts: "12:42:08.041", to: "+886 912****678", template: "tpl_004", agent: "shopmart_official", status: "read", code: "DELIVERED→READ", cost: "$0.0042", segs: 1, msgSid: "SMa1f3e9b21c4f", error: null },
    { ts: "12:42:07.812", to: "+886 933****991", template: "tpl_002", agent: "shopmart_official", status: "delivered", code: "DELIVERED", cost: "$0.0042", segs: 1, msgSid: "SMb7e2a8c44d11", error: null },
    { ts: "12:42:07.490", to: "+886 988****332", template: "tpl_005", agent: "shopmart_auth", status: "read", code: "DELIVERED→READ", cost: "$0.0028", segs: 1, msgSid: "SMc94f1d2ea88a", error: null },
    { ts: "12:42:06.220", to: "+1 415****221", template: "tpl_007", agent: "shopmart_official", status: "failed", code: "30007", cost: "$0.0000", segs: 0, msgSid: "SMd44e8a01b2bf", error: "Recipient unreachable on RCS" },
    { ts: "12:42:05.991", to: "+886 921****415", template: "tpl_001", agent: "shopmart_official", status: "delivered", code: "DELIVERED", cost: "$0.0042", segs: 1, msgSid: "SMe88f293c4140", error: null },
    { ts: "12:42:05.412", to: "+886 939****880", template: "tpl_003", agent: "shopmart_official", status: "read", code: "DELIVERED→READ", cost: "$0.0089", segs: 1, msgSid: "SMf2310bb87420", error: null },
    { ts: "12:42:04.901", to: "+886 970****002", template: "tpl_002", agent: "shopmart_official", status: "queued", code: "QUEUED", cost: "—", segs: 0, msgSid: "SM91b4c0aa3f02", error: null },
    { ts: "12:42:04.211", to: "+886 952****880", template: "tpl_006", agent: "shopmart_official", status: "fallback_sms", code: "RCS_UNAVAILABLE→SMS", cost: "$0.0080", segs: 1, msgSid: "SM7720e1ef8d31", error: null },
    { ts: "12:42:03.804", to: "+886 918****091", template: "tpl_004", agent: "shopmart_official", status: "delivered", code: "DELIVERED", cost: "$0.0042", segs: 1, msgSid: "SM830fa49e7d22", error: null },
    { ts: "12:42:03.220", to: "+886 909****314", template: "tpl_005", agent: "shopmart_auth", status: "read", code: "DELIVERED→READ", cost: "$0.0028", segs: 1, msgSid: "SM6e29ab14df81", error: null },
    { ts: "12:42:02.910", to: "+886 968****472", template: "tpl_001", agent: "shopmart_official", status: "delivered", code: "DELIVERED", cost: "$0.0042", segs: 1, msgSid: "SM5c12b8a92e34", error: null },
    { ts: "12:42:01.401", to: "+1 650****882", template: "tpl_007", agent: "shopmart_official", status: "failed", code: "30022", cost: "$0.0000", segs: 0, msgSid: "SM4ad821e8c701", error: "RCS toll-free not approved in region" },
  ],

  // Agents
  agents: [
    { id: "agt_shopmart_official", name: "ShopMart 官方", brand: "ShopMart", verified: true, status: "live", regions: ["TW","HK","SG"], senders: 2, mau: 482914, color: "#7C5CFF" },
    { id: "agt_shopmart_auth", name: "ShopMart Auth", brand: "ShopMart", verified: true, status: "live", regions: ["TW"], senders: 1, mau: 184210, color: "#00D1B3" },
    { id: "agt_shopmart_promo", name: "ShopMart 促銷活動", brand: "ShopMart", verified: false, status: "in_review", regions: ["TW"], senders: 1, mau: 0, color: "#F5A524" },
    { id: "agt_shopmart_us", name: "ShopMart US", brand: "ShopMart US Inc.", verified: true, status: "live", regions: ["US"], senders: 1, mau: 28140, color: "#38BDF8" },
  ],

  // Webhooks
  webhooks: [
    { id: "wh_1", name: "Delivery Receipt → CRM", url: "https://crm.shopmart.io/webhooks/twilio/dlr", events: ["message.delivered","message.read","message.failed"], status: "active", lastDelivered: "2 sec ago", successRate: 99.7 },
    { id: "wh_2", name: "Inbound RCS → Helpdesk", url: "https://helpdesk.shopmart.io/api/twilio/inbound", events: ["message.received"], status: "active", lastDelivered: "12 sec ago", successRate: 100 },
    { id: "wh_3", name: "Conversion → DataLake", url: "https://snowflake.proxy.shopmart.io/ingest/rcs", events: ["postback.cta_clicked","message.read"], status: "active", lastDelivered: "1 min ago", successRate: 98.2 },
    { id: "wh_4", name: "Fallback SMS Tracking", url: "https://crm.shopmart.io/webhooks/sms-fallback", events: ["message.fallback_sent"], status: "paused", lastDelivered: "3 days ago", successRate: 99.9 },
  ],

  // Time series for charts
  series30d: {
    sent:      [38,42,45,48,52,58,62,68,72,78,82,84,86,88,90,94,98,102,108,114,118,124,130,136,142,148,154,158,162,168],
    delivered: [36,40,43,46,50,56,60,65,69,75,79,81,83,85,86,90,94,98,103,109,113,119,124,130,136,141,147,151,154,160],
    read:      [28,30,32,34,38,42,45,48,52,56,58,60,62,64,65,68,70,73,76,80,82,86,90,94,98,102,106,108,110,114],
  },
  channels: [
    { name: "RCS", value: 68, color: "#7C5CFF" },
    { name: "SMS Fallback", value: 22, color: "#38BDF8" },
    { name: "WhatsApp", value: 7, color: "#22C55E" },
    { name: "Other", value: 3, color: "#5C637A" },
  ],
  funnel: [
    { label: "Sent",       value: 1284510, pct: 100, color: "#7C5CFF" },
    { label: "Delivered",  value: 1231084, pct: 95.83, color: "#8E76FF" },
    { label: "Read",       value: 904872,  pct: 70.45, color: "#9C8EFF" },
    { label: "CTA Clicked",value: 234810,  pct: 18.28, color: "#B0A4FF" },
    { label: "Converted",  value: 28401,   pct: 2.21,  color: "#C6BEFF" },
  ],
};



// ───── src/raw/ui.jsx ─────
// Reusable UI bits: KPI cards, sparklines, area charts, donuts, etc.


// ── Sparkline ────────────────────────────────────────────────────────
function Sparkline({ data, width = 70, height = 24, color = "var(--primary)", fill = true }) {
  if (!data || data.length === 0) return null;
  const max = Math.max(...data), min = Math.min(...data);
  const w = width, h = height, pad = 2;
  const x = (i) => pad + (i * (w - pad * 2)) / (data.length - 1);
  const y = (v) => h - pad - ((v - min) / (max - min || 1)) * (h - pad * 2);
  const d = data.map((v, i) => `${i === 0 ? "M" : "L"}${x(i).toFixed(1)} ${y(v).toFixed(1)}`).join(" ");
  const area = `${d} L${x(data.length - 1)} ${h - pad} L${x(0)} ${h - pad} Z`;
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
      {fill && <path d={area} fill={color} opacity="0.14" />}
      <path d={d} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// ── KPI tile ─────────────────────────────────────────────────────────
function Kpi({ label, value, delta, dir, sub, spark, color }) {
  const cls = dir === "up" ? "delta up" : dir === "dn" ? "delta dn" : "delta flat";
  const arrow = dir === "up" ? "↑" : dir === "dn" ? "↓" : "→";
  const c = color || (dir === "up" ? "var(--success)" : dir === "dn" ? "var(--danger)" : "var(--primary)");
  return (
    <div className="kpi">
      <div className="kpi-row">
        <span className="kpi-label">{label}</span>
        {delta && <span className={cls}>{arrow} {delta}</span>}
      </div>
      <div className="kpi-val">{value}</div>
      <div className="kpi-foot">{sub || <span>&nbsp;</span>}</div>
      <div className="spark"><Sparkline data={spark} color={c} /></div>
    </div>
  );
}

// ── Area chart ───────────────────────────────────────────────────────
function AreaChart({ series, width = 700, height = 220, colors }) {
  const w = width, h = height, padL = 36, padR = 12, padT = 14, padB = 24;
  const innerW = w - padL - padR, innerH = h - padT - padB;
  const lens = series.map(s => s.data.length);
  const N = Math.max(...lens);
  const allMax = Math.max(...series.flatMap(s => s.data));
  const x = (i) => padL + (i / (N - 1)) * innerW;
  const y = (v) => padT + innerH - (v / allMax) * innerH;
  const grid = [0, 0.25, 0.5, 0.75, 1].map(t => padT + t * innerH);
  return (
    <svg viewBox={`0 0 ${w} ${h}`} width="100%" preserveAspectRatio="none" style={{ display: "block" }}>
      <defs>
        {series.map((s, i) => (
          <linearGradient key={i} id={`g-${s.name}-${i}`} x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor={colors[i]} stopOpacity="0.35" />
            <stop offset="100%" stopColor={colors[i]} stopOpacity="0" />
          </linearGradient>
        ))}
      </defs>
      {grid.map((gy, i) => (
        <line key={i} x1={padL} x2={w - padR} y1={gy} y2={gy} stroke="var(--border)" strokeDasharray={i === 4 ? "" : "2 4"} />
      ))}
      {[0, 0.5, 1].map((t, i) => (
        <text key={i} x={padL - 8} y={padT + (1 - t) * innerH + 4} fontSize="10"
              textAnchor="end" fill="var(--text-3)" fontFamily="var(--font-mono)">
          {Math.round(allMax * t)}k
        </text>
      ))}
      {Array.from({ length: 6 }).map((_, i) => {
        const ti = Math.round((i / 5) * (N - 1));
        const day = N - ti;
        return (
          <text key={i} x={x(ti)} y={h - 8} fontSize="10" textAnchor="middle" fill="var(--text-3)" fontFamily="var(--font-mono)">
            -{day}d
          </text>
        );
      })}
      {series.map((s, idx) => {
        const d = s.data.map((v, i) => `${i === 0 ? "M" : "L"}${x(i).toFixed(1)} ${y(v).toFixed(1)}`).join(" ");
        const area = `${d} L${x(s.data.length - 1)} ${padT + innerH} L${x(0)} ${padT + innerH} Z`;
        return (
          <g key={idx}>
            <path d={area} fill={`url(#g-${s.name}-${idx})`} />
            <path d={d} fill="none" stroke={colors[idx]} strokeWidth="2" strokeLinejoin="round" />
          </g>
        );
      })}
    </svg>
  );
}

// ── Donut ────────────────────────────────────────────────────────────
function Donut({ data, size = 160, thickness = 20, label, sub }) {
  const total = data.reduce((s, d) => s + d.value, 0);
  const r = (size - thickness) / 2;
  const c = size / 2;
  let acc = 0;
  return (
    <div style={{ position: "relative", width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={c} cy={c} r={r} fill="none" stroke="var(--surface-3)" strokeWidth={thickness} />
        {data.map((d, i) => {
          const v = d.value / total;
          const len = 2 * Math.PI * r * v;
          const offset = -2 * Math.PI * r * acc;
          acc += v;
          return (
            <circle key={i}
              cx={c} cy={c} r={r}
              fill="none" stroke={d.color} strokeWidth={thickness}
              strokeDasharray={`${len} ${2 * Math.PI * r}`}
              strokeDashoffset={offset}
              transform={`rotate(-90 ${c} ${c})`}
              strokeLinecap="butt"
            />
          );
        })}
      </svg>
      <div style={{
        position: "absolute", inset: 0, display: "flex",
        flexDirection: "column", alignItems: "center", justifyContent: "center"
      }}>
        <div style={{ fontFamily: "var(--font-sans)", fontSize: 22, fontWeight: 600 }}>{label}</div>
        <div style={{ fontSize: 11, color: "var(--text-3)", fontFamily: "var(--font-mono)", marginTop: 2 }}>{sub}</div>
      </div>
    </div>
  );
}

// ── Bars (simple horizontal funnel) ─────────────────────────────────
function Funnel({ rows }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {rows.map((r, i) => (
        <div key={i}>
          <div className="row" style={{ justifyContent: "space-between", alignItems: "baseline", marginBottom: 3 }}>
            <span style={{ fontSize: 12, color: "var(--text-2)" }}>{r.label}</span>
            <span className="mono-sm" style={{ color: "var(--text)" }}>
              {r.value.toLocaleString()} <span className="muted">· {r.pct}%</span>
            </span>
          </div>
          <div style={{ height: 8, background: "var(--surface-2)", borderRadius: 4 }}>
            <div style={{ width: `${r.pct}%`, height: "100%", background: r.color, borderRadius: 4 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

// ── Heatmap (7×24) ───────────────────────────────────────────────────
function Heatmap({ rows = 7, cols = 24, seed = 42 }) {
  const data = useMemo(() => {
    let s = seed;
    const rand = () => { s = (s * 9301 + 49297) % 233280; return s / 233280; };
    return Array.from({ length: rows }, () => Array.from({ length: cols }, () => rand()));
  }, [seed, rows, cols]);
  const days = ["週一","週二","週三","週四","週五","週六","週日"];
  return (
    <div style={{ display: "grid", gridTemplateColumns: `auto repeat(${cols}, 1fr)`, gap: 2, alignItems: "center" }}>
      <div></div>
      {Array.from({ length: cols }).map((_, h) => (
        <div key={h} style={{ fontSize: 9, color: "var(--text-3)", fontFamily: "var(--font-mono)", textAlign: "center" }}>
          {h % 3 === 0 ? `${h}` : ""}
        </div>
      ))}
      {data.map((row, ri) => (
        <React.Fragment key={ri}>
          <div style={{ fontSize: 10, color: "var(--text-3)", paddingRight: 8, fontFamily: "var(--font-mono)" }}>{days[ri]}</div>
          {row.map((v, ci) => {
            // skew so business hours are hotter
            const businessBoost = (ci >= 9 && ci <= 22) ? 1.5 : 0.4;
            const intensity = Math.min(1, v * businessBoost);
            const bg = `rgba(124, 92, 255, ${0.08 + intensity * 0.9})`;
            return <div key={ci} title={`${days[ri]} ${ci}:00 · ${Math.round(intensity * 100)}%`}
                        style={{ aspectRatio: "1", borderRadius: 3, background: bg }} />;
          })}
        </React.Fragment>
      ))}
    </div>
  );
}

// ── Mini Calendar ────────────────────────────────────────────────────
function MiniCalendar({ month = "May 2026", highlight = 22 }) {
  const days = Array.from({ length: 35 }, (_, i) => i - 3); // start 1 May Fri
  return (
    <div>
      <div className="row" style={{ justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
        <span style={{ fontSize: 12, fontWeight: 600 }}>{month}</span>
        <div className="row gap-4">
          <button className="icon-btn"><Icons.ChevLeft size={14} /></button>
          <button className="icon-btn"><Icons.ChevRight size={14} /></button>
        </div>
      </div>
      <div className="cal" style={{ marginBottom: 4 }}>
        {["S","M","T","W","T","F","S"].map((d, i) => (
          <div key={i} style={{ fontSize: 9, color: "var(--text-3)", textAlign: "center", padding: "2px 0", fontFamily: "var(--font-mono)" }}>{d}</div>
        ))}
      </div>
      <div className="cal">
        {days.map((d, i) => {
          if (d < 1 || d > 31) return <div key={i} className="d muted">{d < 1 ? 30 + d : d - 31}</div>;
          const cls = d === highlight ? "active" : "";
          const range = d >= 19 && d <= 25 && d !== highlight ? "range" : "";
          return <div key={i} className={`d ${cls} ${range}`}>{d}</div>;
        })}
      </div>
    </div>
  );
}

// ── status badge with dot ───────────────────────────────────────────
function StatusBadge({ status }) {
  const map = {
    live: { cls: "success", label: "Live" },
    scheduled: { cls: "info", label: "Scheduled" },
    completed: { cls: "outline", label: "Completed" },
    draft: { cls: "outline", label: "Draft" },
    paused: { cls: "warning", label: "Paused" },
    approved: { cls: "success", label: "Approved" },
    pending: { cls: "warning", label: "Pending" },
    archived: { cls: "outline", label: "Archived" },
    delivered: { cls: "success", label: "delivered" },
    read: { cls: "info", label: "read" },
    failed: { cls: "danger", label: "failed" },
    queued: { cls: "outline", label: "queued" },
    fallback_sms: { cls: "warning", label: "fallback→sms" },
    in_review: { cls: "warning", label: "In Review" },
    active: { cls: "success", label: "Active" },
    open: { cls: "info", label: "Open" },
    resolved: { cls: "outline", label: "Resolved" },
  };
  const c = map[status] || { cls: "outline", label: status };
  return <span className={`badge ${c.cls}`}><span className="dot"></span>{c.label}</span>;
}

// avatar from name
function Avatar({ name, size = "sm", color }) {
  const initials = (name || "?").split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase();
  const palette = ["#7C5CFF","#00D1B3","#38BDF8","#F5A524","#F25C5C","#22C55E","#FF8A5B","#C084FC"];
  const hue = Array.from(name || "x").reduce((a, c) => a + c.charCodeAt(0), 0) % palette.length;
  const bg = color || palette[hue];
  return <div className={size === "md" ? "avatar-md" : "avatar-sm"} style={{ background: bg }}>{initials}</div>;
}

Object.assign(window, { Sparkline, Kpi, AreaChart, Donut, Funnel, Heatmap, MiniCalendar, StatusBadge, Avatar });


// ───── src/raw/tweaks-panel.jsx ─────
// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null
      ? keyOrEdits : { [keyOrEdits]: val };
    setValues((prev) => ({ ...prev, ...edits }));
    window.parent.postMessage({ type: '__edit_mode_set_keys', edits }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', { detail: edits }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({ title = 'Tweaks', noDeckControls = false, children }) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  // Auto-inject a rail toggle when a <deck-stage> is on the page. The
  // toggle drives the deck's per-viewer _railVisible via window message;
  // state is mirrored from the same localStorage key the deck reads so
  // the control reflects reality across reloads. The mechanism is the
  // message — authors who want custom placement can post it directly
  // and pass noDeckControls to suppress this one.
  const hasDeckStage = React.useMemo(
    () => typeof document !== 'undefined' && !!document.querySelector('deck-stage'),
    [],
  );
  // deck-stage enables its rail in connectedCallback, but this panel can
  // mount before that element has upgraded. The initial read catches the
  // common case; the listener covers mounting first. (Older deck-stage.js
  // copies still wait for the host's __omelette_rail_enabled postMessage —
  // same listener handles those.)
  const [railEnabled, setRailEnabled] = React.useState(
    () => hasDeckStage && !!document.querySelector('deck-stage')?._railEnabled,
  );
  React.useEffect(() => {
    if (!hasDeckStage || railEnabled) return undefined;
    const onMsg = (e) => {
      if (e.data && e.data.type === '__omelette_rail_enabled') setRailEnabled(true);
    };
    window.addEventListener('message', onMsg);
    return () => window.removeEventListener('message', onMsg);
  }, [hasDeckStage, railEnabled]);
  const [railVisible, setRailVisible] = React.useState(() => {
    try { return localStorage.getItem('deck-stage.railVisible') !== '0'; } catch (e) { return true; }
  });
  const toggleRail = (on) => {
    setRailVisible(on);
    window.postMessage({ type: '__deck_rail_visible', on }, '*');
  };
  const offsetRef = React.useRef({ x: 16, y: 16 });
  const PAD = 16;

  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth, h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y)),
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);

  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);

  React.useEffect(() => {
    const onMsg = (e) => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);
      else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({ type: '__edit_mode_available' }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);

  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({ type: '__edit_mode_dismissed' }, '*');
  };

  const onDragStart = (e) => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX, sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = (ev) => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy),
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };

  if (!open) return null;
  return (
    <>
      <style>{__TWEAKS_STYLE}</style>
      <div ref={dragRef} className="twk-panel" data-noncommentable=""
           style={{ right: offsetRef.current.x, bottom: offsetRef.current.y }}>
        <div className="twk-hd" onMouseDown={onDragStart}>
          <b>{title}</b>
          <button className="twk-x" aria-label="Close tweaks"
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={dismiss}>✕</button>
        </div>
        <div className="twk-body">
          {children}
          {hasDeckStage && railEnabled && !noDeckControls && (
            <TweakSection label="Deck">
              <TweakToggle label="Thumbnail rail" value={railVisible} onChange={toggleRail} />
            </TweakSection>
          )}
        </div>
      </div>
    </>
  );
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({ label, children }) {
  return (
    <>
      <div className="twk-sect">{label}</div>
      {children}
    </>
  );
}

function TweakRow({ label, value, children, inline = false }) {
  return (
    <div className={inline ? 'twk-row twk-row-h' : 'twk-row'}>
      <div className="twk-lbl">
        <span>{label}</span>
        {value != null && <span className="twk-val">{value}</span>}
      </div>
      {children}
    </div>
  );
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({ label, value, min = 0, max = 100, step = 1, unit = '', onChange }) {
  return (
    <TweakRow label={label} value={`${value}${unit}`}>
      <input type="range" className="twk-slider" min={min} max={max} step={step}
             value={value} onChange={(e) => onChange(Number(e.target.value))} />
    </TweakRow>
  );
}

function TweakToggle({ label, value, onChange }) {
  return (
    <div className="twk-row twk-row-h">
      <div className="twk-lbl"><span>{label}</span></div>
      <button type="button" className="twk-toggle" data-on={value ? '1' : '0'}
              role="switch" aria-checked={!!value}
              onClick={() => onChange(!value)}><i /></button>
    </div>
  );
}

function TweakRadio({ label, value, options, onChange }) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = (o) => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({ 2: 16, 3: 10 }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = (s) => {
      const m = options.find((o) => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return <TweakSelect label={label} value={value} options={options}
                        onChange={(s) => onChange(resolve(s))} />;
  }
  const opts = options.map((o) => (typeof o === 'object' ? o : { value: o, label: o }));
  const idx = Math.max(0, opts.findIndex((o) => o.value === value));
  const n = opts.length;

  const segAt = (clientX) => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor(((clientX - r.left - 2) / inner) * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };

  const onPointerDown = (e) => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = (ev) => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };

  return (
    <TweakRow label={label}>
      <div ref={trackRef} role="radiogroup" onPointerDown={onPointerDown}
           className={dragging ? 'twk-seg dragging' : 'twk-seg'}>
        <div className="twk-seg-thumb"
             style={{ left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
                      width: `calc((100% - 4px) / ${n})` }} />
        {opts.map((o) => (
          <button key={o.value} type="button" role="radio" aria-checked={o.value === value}>
            {o.label}
          </button>
        ))}
      </div>
    </TweakRow>
  );
}

function TweakSelect({ label, value, options, onChange }) {
  return (
    <TweakRow label={label}>
      <select className="twk-field" value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((o) => {
          const v = typeof o === 'object' ? o.value : o;
          const l = typeof o === 'object' ? o.label : o;
          return <option key={v} value={v}>{l}</option>;
        })}
      </select>
    </TweakRow>
  );
}

function TweakText({ label, value, placeholder, onChange }) {
  return (
    <TweakRow label={label}>
      <input className="twk-field" type="text" value={value} placeholder={placeholder}
             onChange={(e) => onChange(e.target.value)} />
    </TweakRow>
  );
}

function TweakNumber({ label, value, min, max, step = 1, unit = '', onChange }) {
  const clamp = (n) => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({ x: 0, val: 0 });
  const onScrubStart = (e) => {
    e.preventDefault();
    startRef.current = { x: e.clientX, val: value };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = (ev) => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return (
    <div className="twk-num">
      <span className="twk-num-lbl" onPointerDown={onScrubStart}>{label}</span>
      <input type="number" value={value} min={min} max={max} step={step}
             onChange={(e) => onChange(clamp(Number(e.target.value)))} />
      {unit && <span className="twk-num-unit">{unit}</span>}
    </div>
  );
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, (c) => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}

const __TwkCheck = ({ light }) => (
  <svg viewBox="0 0 14 14" aria-hidden="true">
    <path d="M3 7.2 5.8 10 11 4.2" fill="none" strokeWidth="2.2"
          strokeLinecap="round" strokeLinejoin="round"
          stroke={light ? 'rgba(0,0,0,.78)' : '#fff'} />
  </svg>
);

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({ label, value, options, onChange }) {
  if (!options || !options.length) {
    return (
      <div className="twk-row twk-row-h">
        <div className="twk-lbl"><span>{label}</span></div>
        <input type="color" className="twk-swatch" value={value}
               onChange={(e) => onChange(e.target.value)} />
      </div>
    );
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = (o) => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return (
    <TweakRow label={label}>
      <div className="twk-chips" role="radiogroup">
        {options.map((o, i) => {
          const colors = Array.isArray(o) ? o : [o];
          const [hero, ...rest] = colors;
          const sup = rest.slice(0, 4);
          const on = key(o) === cur;
          return (
            <button key={i} type="button" className="twk-chip" role="radio"
                    aria-checked={on} data-on={on ? '1' : '0'}
                    aria-label={colors.join(', ')} title={colors.join(' · ')}
                    style={{ background: hero }}
                    onClick={() => onChange(o)}>
              {sup.length > 0 && (
                <span>
                  {sup.map((c, j) => <i key={j} style={{ background: c }} />)}
                </span>
              )}
              {on && <__TwkCheck light={__twkIsLight(hero)} />}
            </button>
          );
        })}
      </div>
    </TweakRow>
  );
}

function TweakButton({ label, onClick, secondary = false }) {
  return (
    <button type="button" className={secondary ? 'twk-btn secondary' : 'twk-btn'}
            onClick={onClick}>{label}</button>
  );
}

Object.assign(window, {
  useTweaks, TweaksPanel, TweakSection, TweakRow,
  TweakSlider, TweakToggle, TweakRadio, TweakSelect,
  TweakText, TweakNumber, TweakColor, TweakButton,
});


// ───── src/raw/phone-preview.jsx ─────
// Realistic phone preview with RCS bubbles, cards, carousels, suggested replies.

function PhonePreview({
  device = "iPhone",
  agent = { name: "ShopMart 官方", initials: "S", color: "#7C5CFF", verified: true },
  bubbles = [],
  suggestions = [],
  scale = 1,
  fallbackBanner = null,
  composerHint = "RCS 訊息"
}) {
  const time = "12:42";
  return (
    <div className="phone-stage">
      <div className={`phone-frame ${device === "Android" ? "android" : ""}`} style={{ transform: `scale(${scale})`, transformOrigin: "top center" }}>
        <div className={`phone-screen ${device === "Android" ? "android" : ""}`}>
          <PhoneStatusBar device={device} />
          <PhoneAgentHeader agent={agent} device={device} />
          <div className="phone-conversation">
            {fallbackBanner && (
              <div style={{ alignSelf: "center", padding: "4px 10px", background: "#FFF4E0", color: "#A66400", fontSize: 10, borderRadius: 999, fontFamily: "var(--font-mono)" }}>
                {fallbackBanner}
              </div>
            )}
            <div className="bubble-time">{time} · 透過 RCS Business Messaging 傳送</div>
            {bubbles.map((b, i) => <PhoneBubble key={i} {...b} />)}
            {suggestions.length > 0 && (
              <div className="suggested-row">
                {suggestions.map((s, i) => (
                  <button key={i} className="suggested-chip">
                    {s.icon && <span style={{ marginRight: 4 }}>{s.icon}</span>}
                    {s.label || s.l || s}
                  </button>
                ))}
              </div>
            )}
          </div>
          <PhoneComposer hint={composerHint} />
        </div>
      </div>
      <div className="phone-meta">
        <span>● {device} preview</span>
        <span>·</span>
        <span>{agent.verified ? "已驗證商家" : "未驗證"}</span>
      </div>
    </div>
  );
}

function PhoneStatusBar() {
  return (
    <div className="phone-statusbar">
      <span>9:41</span>
      <span style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}></span>
      <span className="icons">
        <svg width="14" height="9" viewBox="0 0 16 11" fill="currentColor"><rect x="0" y="6" width="3" height="5" rx="0.5"/><rect x="4" y="4" width="3" height="7" rx="0.5"/><rect x="8" y="2" width="3" height="9" rx="0.5"/><rect x="12" y="0" width="3" height="11" rx="0.5"/></svg>
        <svg width="11" height="9" viewBox="0 0 13 11" fill="currentColor"><path d="M6.5 11C3.5 7.5 2.5 6.2 2 5c-.4-1 .8-2 4.5-2s4.9 1 4.5 2c-.5 1.2-1.5 2.5-4.5 6z"/></svg>
        <svg width="20" height="10" viewBox="0 0 24 11" fill="none" stroke="currentColor" strokeWidth="1"><rect x="0.5" y="0.5" width="20" height="10" rx="2.5"/><rect x="2" y="2" width="16" height="7" rx="1" fill="currentColor"/><rect x="21" y="3.5" width="2" height="4" rx="0.5" fill="currentColor"/></svg>
      </span>
    </div>
  );
}

function PhoneAgentHeader({ agent }) {
  return (
    <div className="phone-msg-header">
      <div className="agent-avatar" style={{ background: agent.color }}>
        {agent.initials}
        {agent.verified && (
          <span className="verified">
            <svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
          </span>
        )}
      </div>
      <div className="agent-name">{agent.name}</div>
      <div className="agent-meta">商家 · 已驗證 · 一般訊息</div>
    </div>
  );
}

function PhoneBubble({ kind = "text", from = "out", text, card, cards, time, media, location, file }) {
  if (kind === "text") {
    return (
      <div className={`bubble ${from}`}>
        {text}
        {time && <div style={{ fontSize: 9, opacity: 0.65, marginTop: 3, fontFamily: "var(--font-mono)" }}>{time}</div>}
      </div>
    );
  }
  if (kind === "card") {
    return <RichCard card={card} />;
  }
  if (kind === "carousel") {
    return (
      <div className="rcs-carousel">
        {cards.map((c, i) => <RichCard key={i} card={c} compact />)}
      </div>
    );
  }
  if (kind === "media") {
    return (
      <div style={{ maxWidth: "82%", alignSelf: from === "out" ? "flex-end" : "flex-start" }}>
        <div style={{
          width: 220, aspectRatio: media?.ratio || "16/9",
          background: media?.bg || "linear-gradient(135deg,#FFE7C7,#FF8A5B)",
          borderRadius: 14, display: "grid", placeItems: "center",
          color: "white", fontSize: 11, fontWeight: 600,
          textShadow: "0 1px 2px rgba(0,0,0,0.2)",
          position: "relative", overflow: "hidden"
        }}>
          {media?.kind === "video" && (
            <div style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center" }}>
              <div style={{ width: 38, height: 38, borderRadius: "50%", background: "rgba(0,0,0,0.5)", display: "grid", placeItems: "center" }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M5 3l14 9-14 9V3z"/></svg>
              </div>
            </div>
          )}
          {media?.label || "Media"}
        </div>
        {media?.caption && <div style={{ background: "#F1F1F4", padding: "6px 10px", borderRadius: 14, marginTop: 4, fontSize: 11.5, color: "#333" }}>{media.caption}</div>}
      </div>
    );
  }
  if (kind === "location") {
    return (
      <div style={{ width: 220, alignSelf: from === "out" ? "flex-end" : "flex-start" }}>
        <div style={{
          height: 110,
          background: "linear-gradient(135deg, #DCE9F3 0%, #B6D5EF 50%, #93C0E2 100%)",
          position: "relative", borderRadius: "14px 14px 0 0", overflow: "hidden",
        }}>
          {/* faux map */}
          <svg width="100%" height="100%" viewBox="0 0 220 110" preserveAspectRatio="none">
            <path d="M0,30 Q60,10 120,40 T220,30" stroke="#fff" strokeWidth="2" fill="none" opacity="0.6"/>
            <path d="M0,70 Q70,50 140,80 T220,75" stroke="#fff" strokeWidth="2" fill="none" opacity="0.6"/>
            <path d="M30,0 L40,110" stroke="#9DBED9" strokeWidth="2"/>
            <path d="M170,0 L180,110" stroke="#9DBED9" strokeWidth="2"/>
            <circle cx="110" cy="55" r="20" fill="rgba(31,115,232,0.15)"/>
          </svg>
          <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -100%)" }}>
            <svg width="22" height="28" viewBox="0 0 24 24" fill="#1F73E8" stroke="white" strokeWidth="1.5"><path d="M12 2C7.6 2 4 5.6 4 10c0 6 8 12 8 12s8-6 8-12c0-4.4-3.6-8-8-8zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/></svg>
          </div>
        </div>
        <div style={{ background: "white", padding: "8px 10px", borderRadius: "0 0 14px 14px", borderTop: "1px solid #EDEEF1", border: "1px solid #E5E6EB", borderTop: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 12, color: "#111" }}>{location?.title || "ShopMart 旗艦店"}</div>
          <div style={{ fontSize: 11, color: "#666", marginTop: 2 }}>{location?.addr || "台北市信義區市府路 45 號"}</div>
        </div>
      </div>
    );
  }
  if (kind === "file") {
    return (
      <div className="bubble out" style={{ display: "flex", alignItems: "center", gap: 8, padding: 10 }}>
        <div style={{ width: 32, height: 36, background: "rgba(255,255,255,0.18)", borderRadius: 4, display: "grid", placeItems: "center", fontFamily: "var(--font-mono)", fontSize: 9, fontWeight: 700 }}>PDF</div>
        <div>
          <div style={{ fontSize: 12, fontWeight: 600 }}>{file?.name || "Invoice_SM2026-1042.pdf"}</div>
          <div style={{ fontSize: 10, opacity: 0.8 }}>{file?.size || "184 KB"} · PDF Document</div>
        </div>
      </div>
    );
  }
  if (kind === "system") {
    return (
      <div style={{ alignSelf: "center", fontSize: 10, color: "#888", padding: "2px 10px", background: "#F1F1F4", borderRadius: 999, fontFamily: "var(--font-mono)" }}>
        {text}
      </div>
    );
  }
  return null;
}

function RichCard({ card, compact }) {
  return (
    <div className="rcs-card">
      <div className="media" style={card.bg ? { background: card.bg } : {}}>
        {card.image ? (
          <img src={card.image} alt={card.media} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        ) : (
          <span style={{ textShadow: "0 1px 2px rgba(0,0,0,0.2)" }}>{card.media}</span>
        )}
      </div>
      <div className="body">
        <p className="title">{card.title}</p>
        <p className="desc">{card.desc}</p>
      </div>
      {card.actions && card.actions.length > 0 && (
        <div className="actions">
          {card.actions.map((a, i) => <button key={i}>{a}</button>)}
        </div>
      )}
    </div>
  );
}

function PhoneComposer({ hint }) {
  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 8,
      padding: "8px 12px", background: "#fff",
      borderTop: "1px solid #EDEEF1"
    }}>
      <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#EFEFF4", display: "grid", placeItems: "center", color: "#888" }}>+</div>
      <div style={{
        flex: 1, height: 30, borderRadius: 18, background: "#F2F2F7",
        display: "flex", alignItems: "center", padding: "0 12px",
        fontSize: 11.5, color: "#9095A0"
      }}>{hint || "RCS 訊息"}</div>
      <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#EFEFF4", display: "grid", placeItems: "center", color: "#888" }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/></svg>
      </div>
    </div>
  );
}



// ───── src/raw/new-message-modal.jsx ─────
// New Message Modal — interactive composer for all RCS content types
// Accessible from topbar "+" button, conversations inbox, and dashboard


const NM_TYPES = [
  { id: "text",     l: "純文字",      sub: "≤ 3,072 字元", icon: "Edit" },
  { id: "media",    l: "媒體",        sub: "圖片 / 影片",   icon: "Image" },
  { id: "card",     l: "Rich Card",   sub: "媒體+CTA",     icon: "Card" },
  { id: "carousel", l: "Carousel",    sub: "2-10 卡片",     icon: "Layers" },
  { id: "location", l: "Location",    sub: "地圖卡片",      icon: "Pin" },
  { id: "file",     l: "檔案",        sub: "PDF / 文件",    icon: "Folder" },
];

const PRESET_GRADIENTS = [
  "linear-gradient(135deg,#FFE7C7,#FF8A5B)",
  "linear-gradient(135deg,#D7E8FF,#7C5CFF)",
  "linear-gradient(135deg,#E5F7EE,#22C55E)",
  "linear-gradient(135deg,#FFD6E8,#F25C5C)",
  "linear-gradient(135deg,#E8E3FF,#9C5BFF)",
  "linear-gradient(135deg,#FFF3C7,#F5A524)",
];

const SAMPLE_CONTACTS = DATA.contacts.slice(0, 8);

function NewMessageModal({ open, onClose, initialTo = "", initialType = "card" }) {
  const [contentType, setContentType] = useStateNM(initialType);
  const [to, setTo] = useStateNM(initialTo);
  const [agentId, setAgentId] = useStateNM("agt_shopmart_official");
  const [device, setDevice] = useStateNM("iPhone");
  const [sending, setSending] = useStateNM(false);
  const [sent, setSent] = useStateNM(false);

  // text
  const [text, setText] = useStateNM("您好,這是來自 ShopMart 的訊息 ✨");

  // media
  const [media, setMedia] = useStateNM({
    kind: "image",
    label: "夏季新品圖",
    caption: "全館 8 折,免運至 5/31",
    bg: PRESET_GRADIENTS[0],
  });

  // card
  const [card, setCard] = useStateNM({
    title: "亞麻寬版襯衫",
    desc: "輕盈透氣 · NT$ 1,490",
    bg: PRESET_GRADIENTS[0],
    cta: [
      { type: "url", l: "立即購買" },
      { type: "phone", l: "聯絡客服" },
    ],
  });

  // carousel
  const [carousel, setCarousel] = useStateNM([
    { title: "亞麻寬版襯衫", desc: "NT$ 1,490", bg: PRESET_GRADIENTS[0], cta: [{ type: "url", l: "查看" }] },
    { title: "棉麻寬褲",     desc: "NT$ 1,290", bg: PRESET_GRADIENTS[1], cta: [{ type: "url", l: "查看" }] },
    { title: "編織涼鞋",     desc: "NT$ 980",   bg: PRESET_GRADIENTS[2], cta: [{ type: "url", l: "查看" }] },
  ]);

  // location
  const [location, setLocation] = useStateNM({
    title: "ShopMart 信義旗艦店",
    addr: "台北市信義區市府路 45 號",
    lat: "25.0339",
    lng: "121.5644",
  });

  // file
  const [file, setFile] = useStateNM({ name: "618_DM.pdf", size: "284 KB" });

  // suggested replies (universal)
  const [suggested, setSuggested] = useStateNM([
    { type: "reply", l: "查看詳情", icon: "👀" },
    { type: "reply", l: "聯絡客服", icon: "💬" },
  ]);

  const agent = DATA.agents.find(a => a.id === agentId);

  const bubbles = useMemoNM(() => {
    const arr = [];
    if (contentType === "text") {
      arr.push({ kind: "text", from: "out", text });
    } else if (contentType === "media") {
      arr.push({ kind: "media", from: "out", media });
    } else if (contentType === "card") {
      arr.push({ kind: "card", from: "out", card: { ...card, actions: card.cta.map(c => c.l) } });
    } else if (contentType === "carousel") {
      arr.push({ kind: "carousel", from: "out", cards: carousel.map(c => ({ ...c, actions: c.cta.map(x => x.l) })) });
    } else if (contentType === "location") {
      arr.push({ kind: "location", from: "out", location });
    } else if (contentType === "file") {
      arr.push({ kind: "file", from: "out", file });
    }
    return arr;
  }, [contentType, text, media, card, carousel, location, file]);

  const canSend = to.trim().length >= 8 && !sending;

  const handleSend = () => {
    setSending(true);
    setTimeout(() => {
      setSending(false);
      setSent(true);
      setTimeout(() => {
        setSent(false);
        onClose();
        // reset
      }, 1400);
    }, 1100);
  };

  if (!open) return null;

  return (
    <div className="nm-overlay" onClick={onClose}>
      <div className="nm-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="nm-head">
          <div className="row gap-10" style={{ alignItems: "center", flex: 1 }}>
            <div style={{ width: 28, height: 28, borderRadius: 8, background: "var(--primary-soft)", color: "var(--primary)", display: "grid", placeItems: "center" }}>
              <Icons.Send size={14}/>
            </div>
            <div>
              <strong style={{ fontFamily: "var(--font-sans)", fontSize: 14 }}>新增 RCS 訊息</strong>
              <div className="muted mono-sm" style={{ fontSize: 10 }}>單筆即時發送 · 或加入活動排程</div>
            </div>
          </div>
          <span className="env-pill"><span className="live-dot"></span> LIVE</span>
          <button className="icon-btn" onClick={onClose}><Icons.X size={15}/></button>
        </div>

        {/* Body */}
        <div className="nm-body">
          {/* LEFT — editor */}
          <div className="nm-editor">
            {/* Recipient + sender */}
            <div className="grid-2" style={{ gap: 10, marginBottom: 14 }}>
              <div className="field">
                <label>收件人 <span className="req">*</span></label>
                <div className="row gap-4">
                  <input className="input mono" placeholder="+886 9xx xxx xxx" value={to} onChange={(e) => setTo(e.target.value)}/>
                  <button className="btn"><Icons.Users size={12}/></button>
                </div>
                {/* recent contacts quick pick */}
                <div className="row gap-4" style={{ flexWrap: "wrap", marginTop: 6 }}>
                  {SAMPLE_CONTACTS.slice(0, 4).map(c => (
                    <button key={c.phone} className="btn sm" onClick={() => setTo(c.phone)}
                            style={{ fontSize: 10.5, padding: "2px 8px" }}>
                      <Avatar name={c.name} /> {c.name}
                    </button>
                  ))}
                </div>
              </div>
              <div className="field">
                <label>傳送 Agent <span className="req">*</span></label>
                <select className="input" value={agentId} onChange={(e) => setAgentId(e.target.value)}>
                  {DATA.agents.filter(a => a.status === "live").map(a => (
                    <option key={a.id} value={a.id}>{a.name} {a.verified ? "✓" : ""} · {a.regions.join("/")}</option>
                  ))}
                </select>
                <div className="hint">RCS 可達性 {to ? "87.4%" : "—"} · 不可達自動 fallback SMS</div>
              </div>
            </div>

            {/* Content type tabs */}
            <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500, marginBottom: 6, display: "block" }}>
              訊息類型
            </label>
            <div className="nm-type-grid">
              {NM_TYPES.map(t => {
                const Ico = Icons[t.icon];
                return (
                  <div key={t.id}
                       className={`nm-type ${contentType === t.id ? "selected" : ""}`}
                       onClick={() => setContentType(t.id)}>
                    <Ico size={15}/>
                    <strong>{t.l}</strong>
                    <span>{t.sub}</span>
                  </div>
                );
              })}
            </div>

            {/* Type-specific editor */}
            <div className="nm-editor-pane">
              {contentType === "text" && <NMTextEditor text={text} setText={setText}/>}
              {contentType === "media" && <NMMediaEditor media={media} setMedia={setMedia}/>}
              {contentType === "card" && <NMCardEditor card={card} setCard={setCard}/>}
              {contentType === "carousel" && <NMCarouselEditor carousel={carousel} setCarousel={setCarousel}/>}
              {contentType === "location" && <NMLocationEditor location={location} setLocation={setLocation}/>}
              {contentType === "file" && <NMFileEditor file={file} setFile={setFile}/>}
            </div>

            {/* Suggested replies (all types) */}
            {contentType !== "text" && (
              <div style={{ marginTop: 14 }}>
                <div className="row" style={{ alignItems: "baseline", marginBottom: 6 }}>
                  <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500 }}>
                    Suggested Replies ({suggested.length}/11)
                  </label>
                  <div className="spacer"></div>
                  {suggested.length < 11 && (
                    <button className="btn sm" onClick={() => setSuggested([...suggested, { type: "reply", l: "新建議", icon: "" }])}>
                      <Icons.Plus size={10}/> 新增
                    </button>
                  )}
                </div>
                <div className="nm-sugs">
                  {suggested.map((s, i) => (
                    <div key={i} className="nm-sug-row">
                      <input className="input" placeholder="emoji" value={s.icon}
                             onChange={(e) => setSuggested(suggested.map((x, j) => j === i ? { ...x, icon: e.target.value } : x))}
                             style={{ width: 50, padding: "3px 6px", textAlign: "center" }}/>
                      <input className="input" placeholder="按鈕文字" value={s.l} maxLength={25}
                             onChange={(e) => setSuggested(suggested.map((x, j) => j === i ? { ...x, l: e.target.value } : x))}
                             style={{ padding: "3px 8px", fontSize: 11.5 }}/>
                      <select className="input" value={s.type}
                              onChange={(e) => setSuggested(suggested.map((x, j) => j === i ? { ...x, type: e.target.value } : x))}
                              style={{ padding: "3px 8px", fontSize: 11.5 }}>
                        <option value="reply">文字回覆</option>
                        <option value="url">開連結</option>
                        <option value="phone">撥電話</option>
                        <option value="map">地點</option>
                      </select>
                      <button className="icon-btn" onClick={() => setSuggested(suggested.filter((_, j) => j !== i))} style={{ width: 22, height: 22 }}>
                        <Icons.Trash size={11}/>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* RIGHT — preview */}
          <div className="nm-preview">
            <div className="row" style={{ alignItems: "center", marginBottom: 10 }}>
              <strong style={{ fontSize: 12, flex: 1 }}>即時預覽</strong>
              <div className="seg">
                <button className={device === "iPhone" ? "active" : ""} onClick={() => setDevice("iPhone")}>iOS</button>
                <button className={device === "Android" ? "active" : ""} onClick={() => setDevice("Android")}>Android</button>
              </div>
            </div>
            <div style={{ transform: "scale(0.85)", transformOrigin: "top center", marginTop: -10 }}>
              <PhonePreview
                device={device}
                agent={{ name: agent.name, initials: agent.name.slice(0, 1), color: agent.color, verified: agent.verified }}
                bubbles={bubbles}
                suggestions={contentType === "text" ? [] : suggested}
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="nm-foot">
          <div className="row gap-12" style={{ alignItems: "center" }}>
            <span className="muted mono-sm">
              <Icons.Coin size={11} style={{ verticalAlign: "middle", marginRight: 3 }}/>
              預估成本 <strong style={{ color: "var(--text)" }}>$0.0042</strong> · RCS
            </span>
            <span className="muted mono-sm">
              <Icons.Bolt size={11} style={{ verticalAlign: "middle", marginRight: 3 }}/>
              送達 ≈ 1.2s
            </span>
            <span className="muted mono-sm">
              <Icons.Check size={11} style={{ verticalAlign: "middle", marginRight: 3, color: "var(--success)" }}/>
              內容檢查通過
            </span>
          </div>
          <div className="row gap-6">
            <button className="btn ghost">儲存為範本</button>
            <button className="btn"><Icons.Clock size={12}/> 排程</button>
            <button className={`btn primary ${!canSend ? "disabled" : ""}`}
                    onClick={canSend ? handleSend : null}
                    disabled={!canSend}
                    style={{ minWidth: 110, justifyContent: "center", opacity: canSend ? 1 : 0.5 }}>
              {sending ? <><Icons.Refresh size={13}/> 傳送中…</> :
               sent ? <><Icons.Check size={13}/> 已送達</> :
               <><Icons.Send size={13}/> 立即傳送</>}
            </button>
          </div>
        </div>

        {sent && (
          <div className="nm-toast">
            <Icons.Check size={14} stroke={3}/>
            <span><strong>訊息已送達</strong> · 收件人 {to} · 透過 RCS · Message SID SMa1f3e9b21c4f</span>
          </div>
        )}
      </div>
    </div>
  );
}

// ── per-type editors ───────────────────────────────────────────────

function NMTextEditor({ text, setText }) {
  return (
    <div className="field">
      <label>訊息內容</label>
      <textarea className="input" rows={5} value={text} onChange={(e) => setText(e.target.value)} maxLength={3072}/>
      <div className="hint">
        {text.length} / 3,072 字元 · 支援 emoji · 動態變數: {"{{first_name}}"} {"{{order_id}}"}
      </div>
      <div className="row gap-4" style={{ marginTop: 6, flexWrap: "wrap" }}>
        {["{{first_name}}", "{{order_id}}", "{{tracking_url}}", "{{code}}"].map(v => (
          <button key={v} className="btn sm" style={{ fontSize: 10 }}
                  onClick={() => setText(text + " " + v)}>
            <code style={{ color: "var(--primary)" }}>{v}</code>
          </button>
        ))}
      </div>
    </div>
  );
}

function NMMediaEditor({ media, setMedia }) {
  return (
    <div className="grid-2" style={{ gap: 10 }}>
      <div className="field">
        <label>媒體類型</label>
        <div className="seg" style={{ width: "fit-content" }}>
          <button className={media.kind === "image" ? "active" : ""} onClick={() => setMedia({ ...media, kind: "image" })}>
            <Icons.Image size={11}/> 圖片
          </button>
          <button className={media.kind === "video" ? "active" : ""} onClick={() => setMedia({ ...media, kind: "video" })}>
            <Icons.Play size={11}/> 影片
          </button>
          <button className={media.kind === "gif" ? "active" : ""} onClick={() => setMedia({ ...media, kind: "gif" })}>GIF</button>
        </div>
      </div>
      <div className="field">
        <label>標題</label>
        <input className="input" value={media.label} onChange={(e) => setMedia({ ...media, label: e.target.value })}/>
      </div>
      <div className="field" style={{ gridColumn: "span 2" }}>
        <label>媒體</label>
        <div style={{ border: "1.5px dashed var(--border-strong)", borderRadius: 8, padding: 16, textAlign: "center", color: "var(--text-3)" }}>
          <Icons.Upload size={18}/>
          <div style={{ marginTop: 6, fontSize: 12 }}>拖曳上傳,或先從預設樣式挑選</div>
          <div className="row gap-6" style={{ justifyContent: "center", marginTop: 8 }}>
            {PRESET_GRADIENTS.map((g, i) => (
              <div key={i} onClick={() => setMedia({ ...media, bg: g })}
                   style={{ width: 30, height: 30, borderRadius: 6, background: g, cursor: "pointer",
                            border: media.bg === g ? "2px solid var(--primary)" : "2px solid transparent" }}></div>
            ))}
          </div>
        </div>
      </div>
      <div className="field" style={{ gridColumn: "span 2" }}>
        <label>說明文字 (顯示在媒體下方)</label>
        <input className="input" value={media.caption} onChange={(e) => setMedia({ ...media, caption: e.target.value })}/>
      </div>
    </div>
  );
}

function NMCardEditor({ card, setCard }) {
  return (
    <div className="grid-2" style={{ gap: 10 }}>
      <div className="field">
        <label>卡片標題 <span className="req">*</span></label>
        <input className="input" value={card.title} maxLength={80}
               onChange={(e) => setCard({ ...card, title: e.target.value })}/>
        <div className="hint">{card.title.length} / 80</div>
      </div>
      <div className="field">
        <label>背景</label>
        <div className="row gap-4">
          {PRESET_GRADIENTS.map((g, i) => (
            <div key={i} onClick={() => setCard({ ...card, bg: g })}
                 style={{ width: 28, height: 28, borderRadius: 6, background: g, cursor: "pointer",
                          border: card.bg === g ? "2px solid var(--primary)" : "2px solid transparent" }}></div>
          ))}
        </div>
      </div>
      <div className="field" style={{ gridColumn: "span 2" }}>
        <label>描述</label>
        <textarea className="input" rows={2} value={card.desc} maxLength={2000}
                  onChange={(e) => setCard({ ...card, desc: e.target.value })}/>
      </div>
      <div style={{ gridColumn: "span 2" }}>
        <CTAList ctas={card.cta} setCtas={(v) => setCard({ ...card, cta: v })}/>
      </div>
    </div>
  );
}

function NMCarouselEditor({ carousel, setCarousel }) {
  const [active, setActive] = useStateNM(0);
  const c = carousel[active];
  return (
    <div>
      <div className="row gap-4" style={{ marginBottom: 10, overflowX: "auto", paddingBottom: 4 }}>
        {carousel.map((card, i) => (
          <div key={i} onClick={() => setActive(i)}
               style={{
                 padding: "4px 10px", borderRadius: 6, cursor: "pointer",
                 background: active === i ? "var(--primary-soft)" : "var(--surface-2)",
                 border: `1px solid ${active === i ? "var(--primary)" : "var(--border)"}`,
                 fontSize: 11, fontWeight: 500, whiteSpace: "nowrap", flex: "0 0 auto",
                 color: active === i ? "var(--primary)" : "var(--text-2)",
               }}>
            #{i + 1} {card.title.slice(0, 12)}
          </div>
        ))}
        {carousel.length < 10 && (
          <button className="btn sm" onClick={() => {
            const next = [...carousel, { title: `新卡片 ${carousel.length + 1}`, desc: "卡片描述", bg: PRESET_GRADIENTS[carousel.length % 6], cta: [{ type: "url", l: "查看" }] }];
            setCarousel(next);
            setActive(next.length - 1);
          }}>
            <Icons.Plus size={11}/> 新卡片
          </button>
        )}
        {carousel.length > 2 && (
          <button className="btn sm danger" onClick={() => {
            setCarousel(carousel.filter((_, i) => i !== active));
            setActive(Math.max(0, active - 1));
          }}>
            <Icons.Trash size={11}/>
          </button>
        )}
      </div>
      <NMCardEditor card={c} setCard={(v) => setCarousel(carousel.map((x, i) => i === active ? v : x))}/>
    </div>
  );
}

function NMLocationEditor({ location, setLocation }) {
  return (
    <div className="grid-2" style={{ gap: 10 }}>
      <div className="field">
        <label>地點名稱</label>
        <input className="input" value={location.title}
               onChange={(e) => setLocation({ ...location, title: e.target.value })}/>
      </div>
      <div className="field">
        <label>地址</label>
        <input className="input" value={location.addr}
               onChange={(e) => setLocation({ ...location, addr: e.target.value })}/>
      </div>
      <div className="field">
        <label>緯度</label>
        <input className="input mono" value={location.lat}
               onChange={(e) => setLocation({ ...location, lat: e.target.value })}/>
      </div>
      <div className="field">
        <label>經度</label>
        <input className="input mono" value={location.lng}
               onChange={(e) => setLocation({ ...location, lng: e.target.value })}/>
      </div>
    </div>
  );
}

function NMFileEditor({ file, setFile }) {
  return (
    <div className="field">
      <label>檔案</label>
      <div style={{ border: "1.5px dashed var(--border-strong)", borderRadius: 8, padding: 18, textAlign: "center", color: "var(--text-3)" }}>
        <Icons.Folder size={20}/>
        <div style={{ marginTop: 6, fontSize: 12 }}>選擇 PDF / DOCX / XLSX</div>
        <div className="mono-sm" style={{ fontSize: 10, marginTop: 2 }}>已選: {file.name} ({file.size})</div>
        <button className="btn sm" style={{ marginTop: 8 }}><Icons.Upload size={11}/> 替換檔案</button>
      </div>
    </div>
  );
}

// shared CTA list editor
function CTAList({ ctas, setCtas }) {
  return (
    <div>
      <div className="row" style={{ alignItems: "baseline", marginBottom: 6 }}>
        <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500 }}>CTA 按鈕 ({ctas.length}/4)</label>
        <div className="spacer"></div>
        {ctas.length < 4 && (
          <button className="btn sm" onClick={() => setCtas([...ctas, { type: "url", l: "新按鈕" }])}>
            <Icons.Plus size={11}/> 新增
          </button>
        )}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {ctas.map((b, i) => (
          <div key={i} className="nm-sug-row">
            <input className="input" value={b.l} placeholder="按鈕文字" maxLength={25}
                   onChange={(e) => setCtas(ctas.map((c, j) => j === i ? { ...c, l: e.target.value } : c))}
                   style={{ padding: "3px 8px", fontSize: 11.5, flex: 1 }}/>
            <select className="input" value={b.type}
                    onChange={(e) => setCtas(ctas.map((c, j) => j === i ? { ...c, type: e.target.value } : c))}
                    style={{ padding: "3px 8px", fontSize: 11.5, width: 120 }}>
              <option value="url">開啟連結</option>
              <option value="phone">撥電話</option>
              <option value="map">顯示地點</option>
              <option value="reply">傳送回覆</option>
              <option value="calendar">建立日曆</option>
            </select>
            <button className="icon-btn" onClick={() => setCtas(ctas.filter((_, j) => j !== i))} style={{ width: 22, height: 22 }}>
              <Icons.Trash size={11}/>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}



// ───── src/raw/screens/dashboard.jsx ─────
function DashboardScreen({ go }) {
  return (
    <div className="content">
      <div className="page-head">
        <div className="title-block">
          <h1>Dashboard 總覽</h1>
          <p className="desc">過去 30 天 RCS Business Messaging 全活動表現 · 即時更新</p>
        </div>
        <div className="actions">
          <div className="seg">
            <button>今日</button>
            <button>7d</button>
            <button className="active">30d</button>
            <button>90d</button>
            <button>自訂</button>
          </div>
          <button className="btn"><Icons.Download size={14}/> 匯出</button>
          <button className="btn" onClick={() => window.openNewMessage && window.openNewMessage()}><Icons.Send size={14}/> 立即傳送</button>
          <button className="btn primary" onClick={() => go("campaign_new")}><Icons.Plus size={14}/> 建立活動</button>
        </div>
      </div>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 12, marginBottom: 16 }}>
        {DATA.kpis.map((k, i) => <Kpi key={i} {...k} />)}
      </div>

      {/* Main Chart + Donut */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 280px", gap: 12, marginBottom: 16 }}>
        <div className="chart-frame">
          <div className="row" style={{ alignItems: "center", marginBottom: 14 }}>
            <div className="col gap-4 flex-1">
              <strong style={{ fontFamily: "var(--font-sans)", fontSize: 13 }}>傳送漏斗 (30d)</strong>
              <span className="muted mono-sm">Sent → Delivered → Read</span>
            </div>
            <div className="legend-row">
              <span><span className="sw" style={{ background: "#7C5CFF" }}></span>Sent</span>
              <span><span className="sw" style={{ background: "#00D1B3" }}></span>Delivered</span>
              <span><span className="sw" style={{ background: "#38BDF8" }}></span>Read</span>
            </div>
          </div>
          <AreaChart
            series={[
              { name: "sent", data: DATA.series30d.sent },
              { name: "delivered", data: DATA.series30d.delivered },
              { name: "read", data: DATA.series30d.read },
            ]}
            colors={["#7C5CFF", "#00D1B3", "#38BDF8"]}
          />
        </div>

        <div className="chart-frame">
          <div style={{ marginBottom: 10 }}>
            <strong style={{ fontFamily: "var(--font-sans)", fontSize: 13 }}>訊息通道分佈</strong>
            <div className="muted mono-sm">含 SMS / WhatsApp fallback</div>
          </div>
          <div style={{ display: "flex", justifyContent: "center", padding: "6px 0 12px" }}>
            <Donut data={DATA.channels} label="68%" sub="RCS native" />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {DATA.channels.map(c => (
              <div key={c.name} className="row" style={{ justifyContent: "space-between", alignItems: "center", fontSize: 12 }}>
                <span><span className="sw" style={{ background: c.color, display: "inline-block", width: 8, height: 8, borderRadius: 2, marginRight: 8 }}></span>{c.name}</span>
                <span className="mono-sm">{c.value}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Funnel + Heatmap + Top campaigns */}
      <div style={{ display: "grid", gridTemplateColumns: "1.1fr 1.4fr", gap: 12, marginBottom: 16 }}>
        <div className="chart-frame">
          <div className="row" style={{ alignItems: "baseline", marginBottom: 14 }}>
            <strong className="flex-1" style={{ fontFamily: "var(--font-sans)", fontSize: 13 }}>轉換漏斗</strong>
            <span className="muted mono-sm">含 CTA 點擊 + Conversion 歸因</span>
          </div>
          <Funnel rows={DATA.funnel} />
          <div style={{ marginTop: 12, padding: 10, background: "var(--surface-2)", borderRadius: 8, fontSize: 11.5, color: "var(--text-2)" }}>
            <strong style={{ color: "var(--success)" }}>↑ 34.2%</strong> 整體轉換較上期成長,主要由「618 早鳥」及「棄購挽回」貢獻。
          </div>
        </div>

        <div className="chart-frame">
          <div className="row" style={{ alignItems: "baseline", marginBottom: 14 }}>
            <strong className="flex-1" style={{ fontFamily: "var(--font-sans)", fontSize: 13 }}>互動熱區 (週 × 小時)</strong>
            <span className="muted mono-sm">點擊率最高時段</span>
          </div>
          <Heatmap />
          <div className="row gap-12" style={{ marginTop: 10, fontSize: 11, color: "var(--text-3)", fontFamily: "var(--font-mono)" }}>
            <span>低</span>
            <div style={{ flex: 1, display: "flex", gap: 2 }}>
              {[0.1,0.25,0.4,0.55,0.7,0.85,1].map(v => (
                <div key={v} style={{ flex: 1, height: 8, background: `rgba(124,92,255,${v})`, borderRadius: 2 }} />
              ))}
            </div>
            <span>高</span>
          </div>
        </div>
      </div>

      {/* Live activity + Top templates */}
      <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 12 }}>
        <div className="card">
          <div className="card-head">
            <h3>即時 Top 活動</h3>
            <span className="sub">過去 24 小時表現</span>
            <div className="spacer"></div>
            <button className="btn sm" onClick={() => go("campaigns")}>查看全部 →</button>
          </div>
          <table className="data">
            <thead>
              <tr>
                <th>活動名稱</th>
                <th>狀態</th>
                <th className="right">已傳送</th>
                <th className="right">送達率</th>
                <th className="right">CTR</th>
                <th className="right">歸因營收</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {DATA.campaigns.filter(c => c.status === "live" || c.status === "completed").slice(0, 5).map(c => (
                <tr key={c.id}>
                  <td>
                    <div className="col gap-4">
                      <strong style={{ fontSize: 12.5 }}>{c.name}</strong>
                      <span className="muted mono-sm">{c.id} · {c.type}</span>
                    </div>
                  </td>
                  <td><StatusBadge status={c.status} /></td>
                  <td className="right mono">{c.sent.toLocaleString()}</td>
                  <td className="right mono">{c.sent ? (c.delivered / c.sent * 100).toFixed(1) : "—"}%</td>
                  <td className="right mono">{c.ctr ? `${c.ctr}%` : "—"}</td>
                  <td className="right mono" style={{ color: c.revenue ? "var(--success)" : "var(--text-3)" }}>
                    {c.revenue ? `$${c.revenue.toLocaleString()}` : "—"}
                  </td>
                  <td className="right">
                    <Sparkline data={[12,18,16,24,22,30,28,34,32,38]} width={50} height={18} color="var(--primary)" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="card">
          <div className="card-head">
            <h3>系統狀態</h3>
            <div className="spacer"></div>
            <span className="badge success"><span className="dot"></span>所有系統正常</span>
          </div>
          <div style={{ padding: 14 }}>
            {[
              { name: "RCS Sender (TW)", status: "success", val: "99.99%", sub: "Uptime · 30d" },
              { name: "RCS Sender (US)", status: "success", val: "99.98%", sub: "Uptime · 30d" },
              { name: "Webhook delivery", status: "success", val: "99.7%", sub: "12,481 events / hr" },
              { name: "Fallback SMS pool", status: "warning", val: "94.2%", sub: "carrier latency 高" },
              { name: "Template approval", status: "success", val: "Live", sub: "2 pending review" },
            ].map((s, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: i < 4 ? "1px solid var(--border-soft)" : 0 }}>
                <span className={`status-dot ${s.status}`}></span>
                <div className="col flex-1 gap-4">
                  <span style={{ fontSize: 12, fontWeight: 500 }}>{s.name}</span>
                  <span className="muted mono-sm">{s.sub}</span>
                </div>
                <span className="mono-sm" style={{ fontWeight: 600 }}>{s.val}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}



// ───── src/raw/screens/conversations.jsx ─────
function ConversationsScreen() {
  const [activeId, setActiveId] = useStateConv("t1");
  const [tab, setTab] = useStateConv("all");
  const active = DATA.threads.find(t => t.id === activeId) || DATA.threads[0];
  const counts = {
    all: DATA.threads.length,
    mine: DATA.threads.filter(t => t.assignee === "我").length,
    unassigned: DATA.threads.filter(t => t.assignee === "未指派").length,
    resolved: DATA.threads.filter(t => t.status === "resolved").length,
  };
  const filtered = DATA.threads.filter(t => {
    if (tab === "all") return true;
    if (tab === "mine") return t.assignee === "我";
    if (tab === "unassigned") return t.assignee === "未指派";
    if (tab === "resolved") return t.status === "resolved";
    return true;
  });

  return (
    <div className="content flush">
      <div className="inbox-grid">
        {/* LEFT - thread list */}
        <div className="inbox-pane">
          <div className="inbox-pane-head" style={{ flexDirection: "column", alignItems: "stretch", padding: 10, gap: 8 }}>
            <div className="row" style={{ alignItems: "center", gap: 8 }}>
              <strong style={{ fontFamily: "var(--font-sans)", fontSize: 14, flex: 1 }}>收件匣</strong>
              <button className="btn primary sm" onClick={() => window.openNewMessage && window.openNewMessage()}>
                <Icons.Plus size={11}/> 新訊息
              </button>
              <button className="icon-btn"><Icons.Filter size={14}/></button>
              <button className="icon-btn"><Icons.Refresh size={14}/></button>
            </div>
            <div className="searchbox" style={{ width: "100%", minWidth: 0 }}>
              <Icons.Search size={13}/>
              <input placeholder="搜尋對話、電話、tag..."/>
            </div>
            <div className="tabs" style={{ overflowX: "auto", borderBottom: 0 }}>
              {[
                { id: "all", l: "全部", c: counts.all },
                { id: "mine", l: "我的", c: counts.mine },
                { id: "unassigned", l: "未指派", c: counts.unassigned },
                { id: "resolved", l: "已解決", c: counts.resolved },
              ].map(t => (
                <div key={t.id} className={`tab ${tab === t.id ? "active" : ""}`} onClick={() => setTab(t.id)}>
                  {t.l}<span className="count">{t.c}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="inbox-list">
            {filtered.map(t => (
              <div key={t.id} className={`thread-item ${t.id === activeId ? "active" : ""}`} onClick={() => setActiveId(t.id)}>
                <Avatar name={t.name} />
                <div className="meta">
                  <span className="name">{t.name}</span>
                  <span className="preview">{t.preview}</span>
                  <div className="row gap-4" style={{ marginTop: 3 }}>
                    {t.tag.map(tg => <span key={tg} className="badge outline" style={{ fontSize: 9, padding: "0 5px" }}>{tg}</span>)}
                  </div>
                </div>
                <div className="right">
                  <span className="time">{t.time}</span>
                  {t.unread > 0 && <span className="unread">{t.unread}</span>}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* MIDDLE - conversation */}
        <div className="inbox-pane center conversation-pane">
          <div className="conv-header">
            <Avatar name={active.name} size="md" />
            <div className="col flex-1 gap-4">
              <div className="row gap-8" style={{ alignItems: "center" }}>
                <strong style={{ fontSize: 13.5 }}>{active.name}</strong>
                <span className="badge primary"><span className="dot"></span>RCS</span>
                <span className="muted mono-sm">{active.phone}</span>
              </div>
              <span className="muted mono-sm">最後活動 {active.time} · 對話 ID {active.id.toUpperCase()}-2026-05-19</span>
            </div>
            <div className="row gap-6">
              <button className="btn sm"><Icons.Tag size={12}/> 標籤</button>
              <button className="btn sm"><Icons.Users size={12}/> 指派</button>
              <button className="btn sm"><Icons.Check size={12}/> 標記已解決</button>
              <button className="icon-btn"><Icons.More size={14}/></button>
            </div>
          </div>

          <div className="conv-msgs">
            <div style={{ alignSelf: "center", fontSize: 10, color: "var(--text-3)", padding: "4px 10px", background: "var(--surface-2)", borderRadius: 999, fontFamily: "var(--font-mono)" }}>
              今天 · RCS Business Messaging
            </div>

            {DATA.activeMessages.map((m, i) => {
              if (m.kind === "card") {
                return (
                  <div key={i} style={{ alignSelf: "flex-end", maxWidth: 280 }}>
                    <RcsCardDark card={m.card} />
                    <div style={{ fontSize: 10, color: "var(--text-3)", textAlign: "right", marginTop: 4, fontFamily: "var(--font-mono)" }}>{m.time} · 已讀</div>
                  </div>
                );
              }
              if (m.kind === "carousel") {
                return (
                  <div key={i} style={{ alignSelf: "flex-end", maxWidth: 360 }}>
                    <div style={{ display: "flex", gap: 6, overflowX: "auto", paddingBottom: 4 }}>
                      {[
                        { title: "M 號 米色", desc: "NT$ 1,490", bg: "linear-gradient(135deg,#FFE7C7,#FF8A5B)" },
                        { title: "L 號 米色", desc: "NT$ 1,490", bg: "linear-gradient(135deg,#D7E8FF,#7C5CFF)" },
                        { title: "M 號 灰", desc: "NT$ 1,490", bg: "linear-gradient(135deg,#E5F7EE,#22C55E)" },
                      ].map((c, j) => (
                        <div key={j} style={{ flex: "0 0 140px" }}>
                          <RcsCardDark card={{ title: c.title, desc: c.desc, bg: c.bg, actions: ["立即購買"] }} compact />
                        </div>
                      ))}
                    </div>
                    <div style={{ fontSize: 10, color: "var(--text-3)", textAlign: "right", marginTop: 4, fontFamily: "var(--font-mono)" }}>{m.time} · 已讀</div>
                  </div>
                );
              }
              return (
                <div key={i} className={`conv-msg ${m.from}`}>
                  {m.text}
                  <div className="conv-msg-time">{m.time}{m.from === "out" ? " · 已讀" : ""}</div>
                </div>
              );
            })}
          </div>

          <div className="conv-composer">
            <div className="composer-input">
              <textarea placeholder="輸入訊息... (Cmd+Enter 傳送, / 插入範本)" rows={1}></textarea>
              <button className="btn primary sm"><Icons.Send size={12}/> 傳送</button>
            </div>
            <div className="composer-tools">
              <button className="icon-btn" title="Rich Card"><Icons.Card size={15}/></button>
              <button className="icon-btn" title="Image"><Icons.Image size={15}/></button>
              <button className="icon-btn" title="Carousel"><Icons.Layers size={15}/></button>
              <button className="icon-btn" title="Suggested Replies"><Icons.Bolt size={15}/></button>
              <button className="icon-btn" title="Template"><Icons.Folder size={15}/></button>
              <div style={{ flex: 1 }}></div>
              <span className="muted mono-sm" style={{ marginRight: 8 }}>0 / 2,048</span>
              <span className="badge primary"><span className="dot"></span>RCS Reply</span>
            </div>
          </div>
        </div>

        {/* RIGHT - customer panel */}
        <div className="inbox-pane">
          <div className="inbox-pane-head">
            <strong style={{ fontSize: 13, fontFamily: "var(--font-sans)" }}>客戶資訊</strong>
            <div className="spacer"></div>
            <button className="icon-btn"><Icons.ExternalLink size={14}/></button>
          </div>
          <div style={{ overflowY: "auto", padding: 14 }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8, paddingBottom: 14, borderBottom: "1px solid var(--border-soft)" }}>
              <Avatar name={active.name} size="md" />
              <strong style={{ fontSize: 14 }}>{active.name}</strong>
              <span className="muted mono-sm">{active.phone}</span>
              <div className="row gap-6">
                <span className="badge primary">VIP</span>
                <span className="badge success"><span className="dot"></span>RCS 已驗證</span>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, padding: "14px 0", borderBottom: "1px solid var(--border-soft)" }}>
              {[
                ["終身消費","NT$ 84,210"], ["訂單數","32"], ["上次下單","3 天前"], ["平均客單","NT$ 2,631"]
              ].map(([k, v], i) => (
                <div key={i}>
                  <div className="muted mono-sm" style={{ fontSize: 10 }}>{k.toUpperCase()}</div>
                  <div style={{ fontWeight: 600, marginTop: 2, fontSize: 13 }}>{v}</div>
                </div>
              ))}
            </div>

            <div style={{ padding: "14px 0", borderBottom: "1px solid var(--border-soft)" }}>
              <div className="row" style={{ alignItems: "baseline", marginBottom: 8 }}>
                <strong style={{ fontSize: 12 }}>近期訂單</strong>
                <div className="spacer"></div>
                <a className="muted mono-sm" style={{ fontSize: 10 }}>查看全部</a>
              </div>
              {[
                { id: "SM2026-1042", item: "Linen Shirt × 2", v: "$2,980", s: "已出貨" },
                { id: "SM2026-0918", item: "Silk Scarf", v: "$1,290", s: "運送中" },
                { id: "SM2026-0814", item: "Cotton Dress", v: "$3,420", s: "已完成" },
              ].map((o) => (
                <div key={o.id} style={{ display: "flex", gap: 10, padding: "8px 0", borderBottom: "1px dashed var(--border-soft)", alignItems: "center" }}>
                  <div className="col flex-1 gap-4">
                    <span className="mono-sm" style={{ color: "var(--text)", fontSize: 11.5 }}>{o.id}</span>
                    <span className="muted" style={{ fontSize: 11 }}>{o.item}</span>
                  </div>
                  <div className="col" style={{ alignItems: "flex-end", gap: 4 }}>
                    <span style={{ fontSize: 12, fontWeight: 600 }}>{o.v}</span>
                    <span className="badge outline" style={{ fontSize: 9 }}>{o.s}</span>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ padding: "14px 0" }}>
              <strong style={{ fontSize: 12 }}>標籤</strong>
              <div className="row gap-4" style={{ flexWrap: "wrap", marginTop: 8 }}>
                <span className="badge primary">VIP</span>
                <span className="badge outline">女裝</span>
                <span className="badge outline">早鳥</span>
                <span className="badge outline">+ 新增</span>
              </div>
            </div>

            <div style={{ padding: "14px 0", borderTop: "1px solid var(--border-soft)" }}>
              <strong style={{ fontSize: 12 }}>內部備註</strong>
              <textarea className="input" placeholder="記下此客戶的資訊 (僅內部可見)" style={{ marginTop: 8 }} rows={3}></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// dark-mode variant of RCS card for the inbox view
function RcsCardDark({ card, compact }) {
  return (
    <div style={{
      background: "white", color: "#111",
      borderRadius: 12, overflow: "hidden",
      border: "1px solid rgba(0,0,0,0.08)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
    }}>
      <div style={{
        aspectRatio: compact ? "1/1" : "16/9",
        background: card.bg || "linear-gradient(135deg,#FFE7C7,#FF8A5B)",
        display: "grid", placeItems: "center", color: "white",
        fontWeight: 600, fontSize: compact ? 11 : 13,
        textShadow: "0 1px 2px rgba(0,0,0,0.2)"
      }}>{card.title}</div>
      <div style={{ padding: compact ? "8px 10px" : "10px 12px" }}>
        <div style={{ fontWeight: 700, fontSize: compact ? 11.5 : 12.5 }}>{card.title}</div>
        <div style={{ color: "#666", fontSize: compact ? 10.5 : 11.5, marginTop: 2 }}>{card.desc}</div>
      </div>
      {card.actions && (
        <div style={{ borderTop: "1px solid #EDEEF1" }}>
          {card.actions.map((a, i) => (
            <button key={i} style={{
              width: "100%", background: "white", border: 0,
              borderTop: i > 0 ? "1px solid #EDEEF1" : 0,
              padding: "7px 10px", fontSize: compact ? 11 : 12,
              color: "#1F73E8", fontWeight: 500
            }}>{a}</button>
          ))}
        </div>
      )}
    </div>
  );
}



// ───── src/raw/screens/campaigns.jsx ─────
function CampaignsScreen({ go }) {
  const [filter, setFilter] = useStateCmp("all");
  const counts = {
    all: DATA.campaigns.length,
    live: DATA.campaigns.filter(c => c.status === "live").length,
    scheduled: DATA.campaigns.filter(c => c.status === "scheduled").length,
    completed: DATA.campaigns.filter(c => c.status === "completed").length,
    draft: DATA.campaigns.filter(c => c.status === "draft").length,
  };
  const rows = DATA.campaigns.filter(c => filter === "all" ? true : c.status === filter);

  return (
    <div className="content">
      <div className="page-head">
        <div className="title-block">
          <h1>Campaigns 行銷活動</h1>
          <p className="desc">建立、排程、追蹤 RCS 行銷與交易訊息</p>
        </div>
        <div className="actions">
          <button className="btn"><Icons.Download size={14}/> 匯出 CSV</button>
          <button className="btn primary" onClick={() => go("campaign_new")}><Icons.Plus size={14}/> 建立活動</button>
        </div>
      </div>

      <div className="row" style={{ alignItems: "center", marginBottom: 12, gap: 12 }}>
        <div className="tabs flex-1">
          {[
            { id: "all", l: "全部", c: counts.all },
            { id: "live", l: "Live", c: counts.live },
            { id: "scheduled", l: "已排程", c: counts.scheduled },
            { id: "completed", l: "已完成", c: counts.completed },
            { id: "draft", l: "草稿", c: counts.draft },
          ].map(t => (
            <div key={t.id} className={`tab ${filter === t.id ? "active" : ""}`} onClick={() => setFilter(t.id)}>
              {t.l}<span className="count">{t.c}</span>
            </div>
          ))}
        </div>
        <div className="searchbox" style={{ minWidth: 200 }}>
          <Icons.Search size={13}/>
          <input placeholder="搜尋活動名稱..."/>
        </div>
        <button className="btn"><Icons.Filter size={14}/> 篩選</button>
      </div>

      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th style={{ width: 24 }}><input type="checkbox" /></th>
              <th>活動 / Agent</th>
              <th>類型</th>
              <th>狀態</th>
              <th>受眾</th>
              <th className="right">已傳送</th>
              <th className="right">送達率</th>
              <th className="right">CTR</th>
              <th className="right">營收</th>
              <th>排程</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map(c => (
              <tr key={c.id}>
                <td><input type="checkbox" /></td>
                <td>
                  <div className="col gap-4">
                    <strong style={{ fontSize: 12.5 }}>{c.name}</strong>
                    <span className="muted mono-sm">{c.id} · {c.agent}</span>
                  </div>
                </td>
                <td>
                  <span className="badge outline">{c.type}</span>
                </td>
                <td><StatusBadge status={c.status} /></td>
                <td><span className="mono-sm">{c.audience}</span></td>
                <td className="right mono">{c.sent ? c.sent.toLocaleString() : "—"}</td>
                <td className="right mono">
                  {c.sent ? (
                    <span style={{ color: "var(--success)" }}>{(c.delivered / c.sent * 100).toFixed(1)}%</span>
                  ) : "—"}
                </td>
                <td className="right mono">{c.ctr ? `${c.ctr}%` : "—"}</td>
                <td className="right mono" style={{ color: c.revenue ? "var(--success)" : "var(--text-3)" }}>
                  {c.revenue ? `$${(c.revenue/1000).toFixed(1)}k` : "—"}
                </td>
                <td><span className="muted mono-sm">{c.schedule}</span></td>
                <td className="right">
                  <div className="row gap-4" style={{ justifyContent: "flex-end" }}>
                    {c.status === "draft" ? (
                      <button className="btn sm" onClick={() => go("campaign_new")}><Icons.Edit size={11}/> 編輯</button>
                    ) : (
                      <button className="btn sm" onClick={() => go("campaign_new")}><Icons.Eye size={11}/> 查看</button>
                    )}
                    <button className="icon-btn"><Icons.More size={14}/></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="row" style={{ padding: "10px 14px", borderTop: "1px solid var(--border)", alignItems: "center", color: "var(--text-3)", fontSize: 11.5 }}>
          <span>顯示 1–{rows.length} 筆,共 {rows.length} 筆</span>
          <div className="spacer"></div>
          <div className="row gap-4">
            <button className="btn sm"><Icons.ChevLeft size={12}/></button>
            <button className="btn sm">1</button>
            <button className="btn sm"><Icons.ChevRight size={12}/></button>
          </div>
        </div>
      </div>
    </div>
  );
}



// ───── src/raw/screens/campaign_builder.jsx ─────
// ────────────────────────────────────────────────────────────────────
// Comprehensive Campaign Builder — full Twilio RCS spec
// ref: https://www.twilio.com/docs/rcs
// ────────────────────────────────────────────────────────────────────

const CTA_ACTION_TYPES = [
  { id: "url",      l: "開啟連結 (URL Action)",        icon: "Link",    hint: "https://..." },
  { id: "phone",    l: "撥打電話 (Dial Action)",       icon: "Phone",   hint: "+886-2-..." },
  { id: "map",      l: "顯示地點 (View Location)",     icon: "Globe",   hint: "lat,long 或地址" },
  { id: "calendar", l: "建立行事曆事件",                icon: "Calendar",hint: "ISO 8601" },
  { id: "compose",  l: "撰寫訊息 (Compose Action)",    icon: "Edit",    hint: "預填內文" },
  { id: "share",    l: "分享位置 (Share Location)",    icon: "Pin",     hint: "請求用戶 GPS" },
  { id: "postback", l: "Postback (Webhook 回傳)",      icon: "Webhook", hint: "data=cta_buy_btn" },
];

const SUGGESTED_REPLY_TYPES = [
  { id: "reply",   l: "純文字回覆",   icon: "Edit"    },
  { id: "url",     l: "開啟連結",     icon: "Link"    },
  { id: "phone",   l: "撥打電話",     icon: "Phone"   },
  { id: "map",     l: "顯示地點",     icon: "Globe"   },
];

const CONTENT_TYPES = [
  { id: "text",     l: "純文字",        sub: "≤ 3,072 字元", icon: "Edit" },
  { id: "media",    l: "媒體",          sub: "圖片/影片/GIF", icon: "Image" },
  { id: "card",     l: "Rich Card",     sub: "媒體 + 標題 + 按鈕", icon: "Card" },
  { id: "carousel", l: "Rich Card Carousel", sub: "2-10 張卡片", icon: "Layers" },
  { id: "location", l: "Location Card", sub: "地圖卡片", icon: "Pin" },
  { id: "file",     l: "檔案",          sub: "PDF / 文件", icon: "Folder" },
];

// content templates (matches Twilio Content Template Builder concept)
const CONTENT_TEMPLATES = [
  { sid: "HX2a04b821e8c4d2ef", name: "出貨通知 Rich Card", type: "card",     vars: ["first_name","order_id","delivery_date","tracking_url"], approved: true },
  { sid: "HX7b91c8d4a92ec103", name: "夏季 Carousel",      type: "carousel", vars: ["first_name"], approved: true },
  { sid: "HX4d8e92ab14df81e2", name: "OTP 驗證碼",          type: "text",     vars: ["code","ttl"], approved: true },
  { sid: "HX9c1efb2a5d34019a", name: "棄購挽回",            type: "card",     vars: ["first_name","cart_total","return_url"], approved: true },
  { sid: "HX6a7c3920e88f1b27", name: "618 大圖卡片",        type: "card",     vars: ["first_name"], approved: false },
];

function CampaignBuilderScreen({ go }) {
  // top-level state
  const [name, setName] = useStateCB("夏季新品 Carousel");
  const [agent, setAgent] = useStateCB("agt_shopmart_official");
  const [audience, setAudience] = useStateCB("seg_3");
  const [aupCategory, setAupCategory] = useStateCB("promotional");
  const [contentType, setContentType] = useStateCB("carousel");
  const [device, setDevice] = useStateCB("iPhone");
  const [previewVariant, setPreviewVariant] = useStateCB("rcs"); // rcs | mms | sms

  // content state
  const [templateMode, setTemplateMode] = useStateCB("template"); // template | freeform
  const [templateSid, setTemplateSid] = useStateCB("HX7b91c8d4a92ec103");
  const [introText, setIntroText] = useStateCB("嗨 {{first_name}}～夏天到了 ☀️ 給您挑了幾款清涼好物");

  // carousel cards
  const [cards, setCards] = useStateCB([
    { title: "亞麻寬版襯衫", desc: "輕盈透氣 · NT$ 1,490", bg: "linear-gradient(135deg,#FFE7C7,#FF8A5B)", cta: [{ type: "url", l: "立即購買" }, { type: "reply", l: "尺寸表" }] },
    { title: "棉麻寬褲",     desc: "舒適耐穿 · NT$ 1,290", bg: "linear-gradient(135deg,#D7E8FF,#7C5CFF)", cta: [{ type: "url", l: "立即購買" }] },
    { title: "編織涼鞋",     desc: "夏日必備 · NT$ 980",   bg: "linear-gradient(135deg,#E5F7EE,#22C55E)", cta: [{ type: "url", l: "立即購買" }] },
  ]);

  // suggested replies
  const [suggested, setSuggested] = useStateCB([
    { type: "reply", l: "查看全部新品", icon: "🛍" },
    { type: "reply", l: "尺寸對照表", icon: "📏" },
    { type: "phone", l: "聯絡客服",   icon: "📞" },
    { type: "url",   l: "瀏覽官網",   icon: "🌐" },
  ]);

  // fallback cascade
  const [fallbackOn, setFallbackOn] = useStateCB(true);
  const [mmsFallbackOn, setMmsFallbackOn] = useStateCB(true);
  const [smsBody, setSmsBody] = useStateCB("ShopMart: 嗨 {{first_name}}！夏季新品全館 8 折,立即逛 https://shp.mt/sm618");

  // delivery options
  const [statusCallback, setStatusCallback] = useStateCB("https://crm.shopmart.io/webhooks/twilio/dlr");
  const [validityMins, setValidityMins] = useStateCB(1440);
  const [readReceipts, setReadReceipts] = useStateCB(true);
  const [smartEncoding, setSmartEncoding] = useStateCB(true);

  // schedule
  const [schedule, setSchedule] = useStateCB("scheduled");
  const [scheduleDate, setScheduleDate] = useStateCB("2026-05-22");
  const [scheduleTime, setScheduleTime] = useStateCB("19:00");
  const [tzAware, setTzAware] = useStateCB(true);
  const [quietHours, setQuietHours] = useStateCB(true);
  const [rateLimit, setRateLimit] = useStateCB(5000);

  // testing
  const [testNumber, setTestNumber] = useStateCB("+886 912 345 678");

  // accordion expanded state
  const [openSections, setOpenSections] = useStateCB({
    setup: true, audience: true, content: true, fallback: true,
    variables: false, schedule: true, advanced: false, compliance: false, test: false
  });
  const toggle = (k) => setOpenSections(s => ({ ...s, [k]: !s[k] }));

  // sample contact for personalization preview
  const sampleContact = { first_name: "怡君", order_id: "SM2026-1042", delivery_date: "5/21 (Sat)", tracking_url: "https://shp.mt/t/abc", cart_total: "$2,980", code: "428192", ttl: "5", return_url: "https://shp.mt/c/x9j" };
  const interpolate = (s) => s.replace(/\{\{(\w+)\}\}/g, (_, k) => sampleContact[k] || `{{${k}}}`);

  // build phone preview bubbles
  const phoneBubbles = useMemoCB(() => {
    if (previewVariant === "sms") {
      return [{ kind: "text", from: "out", text: interpolate(smsBody) }];
    }
    if (previewVariant === "mms") {
      return [
        { kind: "media", from: "out", media: { kind: "image", label: "ShopMart 夏季", bg: "linear-gradient(135deg,#FFE7C7,#FF8A5B)" } },
        { kind: "text", from: "out", text: interpolate(smsBody) }
      ];
    }
    // RCS
    const out = [{ kind: "text", from: "out", text: interpolate(introText) }];
    if (contentType === "carousel") {
      out.push({ kind: "carousel", from: "out", cards: cards.map(c => ({
        title: c.title, desc: c.desc, bg: c.bg, actions: c.cta.map(a => a.l)
      })) });
    } else if (contentType === "card") {
      const c = cards[0];
      out.push({ kind: "card", from: "out", card: {
        title: c.title, desc: c.desc, media: c.title, bg: c.bg, actions: c.cta.map(a => a.l)
      } });
    } else if (contentType === "media") {
      out.push({ kind: "media", from: "out", media: { kind: "image", label: cards[0].title, bg: cards[0].bg, caption: cards[0].desc } });
    } else if (contentType === "location") {
      out.push({ kind: "location", from: "out", location: { title: "ShopMart 信義旗艦店", addr: "台北市信義區市府路 45 號" } });
    } else if (contentType === "file") {
      out.push({ kind: "file", from: "out", file: { name: `${sampleContact.first_name}_618_DM.pdf`, size: "284 KB" } });
    }
    return out;
  }, [previewVariant, contentType, cards, introText, smsBody]);

  const audienceData = DATA.segments.find(s => s.id === audience);
  const agentData = DATA.agents.find(a => a.id === agent);

  return (
    <div className="full-page-builder">
      <div className="builder-main">
        <BuilderHeader name={name} setName={setName} go={go} />
        <BuilderTopMetrics audienceData={audienceData} />

        <Section open={openSections.setup} onToggle={() => toggle("setup")}
                 num={1} title="基本設定" sub="活動名稱、Sender Profile、AUP 分類">
          <SetupSection
            name={name} setName={setName}
            agent={agent} setAgent={setAgent} agentData={agentData}
            aupCategory={aupCategory} setAupCategory={setAupCategory}
          />
        </Section>

        <Section open={openSections.audience} onToggle={() => toggle("audience")}
                 num={2} title="受眾選擇" sub="Segment + RCS 可達性檢查"
                 status={`${audienceData.size.toLocaleString()} 受眾`}>
          <AudienceSection audience={audience} setAudience={setAudience} />
        </Section>

        <Section open={openSections.content} onToggle={() => toggle("content")}
                 num={3} title="訊息內容" sub="Content Template + Rich Content"
                 status={CONTENT_TYPES.find(c => c.id === contentType)?.l}>
          <ContentSection
            contentType={contentType} setContentType={setContentType}
            templateMode={templateMode} setTemplateMode={setTemplateMode}
            templateSid={templateSid} setTemplateSid={setTemplateSid}
            introText={introText} setIntroText={setIntroText}
            cards={cards} setCards={setCards}
            suggested={suggested} setSuggested={setSuggested}
          />
        </Section>

        <Section open={openSections.fallback} onToggle={() => toggle("fallback")}
                 num={4} title="Fallback 階層" sub="RCS → MMS → SMS 自動降級"
                 status={fallbackOn ? <span className="badge success">已啟用</span> : <span className="badge outline">關閉</span>}>
          <FallbackSection
            fallbackOn={fallbackOn} setFallbackOn={setFallbackOn}
            mmsFallbackOn={mmsFallbackOn} setMmsFallbackOn={setMmsFallbackOn}
            smsBody={smsBody} setSmsBody={setSmsBody}
            previewVariant={previewVariant} setPreviewVariant={setPreviewVariant}
          />
        </Section>

        <Section open={openSections.variables} onToggle={() => toggle("variables")}
                 num={5} title="個人化變數" sub="Content Variables 映射與預覽">
          <VariablesSection sampleContact={sampleContact} interpolate={interpolate} />
        </Section>

        <Section open={openSections.schedule} onToggle={() => toggle("schedule")}
                 num={6} title="排程與節流" sub="時區感知 + Rate Limit"
                 status={schedule === "now" ? "立即傳送" : `${scheduleDate} ${scheduleTime}`}>
          <ScheduleSection
            schedule={schedule} setSchedule={setSchedule}
            scheduleDate={scheduleDate} setScheduleDate={setScheduleDate}
            scheduleTime={scheduleTime} setScheduleTime={setScheduleTime}
            rateLimit={rateLimit} setRateLimit={setRateLimit}
            tzAware={tzAware} setTzAware={setTzAware}
            quietHours={quietHours} setQuietHours={setQuietHours}
          />
        </Section>

        <Section open={openSections.advanced} onToggle={() => toggle("advanced")}
                 num={7} title="進階傳送選項" sub="Status Callback、Validity、編碼">
          <AdvancedSection
            statusCallback={statusCallback} setStatusCallback={setStatusCallback}
            validityMins={validityMins} setValidityMins={setValidityMins}
            readReceipts={readReceipts} setReadReceipts={setReadReceipts}
            smartEncoding={smartEncoding} setSmartEncoding={setSmartEncoding}
          />
        </Section>

        <Section open={openSections.compliance} onToggle={() => toggle("compliance")}
                 num={8} title="合規檢查" sub="Opt-in、AUP、品牌驗證"
                 status={<span className="badge success"><span className="dot"></span>全部通過</span>}>
          <ComplianceSection aupCategory={aupCategory} />
        </Section>

        <Section open={openSections.test} onToggle={() => toggle("test")}
                 num={9} title="測試傳送" sub="送至 ≤3 個測試手機">
          <TestSection
            testNumber={testNumber} setTestNumber={setTestNumber}
            agentData={agentData}
          />
        </Section>

        {/* Review summary */}
        <ReviewSummary
          audienceData={audienceData} agentData={agentData}
          fallbackOn={fallbackOn} mmsFallbackOn={mmsFallbackOn}
          scheduleDate={scheduleDate} scheduleTime={scheduleTime}
          templateSid={templateSid} contentType={contentType}
        />
      </div>

      {/* RIGHT PHONE PREVIEW */}
      <div className="builder-side">
        <PhonePreviewPane
          device={device} setDevice={setDevice}
          previewVariant={previewVariant} setPreviewVariant={setPreviewVariant}
          agent={agentData} bubbles={phoneBubbles} suggested={suggested}
          fallbackOn={fallbackOn}
        />
      </div>
    </div>
  );
}

// ── Header ──────────────────────────────────────────────────────────
function BuilderHeader({ name, setName, go }) {
  return (
    <div className="page-head">
      <div className="title-block">
        <div className="row gap-8" style={{ alignItems: "center", marginBottom: 6 }}>
          <a onClick={() => go("campaigns")} className="muted mono-sm" style={{ cursor: "pointer" }}>← Campaigns</a>
          <span className="muted">/</span>
          <span className="mono-sm">新活動</span>
          <span className="badge outline" style={{ marginLeft: 6 }}>草稿 · 自動儲存中</span>
        </div>
        <input value={name} onChange={(e) => setName(e.target.value)}
               style={{ background: "transparent", border: 0, outline: 0, fontFamily: "var(--font-sans)", fontSize: 20, fontWeight: 600, color: "var(--text)", width: "100%", letterSpacing: "-0.02em" }} />
      </div>
      <div className="actions">
        <button className="btn ghost">儲存草稿</button>
        <button className="btn"><Icons.Send size={13}/> 測試傳送</button>
        <button className="btn"><Icons.Eye size={13}/> 完整預覽</button>
        <button className="btn primary"><Icons.Bolt size={13}/> 排程 / 立即傳送</button>
      </div>
    </div>
  );
}

// ── Top metrics row ────────────────────────────────────────────────
function BuilderTopMetrics({ audienceData }) {
  const total = audienceData.size;
  const rcsRate = 87.4;
  const rcsReach = Math.round(total * rcsRate / 100);
  const mmsReach = Math.round(total * 0.08);
  const smsReach = total - rcsReach - mmsReach;
  const cost = (rcsReach * 0.0042 + mmsReach * 0.008 + smsReach * 0.0035).toFixed(0);

  return (
    <div className="card" style={{ padding: 0, marginBottom: 14, overflow: "hidden" }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)" }}>
        {[
          { l: "預估觸及", v: total.toLocaleString(), s: `Segment: ${audienceData.name.slice(0,8)}…`, c: "var(--primary)" },
          { l: "RCS 可達",  v: `${rcsRate}%`,            s: `${rcsReach.toLocaleString()} 用戶 · 透過 RBM`, c: "var(--success)" },
          { l: "MMS Fallback", v: "7.8%",                s: `${mmsReach.toLocaleString()} 用戶 · 圖片+文字`, c: "var(--info)" },
          { l: "SMS Fallback", v: "4.8%",                s: `${smsReach.toLocaleString()} 用戶 · 純文字`, c: "var(--warning)" },
          { l: "預估成本", v: `$${Number(cost).toLocaleString()}`, s: "USD · ±12% 誤差",            c: "var(--accent)" },
        ].map((m, i) => (
          <div key={i} style={{ padding: 12, borderRight: i < 4 ? "1px solid var(--border-soft)" : 0 }}>
            <div className="muted mono-sm" style={{ fontSize: 10 }}>{m.l.toUpperCase()}</div>
            <div style={{ fontSize: 20, fontWeight: 600, fontFamily: "var(--font-sans)", color: m.c, lineHeight: 1.1, margin: "4px 0 4px" }}>{m.v}</div>
            <div className="muted mono-sm" style={{ fontSize: 10 }}>{m.s}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Accordion section ──────────────────────────────────────────────
function Section({ num, title, sub, status, open, onToggle, children }) {
  return (
    <div className="card" style={{ marginBottom: 12 }}>
      <div className="card-head" onClick={onToggle} style={{ cursor: "pointer", userSelect: "none" }}>
        <div style={{ width: 22, height: 22, borderRadius: 6, background: open ? "var(--primary-soft)" : "var(--surface-2)", display: "grid", placeItems: "center", color: open ? "var(--primary)" : "var(--text-2)", fontFamily: "var(--font-mono)", fontWeight: 700, fontSize: 11 }}>{num}</div>
        <h3>{title}</h3>
        <span className="sub">{sub}</span>
        <div className="spacer"></div>
        {status && (typeof status === "string" ? <span className="badge outline mono-sm">{status}</span> : status)}
        <button className="icon-btn" style={{ width: 22, height: 22 }}>
          {open ? <Icons.ChevDown size={13}/> : <Icons.ChevRight size={13}/>}
        </button>
      </div>
      {open && <div className="card-body">{children}</div>}
    </div>
  );
}

// ── Section: Setup ─────────────────────────────────────────────────
function SetupSection({ name, setName, agent, setAgent, agentData, aupCategory, setAupCategory }) {
  return (
    <div>
      <div className="grid-2" style={{ gap: 14, marginBottom: 14 }}>
        <div className="field">
          <label>活動名稱 <span className="req">*</span></label>
          <input className="input" value={name} onChange={(e) => setName(e.target.value)} />
          <div className="hint">僅內部可見 · 不會顯示給收件人</div>
        </div>
        <div className="field">
          <label>內部標籤</label>
          <div className="pill-input">
            <span className="pill">夏季 <Icons.X size={10}/></span>
            <span className="pill">618 <Icons.X size={10}/></span>
            <span className="pill">VIP <Icons.X size={10}/></span>
            <input placeholder="+ 新增 tag"/>
          </div>
        </div>
      </div>

      <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500, marginBottom: 6, display: "block" }}>
        傳送者 (RCS Agent / Messaging Service) <span className="req">*</span>
      </label>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 10, marginBottom: 14 }}>
        {DATA.agents.map(a => (
          <div key={a.id} className={`option-card ${agent === a.id ? "selected" : ""}`}
               onClick={() => a.status === "live" && setAgent(a.id)}
               style={{ opacity: a.status === "live" ? 1 : 0.5, cursor: a.status === "live" ? "pointer" : "not-allowed" }}>
            <div className="row gap-10" style={{ alignItems: "flex-start" }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: `linear-gradient(135deg, ${a.color}, ${a.color}aa)`, display: "grid", placeItems: "center", color: "white", fontWeight: 700, fontSize: 15, position: "relative", flex: "0 0 auto" }}>
                {a.name.slice(0,1)}
                {a.verified && (
                  <span style={{ position: "absolute", right: -2, bottom: -2, width: 14, height: 14, borderRadius: "50%", background: "#1F73E8", color: "white", display: "grid", placeItems: "center", border: "2px solid var(--surface)" }}>
                    <svg width="7" height="7" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                  </span>
                )}
              </div>
              <div className="col flex-1 gap-4" style={{ minWidth: 0 }}>
                <div className="row gap-6" style={{ alignItems: "center" }}>
                  <strong style={{ fontSize: 13 }}>{a.name}</strong>
                  <StatusBadge status={a.status === "in_review" ? "in_review" : "live"} />
                </div>
                <span className="muted mono-sm" style={{ fontSize: 10 }}>{a.id}</span>
                <div className="row gap-4">
                  {a.regions.map(r => <span key={r} className="badge primary" style={{ fontSize: 9 }}>{r}</span>)}
                  <span className="badge outline" style={{ fontSize: 9 }}>{(a.mau/1000).toFixed(0)}k MAU</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="grid-2" style={{ gap: 14 }}>
        <div className="field">
          <label>AUP 內容分類 <span className="req">*</span></label>
          <select className="input" value={aupCategory} onChange={(e) => setAupCategory(e.target.value)}>
            <option value="promotional">Promotional 行銷推廣</option>
            <option value="transactional">Transactional 交易通知</option>
            <option value="otp">OTP / Authentication</option>
            <option value="conversational">Conversational 客服對話</option>
            <option value="alert">Alert 系統警示</option>
          </select>
          <div className="hint">依 Google RBM AUP 規範分類,影響審核流程與費率</div>
        </div>
        <div className="field">
          <label>歸因目標 / 轉換事件</label>
          <select className="input" defaultValue="purchase">
            <option value="purchase">Purchase (歸因營收)</option>
            <option>Click-through (連結點擊)</option>
            <option>Engagement (互動)</option>
            <option>Lead Capture (留資)</option>
            <option>App Install</option>
          </select>
          <div className="hint">歸因視窗: 7 天點擊 / 1 天瀏覽</div>
        </div>
      </div>

      <div className="row gap-8" style={{ marginTop: 14, padding: 10, background: "var(--surface-2)", borderRadius: 8, fontSize: 12 }}>
        <Icons.Sparkles size={14} style={{ color: "var(--primary)", marginRight: 4 }} />
        <span className="flex-1">
          目前 Agent <strong>{agentData.name}</strong> 已通過 <strong style={{ color: "var(--success)" }}>{agentData.regions.join(", ")}</strong> 區域 Carrier 驗證,
          可使用全部 Rich Content 功能。
        </span>
      </div>
    </div>
  );
}

// ── Section: Audience ──────────────────────────────────────────────
function AudienceSection({ audience, setAudience }) {
  return (
    <div>
      <div className="row gap-8" style={{ marginBottom: 12 }}>
        <div className="searchbox flex-1">
          <Icons.Search size={13}/>
          <input placeholder="搜尋 Segment 或建立動態查詢..."/>
        </div>
        <button className="btn"><Icons.Plus size={12}/> 建立 Segment</button>
        <button className="btn"><Icons.Upload size={12}/> 上傳 CSV</button>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 10, marginBottom: 12 }}>
        {DATA.segments.map(s => (
          <div key={s.id} className={`option-card ${audience === s.id ? "selected" : ""}`} onClick={() => setAudience(s.id)}>
            <div className="row" style={{ alignItems: "flex-start" }}>
              <div className="flex-1">
                <h4>{s.name}</h4>
                <p>{s.size.toLocaleString()} 受眾 · {s.source} · 同步 {s.lastSync}</p>
              </div>
              <span className="badge primary mono-sm">{s.size > 999 ? `${(s.size/1000).toFixed(1)}k` : s.size}</span>
            </div>
            <div className="row gap-4" style={{ marginTop: 8, fontSize: 10, color: "var(--text-3)" }}>
              <span className="badge outline" style={{ fontSize: 9 }}>RCS 87%</span>
              <span className="badge outline" style={{ fontSize: 9 }}>opt-in 100%</span>
              <span className="badge outline" style={{ fontSize: 9 }}>{s.growth}</span>
            </div>
          </div>
        ))}
      </div>
      <div style={{ padding: 12, background: "var(--surface-2)", borderRadius: 8, fontSize: 12, display: "flex", gap: 14, alignItems: "center" }}>
        <Icons.Filter size={14} style={{ color: "var(--text-2)" }} />
        <div className="flex-1">
          <strong>排除規則</strong>: 已在 7 天內收過此活動 · 不在台北/桃園地區 · LTV &lt; $100
        </div>
        <button className="btn sm">編輯</button>
      </div>
    </div>
  );
}

// ── Section: Content (the big one) ─────────────────────────────────
function ContentSection({ contentType, setContentType, templateMode, setTemplateMode,
                          templateSid, setTemplateSid, introText, setIntroText,
                          cards, setCards, suggested, setSuggested }) {
  return (
    <div>
      {/* Template vs Freeform */}
      <div className="row gap-8" style={{ marginBottom: 12, alignItems: "center" }}>
        <div className="seg">
          <button className={templateMode === "template" ? "active" : ""} onClick={() => setTemplateMode("template")}>
            <Icons.Card size={11}/> 使用 Content Template
          </button>
          <button className={templateMode === "freeform" ? "active" : ""} onClick={() => setTemplateMode("freeform")}>
            <Icons.Edit size={11}/> 自由輸入 (Conversational only)
          </button>
        </div>
        <div className="spacer"></div>
        <span className="muted mono-sm">Conversational session 內可發送 freeform · 否則需通過審核 Template</span>
      </div>

      {templateMode === "template" && (
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500, marginBottom: 6, display: "block" }}>
            選擇 Content Template <span className="req">*</span>
          </label>
          <div style={{ border: "1px solid var(--border-strong)", borderRadius: 8, overflow: "hidden" }}>
            {CONTENT_TEMPLATES.map((t, i) => (
              <div key={t.sid}
                   onClick={() => t.approved && setTemplateSid(t.sid)}
                   style={{
                     display: "grid", gridTemplateColumns: "auto 1fr auto auto",
                     gap: 12, padding: "10px 14px",
                     borderBottom: i < CONTENT_TEMPLATES.length - 1 ? "1px solid var(--border-soft)" : 0,
                     background: templateSid === t.sid ? "var(--primary-soft)" : "transparent",
                     cursor: t.approved ? "pointer" : "not-allowed",
                     opacity: t.approved ? 1 : 0.55,
                     alignItems: "center"
                   }}>
                <div style={{ width: 18, height: 18, borderRadius: "50%", border: `2px solid ${templateSid === t.sid ? "var(--primary)" : "var(--border-strong)"}`, display: "grid", placeItems: "center" }}>
                  {templateSid === t.sid && <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--primary)" }}></div>}
                </div>
                <div>
                  <div className="row gap-6" style={{ alignItems: "center" }}>
                    <strong style={{ fontSize: 12.5 }}>{t.name}</strong>
                    <span className="badge outline" style={{ fontSize: 9 }}>{t.type}</span>
                  </div>
                  <div className="row gap-4" style={{ marginTop: 4, alignItems: "center" }}>
                    <code className="mono-sm" style={{ fontSize: 10, color: "var(--text-3)" }}>{t.sid}</code>
                    {t.vars.length > 0 && (
                      <span className="muted mono-sm" style={{ fontSize: 10 }}>
                        · vars: {t.vars.map(v => `{{${v}}}`).join(", ")}
                      </span>
                    )}
                  </div>
                </div>
                {t.approved ? <StatusBadge status="approved"/> : <StatusBadge status="pending"/>}
                <button className="btn sm ghost"><Icons.Eye size={11}/></button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Content type selector */}
      <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500, marginBottom: 6, display: "block" }}>
        RCS Content Type
      </label>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 8, marginBottom: 14 }}>
        {CONTENT_TYPES.map(c => {
          const Ico = Icons[c.icon];
          return (
            <div key={c.id} className={`option-card ${contentType === c.id ? "selected" : ""}`}
                 onClick={() => setContentType(c.id)}
                 style={{ padding: "10px 10px", textAlign: "center" }}>
              <Ico size={16} style={{ color: contentType === c.id ? "var(--primary)" : "var(--text-2)", marginBottom: 6 }}/>
              <h4 style={{ fontSize: 11.5 }}>{c.l}</h4>
              <p style={{ fontSize: 10, marginTop: 2 }}>{c.sub}</p>
            </div>
          );
        })}
      </div>

      {/* Intro text */}
      <div className="field" style={{ marginBottom: 14 }}>
        <label>引導文字 (顯示在 Rich Content 之前)</label>
        <textarea className="input" rows={2} value={introText} onChange={(e) => setIntroText(e.target.value)} />
        <div className="hint">
          <span className="row gap-12" style={{ display: "inline-flex" }}>
            <span>{introText.length} / 3,072 字元</span>
            <span className="mono-sm">·</span>
            <span>支援變數 · <a style={{ color: "var(--primary)" }}>插入 {`{{first_name}}`}</a></span>
            <span className="mono-sm">·</span>
            <span>UTF-8 編碼 (不會分段)</span>
          </span>
        </div>
      </div>

      {/* Per-content-type editor */}
      {(contentType === "card" || contentType === "carousel") && (
        <CardEditor cards={cards} setCards={setCards} mode={contentType} />
      )}
      {contentType === "media" && <MediaEditor cards={cards} setCards={setCards} />}
      {contentType === "location" && <LocationEditor />}
      {contentType === "file" && <FileEditor />}
      {contentType === "text" && (
        <div style={{ padding: 16, background: "var(--surface-2)", borderRadius: 8, fontSize: 12, color: "var(--text-2)" }}>
          純文字內容已在上方「引導文字」設定 · RCS 可一次傳送 3,072 字元(SMS Fallback 會自動分段)
        </div>
      )}

      {/* Suggested replies (universal) */}
      <SuggestedRepliesEditor suggested={suggested} setSuggested={setSuggested} />
    </div>
  );
}

// ── Card / Carousel editor ─────────────────────────────────────────
function CardEditor({ cards, setCards, mode }) {
  const isCarousel = mode === "carousel";
  return (
    <div style={{ marginBottom: 14 }}>
      <div className="row" style={{ alignItems: "baseline", marginBottom: 10 }}>
        <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500 }}>
          {isCarousel ? `Carousel 卡片 (${cards.length} / 10)` : "Rich Card"}
        </label>
        <div className="spacer"></div>
        {isCarousel && (
          <button className="btn sm" onClick={() => setCards([...cards, { title: "新卡片", desc: "卡片描述", bg: "linear-gradient(135deg,#FFE7C7,#FF8A5B)", cta: [{ type: "url", l: "立即查看" }] }])}>
            <Icons.Plus size={11}/> 新增卡片
          </button>
        )}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {(isCarousel ? cards : cards.slice(0, 1)).map((c, i) => (
          <CardRow key={i} index={i} card={c}
                   canDelete={isCarousel && cards.length > 2}
                   onChange={(patch) => setCards(cards.map((cc, j) => j === i ? { ...cc, ...patch } : cc))}
                   onDelete={() => setCards(cards.filter((_, j) => j !== i))} />
        ))}
      </div>
      <div className="row gap-12" style={{ marginTop: 12, padding: "10px 12px", background: "var(--surface-2)", borderRadius: 8, fontSize: 11, color: "var(--text-2)" }}>
        <span><strong>{isCarousel ? "Carousel" : "Card"}</strong> 規格</span>
        <span>·</span>
        <span>媒體比例 16:9 / 7:3 / 4:3 (建議 1440×810)</span>
        <span>·</span>
        <span>最多 4 個 CTA 按鈕 / 11 個 quick replies</span>
        <span>·</span>
        <span>單筆 ≤ 250KB (text + media descriptor)</span>
      </div>
    </div>
  );
}

function CardRow({ index, card, onChange, onDelete, canDelete }) {
  const [open, setOpen] = useStateCB(index === 0);
  return (
    <div style={{ border: "1px solid var(--border)", borderRadius: 8, background: "var(--surface-2)", overflow: "hidden" }}>
      <div onClick={() => setOpen(!open)} style={{ display: "grid", gridTemplateColumns: "auto 60px 1fr auto", gap: 12, padding: 10, alignItems: "center", cursor: "pointer" }}>
        <Icons.More size={14} style={{ color: "var(--text-3)", cursor: "grab", transform: "rotate(90deg)" }}/>
        <div style={{ width: 60, height: 36, borderRadius: 4, background: card.bg }}></div>
        <div className="col gap-4">
          <strong style={{ fontSize: 12.5 }}>{card.title || `卡片 ${index + 1}`}</strong>
          <span className="muted mono-sm" style={{ fontSize: 10.5 }}>{card.desc}</span>
        </div>
        <div className="row gap-6">
          <span className="badge outline mono-sm" style={{ fontSize: 9 }}>{card.cta.length} CTA</span>
          {canDelete && <button className="icon-btn" onClick={(e) => { e.stopPropagation(); onDelete(); }} style={{ width: 24, height: 24 }}><Icons.Trash size={12}/></button>}
          <Icons.ChevDown size={13} style={{ color: "var(--text-3)", transform: open ? "rotate(180deg)" : "none" }}/>
        </div>
      </div>
      {open && (
        <div style={{ padding: "0 14px 14px", borderTop: "1px solid var(--border-soft)" }}>
          <div className="grid-2" style={{ gap: 10, marginTop: 12 }}>
            <div className="field">
              <label>標題 <span className="req">*</span></label>
              <input className="input" value={card.title} onChange={(e) => onChange({ title: e.target.value })} maxLength={80}/>
              <div className="hint">{card.title.length} / 80</div>
            </div>
            <div className="field">
              <label>背景 / 媒體</label>
              <div className="row gap-4">
                {["linear-gradient(135deg,#FFE7C7,#FF8A5B)","linear-gradient(135deg,#D7E8FF,#7C5CFF)","linear-gradient(135deg,#E5F7EE,#22C55E)","linear-gradient(135deg,#FFD6E8,#F25C5C)","linear-gradient(135deg,#E8E3FF,#7C5CFF)"].map(g => (
                  <div key={g} onClick={() => onChange({ bg: g })}
                       style={{ width: 28, height: 28, borderRadius: 6, background: g, cursor: "pointer", border: card.bg === g ? "2px solid var(--primary)" : "2px solid transparent" }}></div>
                ))}
                <button className="btn sm"><Icons.Upload size={11}/> 上傳</button>
              </div>
            </div>
            <div className="field" style={{ gridColumn: "span 2" }}>
              <label>描述</label>
              <textarea className="input" rows={2} value={card.desc} onChange={(e) => onChange({ desc: e.target.value })} maxLength={2000}/>
            </div>
            <div className="grid-2" style={{ gridColumn: "span 2", gap: 8 }}>
              <div className="field">
                <label>媒體高度</label>
                <div className="seg" style={{ width: "fit-content" }}>
                  <button className="active">中</button>
                  <button>短</button>
                  <button>高</button>
                </div>
              </div>
              <div className="field">
                <label>卡片方向</label>
                <div className="seg" style={{ width: "fit-content" }}>
                  <button className="active">直式</button>
                  <button>橫式</button>
                </div>
              </div>
            </div>
          </div>

          {/* CTA per card */}
          <div style={{ marginTop: 14 }}>
            <div className="row" style={{ alignItems: "baseline", marginBottom: 6 }}>
              <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500 }}>CTA 按鈕 ({card.cta.length} / 4)</label>
              <div className="spacer"></div>
              {card.cta.length < 4 && (
                <button className="btn sm" onClick={() => onChange({ cta: [...card.cta, { type: "url", l: "新按鈕" }] })}><Icons.Plus size={11}/> 新增</button>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {card.cta.map((b, i) => (
                <CtaRow key={i} cta={b}
                        onChange={(p) => onChange({ cta: card.cta.map((cc, j) => j === i ? { ...cc, ...p } : cc) })}
                        onDelete={() => onChange({ cta: card.cta.filter((_, j) => j !== i) })}/>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function CtaRow({ cta, onChange, onDelete }) {
  const t = CTA_ACTION_TYPES.find(x => x.id === cta.type) || CTA_ACTION_TYPES[0];
  const Ico = Icons[t.icon];
  return (
    <div style={{ display: "grid", gridTemplateColumns: "auto 1fr 1.4fr 1.4fr auto", gap: 6, alignItems: "center", padding: 8, background: "var(--surface)", borderRadius: 6, border: "1px solid var(--border)" }}>
      <Ico size={12} style={{ color: "var(--primary)" }}/>
      <input className="input" value={cta.l} onChange={(e) => onChange({ l: e.target.value })} placeholder="按鈕文字" style={{ padding: "4px 8px", fontSize: 11.5 }}/>
      <select className="input" value={cta.type} onChange={(e) => onChange({ type: e.target.value })} style={{ padding: "4px 8px", fontSize: 11.5 }}>
        {CTA_ACTION_TYPES.map(a => <option key={a.id} value={a.id}>{a.l}</option>)}
      </select>
      <input className="input" defaultValue={t.hint} placeholder={t.hint} style={{ padding: "4px 8px", fontSize: 11.5, fontFamily: "var(--font-mono)" }}/>
      <button className="icon-btn" onClick={onDelete} style={{ width: 22, height: 22 }}><Icons.Trash size={11}/></button>
    </div>
  );
}

// ── Media-only editor ──────────────────────────────────────────────
function MediaEditor({ cards, setCards }) {
  const c = cards[0];
  return (
    <div className="grid-2" style={{ gap: 14, marginBottom: 14 }}>
      <div className="field">
        <label>媒體類型</label>
        <div className="seg" style={{ width: "fit-content" }}>
          <button className="active"><Icons.Image size={11}/> 圖片</button>
          <button><Icons.Play size={11}/> 影片</button>
          <button>GIF</button>
        </div>
        <div className="hint" style={{ marginTop: 6 }}>RCS 支援檔案 ≤ 100 MB / 8 MB MMS fallback</div>
      </div>
      <div className="field">
        <label>標籤 / Alt Text</label>
        <input className="input" defaultValue={c.title}/>
      </div>
      <div className="field" style={{ gridColumn: "span 2" }}>
        <label>媒體上傳</label>
        <div style={{ border: "1.5px dashed var(--border-strong)", borderRadius: 8, padding: 24, textAlign: "center", color: "var(--text-3)" }}>
          <Icons.Upload size={22}/>
          <div style={{ marginTop: 8, fontSize: 12.5, fontWeight: 500, color: "var(--text-2)" }}>拖曳檔案,或從 <a style={{ color: "var(--primary)" }}>媒體庫</a> 選擇</div>
          <div className="mono-sm" style={{ marginTop: 4, fontSize: 10.5 }}>建議 1440×810 px · JPG / PNG / WebP / MP4 / GIF · ≤ 100MB</div>
          <div className="row gap-6" style={{ justifyContent: "center", marginTop: 10 }}>
            <button className="btn sm"><Icons.Sparkles size={11}/> AI 生成</button>
            <button className="btn sm"><Icons.Folder size={11}/> 媒體庫</button>
            <button className="btn sm"><Icons.Link size={11}/> 來自 URL</button>
          </div>
        </div>
      </div>
      <div className="field">
        <label>圖片快取 (Twilio CDN)</label>
        <div className="row gap-8" style={{ alignItems: "center", padding: 8, background: "var(--surface-2)", borderRadius: 6 }}>
          <span className="switch on"></span>
          <span style={{ fontSize: 11.5 }}>啟用 (建議,降低載入延遲)</span>
        </div>
      </div>
      <div className="field">
        <label>圖片描述 (a11y)</label>
        <input className="input" placeholder="供視障輔助讀取的內容描述"/>
      </div>
    </div>
  );
}

function LocationEditor() {
  return (
    <div className="grid-2" style={{ gap: 14, marginBottom: 14 }}>
      <div className="field">
        <label>地點名稱 <span className="req">*</span></label>
        <input className="input" defaultValue="ShopMart 信義旗艦店"/>
      </div>
      <div className="field">
        <label>地址</label>
        <input className="input" defaultValue="台北市信義區市府路 45 號"/>
      </div>
      <div className="field">
        <label>緯度</label>
        <input className="input mono" defaultValue="25.0339"/>
      </div>
      <div className="field">
        <label>經度</label>
        <input className="input mono" defaultValue="121.5644"/>
      </div>
      <div style={{ gridColumn: "span 2", height: 140, borderRadius: 8, background: "linear-gradient(135deg, #1B2030, #232838)", display: "grid", placeItems: "center", color: "var(--text-3)", fontSize: 12, border: "1px solid var(--border)" }}>
        <div style={{ textAlign: "center" }}>
          <Icons.Pin size={28} style={{ color: "var(--primary)" }}/>
          <div style={{ marginTop: 6 }}>地圖預覽 (整合 Google Maps Places API)</div>
        </div>
      </div>
    </div>
  );
}

function FileEditor() {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ border: "1.5px dashed var(--border-strong)", borderRadius: 8, padding: 20, textAlign: "center", color: "var(--text-3)" }}>
        <Icons.Folder size={20}/>
        <div style={{ marginTop: 6, fontSize: 12.5, color: "var(--text-2)" }}>拖曳 PDF / DOCX / XLSX 等檔案</div>
        <div className="mono-sm" style={{ fontSize: 10.5, marginTop: 4 }}>最大 100MB · RCS only · MMS fallback 不支援檔案</div>
      </div>
    </div>
  );
}

// ── Suggested replies ──────────────────────────────────────────────
function SuggestedRepliesEditor({ suggested, setSuggested }) {
  return (
    <div style={{ marginTop: 14 }}>
      <div className="row" style={{ alignItems: "baseline", marginBottom: 8 }}>
        <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500 }}>
          Suggested Replies / Suggested Actions (訊息下方快速按鈕,{suggested.length} / 11)
        </label>
        <div className="spacer"></div>
        <button className="btn sm" onClick={() => setSuggested([...suggested, { type: "reply", l: "新建議", icon: "" }])}>
          <Icons.Plus size={11}/> 新增
        </button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {suggested.map((s, i) => (
          <div key={i} style={{ display: "grid", gridTemplateColumns: "auto 50px 1fr 1.2fr auto", gap: 6, padding: 8, background: "var(--surface-2)", borderRadius: 6, alignItems: "center" }}>
            <Icons.More size={14} style={{ color: "var(--text-3)", transform: "rotate(90deg)" }}/>
            <input className="input" value={s.icon} onChange={(e) => setSuggested(suggested.map((ss,j) => j===i ? {...ss, icon: e.target.value} : ss))} placeholder="emoji" style={{ padding: "4px 8px", textAlign: "center" }}/>
            <input className="input" value={s.l} onChange={(e) => setSuggested(suggested.map((ss,j) => j===i ? {...ss, l: e.target.value} : ss))} placeholder="按鈕文字" maxLength={25} style={{ padding: "4px 8px", fontSize: 11.5 }}/>
            <select className="input" value={s.type} onChange={(e) => setSuggested(suggested.map((ss,j) => j===i ? {...ss, type: e.target.value} : ss))} style={{ padding: "4px 8px", fontSize: 11.5 }}>
              {SUGGESTED_REPLY_TYPES.map(t => <option key={t.id} value={t.id}>{t.l}</option>)}
            </select>
            <button className="icon-btn" onClick={() => setSuggested(suggested.filter((_,j) => j !== i))} style={{ width: 22, height: 22 }}><Icons.Trash size={11}/></button>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Section: Fallback cascade ─────────────────────────────────────
function FallbackSection({ fallbackOn, setFallbackOn, mmsFallbackOn, setMmsFallbackOn, smsBody, setSmsBody, previewVariant, setPreviewVariant }) {
  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr auto 1fr", gap: 12, alignItems: "stretch", marginBottom: 14 }}>
        <FallbackCard
          level="1" channel="RCS" sender="rcs:agt_shopmart_official"
          enabled={true} color="var(--primary)"
          features={["Rich Card / Carousel","Suggested Replies","Delivery + Read","高品質媒體 100MB"]}
          active={previewVariant === "rcs"}
          onPreview={() => setPreviewVariant("rcs")}
        />
        <FallbackArrow on={fallbackOn} onToggle={() => setFallbackOn(!fallbackOn)} />
        <FallbackCard
          level="2" channel="MMS Fallback" sender="+886 2 2780 8888"
          enabled={fallbackOn && mmsFallbackOn} color="var(--info)"
          features={["圖片 + 文字 (≤ 8MB)","Subject line","Delivery 回報","台灣/HK shortcode"]}
          active={previewVariant === "mms"}
          onPreview={() => setPreviewVariant("mms")}
          toggle={{ on: mmsFallbackOn, set: () => setMmsFallbackOn(!mmsFallbackOn) }}
        />
        <FallbackArrow on={fallbackOn} onToggle={() => setFallbackOn(!fallbackOn)} />
        <FallbackCard
          level="3" channel="SMS Fallback" sender="ShopMart (alphanumeric)"
          enabled={fallbackOn} color="var(--warning)"
          features={["純文字 (≤ 160 字)","可分段","所有手機支援","最低成本"]}
          active={previewVariant === "sms"}
          onPreview={() => setPreviewVariant("sms")}
        />
      </div>

      <div className="grid-2" style={{ gap: 14 }}>
        <div className="field">
          <label>SMS Fallback 文字 (純文字)</label>
          <textarea className="input" rows={3} value={smsBody} onChange={(e) => setSmsBody(e.target.value)} maxLength={160}/>
          <div className="hint">
            {smsBody.length} / 160 字元 · {Math.ceil(smsBody.length / 160) || 1} 段
            · 預估 SMS 成本 ${(0.0035 * Math.ceil(smsBody.length / 160)).toFixed(4)} / 則
          </div>
        </div>
        <div className="field">
          <label>Sender Pool (依優先順序自動選擇)</label>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {[
              { p: "1", t: "Shortcode", v: "881288" },
              { p: "2", t: "Alphanumeric", v: "ShopMart" },
              { p: "3", t: "Long Code", v: "+886-2-2780-8888" },
              { p: "4", t: "Toll-Free", v: "0800-118-118" },
            ].map((s, i) => (
              <div key={i} style={{ display: "grid", gridTemplateColumns: "30px 90px 1fr auto", gap: 8, padding: 6, background: "var(--surface-2)", borderRadius: 6, fontSize: 11.5, alignItems: "center" }}>
                <span className="mono" style={{ color: "var(--text-3)", textAlign: "center" }}>#{s.p}</span>
                <span className="badge outline mono-sm" style={{ fontSize: 9 }}>{s.t}</span>
                <span className="mono" style={{ fontSize: 11 }}>{s.v}</span>
                <Icons.More size={12} style={{ color: "var(--text-3)" }}/>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ marginTop: 14, padding: 12, background: "var(--surface-2)", borderRadius: 8, display: "flex", gap: 10, alignItems: "flex-start" }}>
        <Icons.Bolt size={14} style={{ color: "var(--warning)", marginTop: 2 }}/>
        <div style={{ fontSize: 11.5, color: "var(--text-2)", lineHeight: 1.6 }}>
          <strong style={{ color: "var(--text)" }}>Twilio 自動 Capability Check</strong>:傳送前 Twilio 會檢查收件人裝置是否支援 RCS,不支援的會自動降級到 MMS (在支援地區) 或 SMS。
          來自 Twilio 文件:「Messages that can't be delivered over RCS automatically fall back to SMS or MMS, using other senders in the Messaging Service's Sender Pool.」
        </div>
      </div>
    </div>
  );
}

function FallbackCard({ level, channel, sender, enabled, color, features, active, onPreview, toggle }) {
  return (
    <div style={{
      border: `1px solid ${active ? color : "var(--border)"}`,
      borderRadius: 10, padding: 12,
      background: active ? "var(--surface-2)" : "var(--surface)",
      opacity: enabled ? 1 : 0.45,
      cursor: enabled ? "pointer" : "not-allowed",
      position: "relative",
      boxShadow: active ? `0 0 0 3px ${color}30` : "none",
      transition: "all 0.15s"
    }} onClick={() => enabled && onPreview()}>
      <div style={{ position: "absolute", top: 10, right: 12, fontFamily: "var(--font-mono)", fontSize: 10, color, fontWeight: 700 }}>L{level}</div>
      <div style={{ width: 30, height: 30, borderRadius: 8, background: `${color}20`, color: color, display: "grid", placeItems: "center", marginBottom: 8 }}>
        {channel.startsWith("RCS") ? <Icons.Sparkles size={16}/> : channel.startsWith("MMS") ? <Icons.Image size={16}/> : <Icons.Mail size={16}/>}
      </div>
      <div style={{ fontSize: 13, fontWeight: 600, fontFamily: "var(--font-sans)" }}>{channel}</div>
      <code className="mono-sm" style={{ fontSize: 10, color: "var(--text-3)", display: "block", marginTop: 2 }}>{sender}</code>
      <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 3 }}>
        {features.map((f, i) => (
          <div key={i} className="row gap-4" style={{ fontSize: 10.5, color: "var(--text-2)", alignItems: "center" }}>
            <Icons.Check size={9} style={{ color }}/>
            {f}
          </div>
        ))}
      </div>
      {toggle && (
        <div className="row gap-6" style={{ marginTop: 10, alignItems: "center" }} onClick={(e) => { e.stopPropagation(); toggle.set(); }}>
          <span className={`switch ${toggle.on ? "on" : ""}`}></span>
          <span style={{ fontSize: 10.5 }}>啟用此層</span>
        </div>
      )}
    </div>
  );
}

function FallbackArrow({ on, onToggle }) {
  return (
    <div style={{ display: "grid", placeItems: "center", color: on ? "var(--primary)" : "var(--text-dim)", cursor: "pointer" }} onClick={onToggle}
         title={on ? "Fallback enabled — click to disable" : "Click to enable fallback"}>
      <Icons.ChevRight size={18}/>
      <span className="mono-sm" style={{ fontSize: 9, marginTop: 2 }}>{on ? "fallback" : "off"}</span>
    </div>
  );
}

// ── Section: Variables / Personalization ──────────────────────────
function VariablesSection({ sampleContact, interpolate }) {
  return (
    <div>
      <div className="grid-2" style={{ gap: 14 }}>
        <div>
          <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500, marginBottom: 6, display: "block" }}>
            Content Variables 映射
          </label>
          <div style={{ border: "1px solid var(--border-strong)", borderRadius: 8, overflow: "hidden" }}>
            {[
              { var: "first_name",    src: "contact.first_name", sample: sampleContact.first_name },
              { var: "order_id",      src: "trigger.order_id",   sample: sampleContact.order_id },
              { var: "delivery_date", src: "trigger.delivery_eta",sample: sampleContact.delivery_date },
              { var: "tracking_url",  src: "trigger.tracking_url",sample: sampleContact.tracking_url },
              { var: "cart_total",    src: "trigger.cart.total", sample: sampleContact.cart_total },
            ].map((v, i) => (
              <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", gap: 8, padding: 8, borderBottom: i < 4 ? "1px solid var(--border-soft)" : 0, fontSize: 11.5, alignItems: "center" }}>
                <code className="mono" style={{ color: "var(--primary)" }}>{`{{${v.var}}}`}</code>
                <Icons.ArrowDn size={11} style={{ color: "var(--text-3)", transform: "rotate(-90deg)" }}/>
                <code className="mono-sm" style={{ color: "var(--text-2)" }}>{v.src}</code>
              </div>
            ))}
          </div>
          <button className="btn sm" style={{ marginTop: 8 }}><Icons.Plus size={11}/> 新增變數映射</button>
        </div>

        <div>
          <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500, marginBottom: 6, display: "block" }}>
            預覽 (使用範例聯絡人)
          </label>
          <div style={{ background: "var(--surface-2)", borderRadius: 8, padding: 12, fontSize: 11.5 }}>
            <div className="row" style={{ alignItems: "center", marginBottom: 8, gap: 8 }}>
              <Avatar name="陳怡君" size="sm" />
              <div className="col flex-1">
                <strong style={{ fontSize: 12 }}>陳怡君</strong>
                <span className="muted mono-sm" style={{ fontSize: 10 }}>+886 912 ****678 · VIP</span>
              </div>
              <button className="btn sm"><Icons.Refresh size={10}/> 切換</button>
            </div>
            <div style={{ padding: 10, background: "var(--surface)", borderRadius: 6, color: "var(--text)", lineHeight: 1.5 }}>
              {interpolate("嗨 {{first_name}}!您的訂單 #{{order_id}} 已交付物流,預計 {{delivery_date}} 送達。")}
            </div>
            <div style={{ marginTop: 8, padding: 8, background: "var(--surface)", borderRadius: 6 }}>
              {Object.entries(sampleContact).slice(0, 4).map(([k, v]) => (
                <div key={k} className="row" style={{ fontSize: 11, padding: "2px 0" }}>
                  <code className="mono-sm" style={{ color: "var(--text-3)", flex: 1 }}>{k}</code>
                  <span className="mono">{v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Section: Schedule ─────────────────────────────────────────────
function ScheduleSection({ schedule, setSchedule, scheduleDate, setScheduleDate, scheduleTime, setScheduleTime, rateLimit, setRateLimit, tzAware, setTzAware, quietHours, setQuietHours }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
      <div>
        <div className="row gap-8" style={{ marginBottom: 12 }}>
          {[
            { id: "now", l: "立即傳送", icon: "Bolt" },
            { id: "scheduled", l: "排程時間", icon: "Calendar" },
            { id: "trigger", l: "事件觸發", icon: "Webhook" },
            { id: "stz", l: "STZ 智慧時區", icon: "Sparkles" },
          ].map(o => {
            const Ico = Icons[o.icon];
            return (
              <div key={o.id} className={`option-card ${schedule === o.id ? "selected" : ""}`}
                   style={{ flex: 1, padding: "8px 10px", textAlign: "center", cursor: "pointer" }} onClick={() => setSchedule(o.id)}>
                <Ico size={14} style={{ color: schedule === o.id ? "var(--primary)" : "var(--text-2)", marginBottom: 4 }}/>
                <h4 style={{ fontSize: 11 }}>{o.l}</h4>
              </div>
            );
          })}
        </div>

        {schedule === "scheduled" && (
          <div className="grid-2" style={{ gap: 8, marginBottom: 12 }}>
            <div className="field">
              <label>開始日期</label>
              <input className="input" value={scheduleDate} onChange={(e) => setScheduleDate(e.target.value)}/>
            </div>
            <div className="field">
              <label>時間</label>
              <input className="input" value={scheduleTime} onChange={(e) => setScheduleTime(e.target.value)}/>
            </div>
          </div>
        )}
        {schedule === "trigger" && (
          <div className="field" style={{ marginBottom: 12 }}>
            <label>觸發事件</label>
            <select className="input" defaultValue="cart.abandoned">
              <option value="cart.abandoned">cart.abandoned (24h 後)</option>
              <option>order.shipped</option>
              <option>order.delivered</option>
              <option>customer.tier_upgraded</option>
              <option>custom webhook event</option>
            </select>
          </div>
        )}
        {schedule === "stz" && (
          <div className="field" style={{ marginBottom: 12, padding: 10, background: "var(--surface-2)", borderRadius: 8, fontSize: 11.5 }}>
            <Icons.Sparkles size={12} style={{ color: "var(--primary)", marginRight: 4 }}/>
            <strong>智慧時區 (Send-Time Optimization)</strong>: AI 根據每位用戶歷史互動時段個別最佳化發送時間,提升 CTR ≈22%
          </div>
        )}

        <div className="field">
          <label>傳送速率限制 (Throughput)</label>
          <div className="input-row">
            <span className="input-prefix">≤</span>
            <input className="input" value={rateLimit} onChange={(e) => setRateLimit(+e.target.value)}/>
            <span className="input-prefix" style={{ borderLeft: 0, borderRight: "1px solid var(--border-strong)", borderTopRightRadius: "var(--r-md)", borderBottomRightRadius: "var(--r-md)" }}>msg / min</span>
          </div>
          <div className="hint">Agent 上限 8,000 msg/min · 你的方案 12,000 msg/min</div>
        </div>

        <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
          <Toggle label="遵守用戶在地時區" sub="依用戶 timezone 排程,而非帳號時區" on={tzAware} set={setTzAware}/>
          <Toggle label="Quiet hours (22:00–08:00)" sub="符合 TCPA / 各區法規 (TW NCC 8.5 / US 22-8 local)" on={quietHours} set={setQuietHours}/>
          <Toggle label="Throttle 防壅塞" sub="若 carrier 回應 429,自動降速重送" on={true} set={()=>{}}/>
        </div>
      </div>

      <div>
        <MiniCalendar month="五月 2026" highlight={22}/>
        <div style={{ marginTop: 14, padding: 12, background: "var(--surface-2)", borderRadius: 8, fontSize: 11.5 }}>
          <div className="row" style={{ marginBottom: 6 }}>
            <strong style={{ color: "var(--text)" }}>排程摘要</strong>
            <div className="spacer"></div>
            <span className="badge primary">{scheduleDate} {scheduleTime} +08:00</span>
          </div>
          <div className="mono-sm" style={{ color: "var(--text-2)", lineHeight: 1.7 }}>
            · 92,140 用戶 (女裝瀏覽 30d)<br/>
            · 約 19:00–19:31 內完成傳送 (rate {rateLimit.toLocaleString()}/min)<br/>
            · 預估成本 $3,820 USD<br/>
            · ⏰ Quiet hours 啟用,延後送達 {Math.round(0.04 * 92140).toLocaleString()} 筆<br/>
            · ✓ 已通過內容審核
          </div>
        </div>
      </div>
    </div>
  );
}

function Toggle({ label, sub, on, set }) {
  return (
    <div className="row gap-10" style={{ alignItems: "center", padding: 10, background: "var(--surface-2)", borderRadius: 6 }} onClick={() => set(!on)}>
      <span className={`switch ${on ? "on" : ""}`}></span>
      <div className="col flex-1 gap-4">
        <span style={{ fontSize: 12 }}>{label}</span>
        {sub && <span className="muted mono-sm" style={{ fontSize: 10 }}>{sub}</span>}
      </div>
    </div>
  );
}

// ── Section: Advanced ─────────────────────────────────────────────
function AdvancedSection({ statusCallback, setStatusCallback, validityMins, setValidityMins, readReceipts, setReadReceipts, smartEncoding, setSmartEncoding }) {
  return (
    <div>
      <div className="grid-2" style={{ gap: 14, marginBottom: 14 }}>
        <div className="field">
          <label>Status Callback URL</label>
          <input className="input mono" value={statusCallback} onChange={(e) => setStatusCallback(e.target.value)} style={{ fontSize: 11.5 }}/>
          <div className="hint">收 message.delivered / message.read / message.failed 事件</div>
        </div>
        <div className="field">
          <label>Validity Period (TTL)</label>
          <div className="input-row">
            <input className="input" value={validityMins} onChange={(e) => setValidityMins(+e.target.value)}/>
            <span className="input-prefix" style={{ borderLeft: 0, borderRight: "1px solid var(--border-strong)", borderTopRightRadius: "var(--r-md)", borderBottomRightRadius: "var(--r-md)" }}>分鐘</span>
          </div>
          <div className="hint">超過此時間未送達,訊息自動失效 (預設 1440 = 24h)</div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <Toggle label="Delivery Receipt" sub="送達手機時觸發 webhook (RCS 比 SMS 更可靠)" on={true} set={()=>{}}/>
        <Toggle label="Read Receipt" sub="用戶開啟訊息時觸發 (RCS 獨有,需用戶允許)" on={readReceipts} set={setReadReceipts}/>
        <Toggle label="Smart Encoding" sub="自動轉換 Unicode → GSM-7 字元 (SMS fallback 省段)" on={smartEncoding} set={setSmartEncoding}/>
        <Toggle label="Profile / Vendor metadata" sub="附加自訂 metadata 到每筆訊息" on={false} set={()=>{}}/>
        <Toggle label="Inbound auto-reply" sub="若用戶回覆,將透過 Conversational Studio 路由處理" on={true} set={()=>{}}/>
      </div>

      <div style={{ marginTop: 14 }}>
        <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500, marginBottom: 6, display: "block" }}>
          產生 API Payload 預覽
        </label>
        <pre className="codeblock" style={{ fontSize: 10.5 }}>{`POST https://content.twilio.com/v1/Messages
Authorization: Basic ${"<base64(AC...:<auth>)>"}
Content-Type: application/x-www-form-urlencoded

MessagingServiceSid=MG2a04b821e8c4d2ef1a04b821e8c4d2ef
To=+886912345678
ContentSid=HX7b91c8d4a92ec103
ContentVariables={"first_name":"怡君","order_id":"SM2026-1042"}
StatusCallback=${statusCallback}
ValidityPeriod=${validityMins * 60}
SmartEncoded=${smartEncoding}
ScheduleType=fixed
SendAt=2026-05-22T11:00:00Z`}</pre>
      </div>
    </div>
  );
}

// ── Section: Compliance ───────────────────────────────────────────
function ComplianceSection({ aupCategory }) {
  const checks = [
    { l: "RCS Agent 已通過 Google RBM 品牌驗證", s: "pass", sub: "agt_shopmart_official · 完成於 2025-08-14" },
    { l: "Agent 已在 TW 三大電信通過 Carrier 審核", s: "pass", sub: "Chunghwa · Taiwan Mobile · FET" },
    { l: "AUP 內容分類已設定", s: "pass", sub: `分類: ${aupCategory} · 符合 Google AUP` },
    { l: "受眾 100% 已 opt-in", s: "pass", sub: "92,140 / 92,140 同意接收行銷訊息" },
    { l: "包含 STOP/退訂指引", s: "pass", sub: "Footer 自動附加 · 「回覆 STOP 取消」" },
    { l: "內容掃描 (詐騙/敏感字)", s: "pass", sub: "通過 AI 內容檢查 · 0 旗標" },
    { l: "GDPR / PDPA 資料處理協議", s: "pass", sub: "DPA 簽署於 2024-11-02" },
    { l: "圖片/影片版權聲明", s: "warning", sub: "建議附加版權標示 (非必要)" },
  ];
  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
        {checks.map((c, i) => (
          <div key={i} style={{ display: "flex", gap: 10, padding: 10, background: "var(--surface-2)", borderRadius: 8, alignItems: "flex-start" }}>
            <span style={{
              width: 20, height: 20, borderRadius: "50%",
              background: c.s === "pass" ? "var(--success)" : c.s === "warning" ? "var(--warning)" : "var(--danger)",
              color: "white", display: "grid", placeItems: "center", flex: "0 0 auto", marginTop: 1,
            }}>
              {c.s === "pass" ? <Icons.Check size={12} stroke={3}/> : <span style={{ fontWeight: 700, fontSize: 12 }}>!</span>}
            </span>
            <div>
              <div style={{ fontSize: 12, fontWeight: 500 }}>{c.l}</div>
              <div className="muted mono-sm" style={{ fontSize: 10, marginTop: 2 }}>{c.sub}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="row gap-8" style={{ marginTop: 14, padding: 12, background: "var(--success-soft)", borderRadius: 8, fontSize: 12, color: "var(--success)" }}>
        <Icons.Check size={14} stroke={3}/>
        <strong>已通過全部關鍵合規檢查</strong>
        <div className="spacer"></div>
        <button className="btn sm" style={{ borderColor: "var(--success)", color: "var(--success)" }}>查看完整合規報告 →</button>
      </div>
    </div>
  );
}

// ── Section: Test ─────────────────────────────────────────────────
function TestSection({ testNumber, setTestNumber, agentData }) {
  return (
    <div>
      <div className="grid-2" style={{ gap: 14 }}>
        <div>
          <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500, marginBottom: 6, display: "block" }}>
            測試手機號碼 (最多 3 個)
          </label>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {[testNumber, "+886 933 248 991", ""].map((n, i) => (
              <div key={i} style={{ display: "grid", gridTemplateColumns: "auto 1fr auto", gap: 6, padding: 8, background: "var(--surface-2)", borderRadius: 6, alignItems: "center" }}>
                <span className="mono-sm" style={{ color: "var(--text-3)", paddingLeft: 4 }}>#{i+1}</span>
                <input className="input mono" placeholder="+886 9xx xxx xxx" value={n} onChange={(e) => i === 0 && setTestNumber(e.target.value)} style={{ padding: "4px 8px" }}/>
                <span className="badge success" style={{ fontSize: 9 }}><span className="dot"></span>RCS</span>
              </div>
            ))}
          </div>
          <button className="btn primary" style={{ marginTop: 10, width: "100%" }}>
            <Icons.Send size={13}/> 傳送測試訊息
          </button>
        </div>

        <div>
          <label style={{ fontSize: 11, color: "var(--text-2)", fontWeight: 500, marginBottom: 6, display: "block" }}>
            或透過 Deep Link / QR Code 測試
          </label>
          <div style={{ display: "grid", gridTemplateColumns: "100px 1fr", gap: 12, padding: 12, background: "var(--surface-2)", borderRadius: 8 }}>
            <div style={{ width: 100, height: 100, background: "white", borderRadius: 6, padding: 6 }}>
              {/* faux QR */}
              <svg viewBox="0 0 100 100" width="100%" height="100%">
                {Array.from({ length: 100 }).map((_, i) => {
                  const x = (i % 10) * 10, y = Math.floor(i / 10) * 10;
                  const on = ((i * 37 + 7) % 5) > 1;
                  return on ? <rect key={i} x={x} y={y} width="10" height="10" fill="#111"/> : null;
                })}
                <rect x="0" y="0" width="30" height="30" fill="white"/>
                <rect x="0" y="0" width="30" height="30" fill="none" stroke="#111" strokeWidth="5"/>
                <rect x="10" y="10" width="10" height="10" fill="#111"/>
                <rect x="70" y="0" width="30" height="30" fill="white"/>
                <rect x="70" y="0" width="30" height="30" fill="none" stroke="#111" strokeWidth="5"/>
                <rect x="80" y="10" width="10" height="10" fill="#111"/>
                <rect x="0" y="70" width="30" height="30" fill="white"/>
                <rect x="0" y="70" width="30" height="30" fill="none" stroke="#111" strokeWidth="5"/>
                <rect x="10" y="80" width="10" height="10" fill="#111"/>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 4 }}>掃描即開啟對話</div>
              <div className="muted mono-sm" style={{ fontSize: 10, marginBottom: 8 }}>Google SMS Link · 由 {agentData.name} 發起</div>
              <code className="mono-sm" style={{ fontSize: 10, color: "var(--primary)", wordBreak: "break-all", display: "block" }}>https://sms.google.com/agent/{agentData.id}/</code>
              <div className="row gap-4" style={{ marginTop: 8 }}>
                <button className="btn sm"><Icons.Copy size={11}/></button>
                <button className="btn sm"><Icons.Download size={11}/> PNG</button>
                <button className="btn sm"><Icons.Send size={11}/> Email</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card" style={{ marginTop: 14, padding: 0, background: "var(--surface-2)" }}>
        <div className="card-head" style={{ padding: "8px 12px" }}>
          <strong style={{ fontSize: 12 }}>歷史測試紀錄</strong>
          <div className="spacer"></div>
          <span className="muted mono-sm">最近 5 筆</span>
        </div>
        <table className="data">
          <thead>
            <tr><th>時間</th><th>收件人</th><th>內容</th><th>結果</th><th></th></tr>
          </thead>
          <tbody>
            {[
              { ts: "12:38:21", to: "+886 912 ****678", c: "carousel · 3 cards", s: "read" },
              { ts: "12:35:08", to: "+886 933 ****991", c: "rich card", s: "delivered" },
              { ts: "12:32:44", to: "+886 988 ****332", c: "text + media", s: "fallback_sms" },
              { ts: "12:21:09", to: "+1 415 ****821", c: "rich card", s: "failed" },
            ].map((r, i) => (
              <tr key={i}>
                <td className="mono-sm">{r.ts}</td>
                <td className="mono-sm">{r.to}</td>
                <td><span className="mono-sm">{r.c}</span></td>
                <td><StatusBadge status={r.s}/></td>
                <td><button className="btn sm"><Icons.Eye size={11}/></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Final review card ─────────────────────────────────────────────
function ReviewSummary({ audienceData, agentData, fallbackOn, mmsFallbackOn, scheduleDate, scheduleTime, templateSid, contentType }) {
  return (
    <div className="card" style={{
      background: "linear-gradient(135deg, rgba(124,92,255,0.10), rgba(0,209,179,0.05))",
      border: "1px solid var(--primary)",
      marginTop: 6
    }}>
      <div className="card-head">
        <Icons.Bolt size={15} style={{ color: "var(--primary)" }}/>
        <h3>準備發送 · 最終審核</h3>
        <div className="spacer"></div>
        <span className="badge success"><span className="dot"></span>9/9 通過</span>
      </div>
      <div style={{ padding: 14, display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12 }}>
        {[
          ["受眾", audienceData.name, `${audienceData.size.toLocaleString()} 用戶`],
          ["Sender", agentData.name, agentData.id],
          ["內容", `${contentType}`, `Template ${templateSid.slice(0,10)}…`],
          ["Fallback", fallbackOn ? `RCS → ${mmsFallbackOn ? "MMS → " : ""}SMS` : "僅 RCS", fallbackOn ? "auto" : "—"],
          ["排程", `${scheduleDate} ${scheduleTime}`, "+08:00 · TZ-aware"],
          ["預估成本", "$3,820", "USD · 計費 RCS+Fallback"],
          ["預估送達", "31 min", "rate 5,000/min"],
          ["預估營收", "$84,210", "歸因 11.9× ROAS"],
        ].map((cell, i) => (
          <div key={i} style={{ padding: 10, background: "var(--surface)", borderRadius: 8 }}>
            <div className="muted mono-sm" style={{ fontSize: 10 }}>{cell[0].toUpperCase()}</div>
            <div style={{ fontWeight: 600, fontSize: 13, marginTop: 4, fontFamily: "var(--font-sans)" }}>{cell[1]}</div>
            <div className="muted mono-sm" style={{ fontSize: 10, marginTop: 2 }}>{cell[2]}</div>
          </div>
        ))}
      </div>
      <div style={{ padding: 14, borderTop: "1px solid var(--border-soft)", display: "flex", gap: 8, alignItems: "center" }}>
        <Icons.Lock size={13} style={{ color: "var(--text-3)" }}/>
        <span style={{ fontSize: 11.5, color: "var(--text-2)" }}>
          發送後將無法停止已送出訊息 · 只能取消未送出的部份
        </span>
        <div className="spacer"></div>
        <button className="btn ghost">儲存為草稿</button>
        <button className="btn"><Icons.Calendar size={13}/> 確認排程</button>
        <button className="btn primary"><Icons.Bolt size={13}/> 立即發送 92,140 則</button>
      </div>
    </div>
  );
}

// ── Phone Preview Pane ────────────────────────────────────────────
function PhonePreviewPane({ device, setDevice, previewVariant, setPreviewVariant, agent, bubbles, suggested, fallbackOn }) {
  const fallbackLabel = previewVariant === "rcs" ? null
    : previewVariant === "mms" ? "RCS 不可達 → 已 fallback 至 MMS"
    : "RCS 不可達 → 已 fallback 至 SMS";
  return (
    <div>
      <div className="row" style={{ alignItems: "center", marginBottom: 10 }}>
        <strong style={{ fontFamily: "var(--font-sans)", fontSize: 13, flex: 1 }}>即時預覽</strong>
        <div className="seg">
          <button className={device === "iPhone" ? "active" : ""} onClick={() => setDevice("iPhone")}>iOS</button>
          <button className={device === "Android" ? "active" : ""} onClick={() => setDevice("Android")}>Android</button>
        </div>
      </div>
      <div className="seg" style={{ width: "100%", marginBottom: 14 }}>
        <button className={previewVariant === "rcs" ? "active" : ""} onClick={() => setPreviewVariant("rcs")} style={{ flex: 1 }}>
          <Icons.Sparkles size={10}/> RCS
        </button>
        <button className={previewVariant === "mms" ? "active" : ""} onClick={() => setPreviewVariant("mms")} disabled={!fallbackOn} style={{ flex: 1, opacity: fallbackOn ? 1 : 0.4 }}>
          <Icons.Image size={10}/> MMS
        </button>
        <button className={previewVariant === "sms" ? "active" : ""} onClick={() => setPreviewVariant("sms")} disabled={!fallbackOn} style={{ flex: 1, opacity: fallbackOn ? 1 : 0.4 }}>
          <Icons.Mail size={10}/> SMS
        </button>
      </div>
      <PhonePreview
        device={device}
        agent={{ name: previewVariant === "rcs" ? agent.name : "ShopMart", initials: agent.name.slice(0,1), color: agent.color, verified: previewVariant === "rcs" && agent.verified }}
        bubbles={bubbles}
        suggestions={previewVariant === "rcs" ? suggested : []}
        fallbackBanner={fallbackLabel}
        composerHint={previewVariant === "sms" ? "Text Message · SMS/MMS" : "RCS message"}
      />

      {/* Stats below phone */}
      <div style={{ marginTop: 14, padding: 12, background: "var(--surface-2)", borderRadius: 8 }}>
        <div className="row" style={{ alignItems: "baseline", marginBottom: 8 }}>
          <strong style={{ fontSize: 11.5 }}>內容檢查</strong>
          <div className="spacer"></div>
          <span className="badge success" style={{ fontSize: 9 }}>OK</span>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 4, fontSize: 11, color: "var(--text-2)" }}>
          {[
            ["Payload size", "1.84 KB / 250 KB"],
            ["Card count", `${1}–${3} cards`],
            ["CTA count (max)", `${4} / 4`],
            ["Suggestions", `${suggested.length} / 11`],
            ["Variables", "5 mapped"],
            ["Media weight", "248 KB"],
          ].map(([k, v]) => (
            <React.Fragment key={k}>
              <span>{k}</span>
              <span className="mono-sm" style={{ color: "var(--text)" }}>{v}</span>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}



// ───── src/raw/screens/templates.jsx ─────
function TemplatesScreen({ go }) {
  const [view, setView] = useStateTpl("grid");
  const [filter, setFilter] = useStateTpl("all");

  const rows = DATA.templates.filter(t => filter === "all" ? true : t.category === filter);

  return (
    <div className="content">
      <div className="page-head">
        <div className="title-block">
          <h1>Templates 訊息範本</h1>
          <p className="desc">設計、審核、管理 RCS Rich Cards、Carousel 與 Text 範本</p>
        </div>
        <div className="actions">
          <button className="btn"><Icons.Download size={14}/> 匯入</button>
          <button className="btn primary" onClick={() => go("template_edit")}><Icons.Plus size={14}/> 新範本</button>
        </div>
      </div>

      <div className="row" style={{ alignItems: "center", marginBottom: 12, gap: 12 }}>
        <div className="tabs flex-1">
          {[
            { id: "all", l: "全部" },
            { id: "Transactional", l: "交易" },
            { id: "Promotional", l: "行銷" },
            { id: "Conversational", l: "對話" },
            { id: "Triggered", l: "觸發" },
          ].map(t => (
            <div key={t.id} className={`tab ${filter === t.id ? "active" : ""}`} onClick={() => setFilter(t.id)}>{t.l}</div>
          ))}
        </div>
        <div className="searchbox" style={{ minWidth: 200 }}>
          <Icons.Search size={13}/>
          <input placeholder="搜尋範本..."/>
        </div>
        <div className="seg">
          <button className={view === "grid" ? "active" : ""} onClick={() => setView("grid")}>卡片</button>
          <button className={view === "list" ? "active" : ""} onClick={() => setView("list")}>列表</button>
        </div>
      </div>

      {view === "grid" ? (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12 }}>
          {rows.map(t => <TemplateCard key={t.id} t={t} onOpen={() => go("template_edit")} />)}
          <div onClick={() => go("template_edit")} style={{
            border: "1.5px dashed var(--border-strong)", borderRadius: "var(--r-lg)",
            display: "grid", placeItems: "center", minHeight: 200, cursor: "pointer",
            color: "var(--text-3)", background: "var(--surface)"
          }}>
            <div style={{ textAlign: "center" }}>
              <Icons.Plus size={20} />
              <div style={{ marginTop: 8, fontSize: 12, fontWeight: 600 }}>建立新範本</div>
              <div style={{ fontSize: 11, marginTop: 2 }}>從空白或範本庫</div>
            </div>
          </div>
        </div>
      ) : (
        <div className="table-wrap">
          <table className="data">
            <thead>
              <tr>
                <th>名稱</th>
                <th>類型</th>
                <th>分類</th>
                <th>語系</th>
                <th>狀態</th>
                <th className="right">使用次數</th>
                <th>最後使用</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map(t => (
                <tr key={t.id} onClick={() => go("template_edit")} style={{ cursor: "pointer" }}>
                  <td><strong style={{ fontSize: 12.5 }}>{t.name}</strong><div className="muted mono-sm">{t.id}</div></td>
                  <td><span className="badge outline">{t.type}</span></td>
                  <td><span className="mono-sm">{t.category}</span></td>
                  <td><span className="mono-sm">{t.language}</span></td>
                  <td><StatusBadge status={t.status} /></td>
                  <td className="right mono">{t.uses.toLocaleString()}</td>
                  <td><span className="muted mono-sm">{t.lastUsed}</span></td>
                  <td><button className="icon-btn"><Icons.More size={14}/></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function TemplateCard({ t, onOpen }) {
  // visual preview varies by type
  let preview;
  if (t.type === "Rich Card") {
    preview = (
      <div style={{ height: 110, background: "linear-gradient(135deg,#FFE7C7 0%,#FFC8A5 60%,#FF8A5B 100%)", display: "grid", placeItems: "center", color: "white", fontWeight: 700, fontSize: 13, textShadow: "0 1px 2px rgba(0,0,0,0.2)" }}>
        Rich Card
      </div>
    );
  } else if (t.type === "Carousel") {
    preview = (
      <div style={{ height: 110, padding: 10, background: "var(--surface-2)", display: "flex", gap: 6, overflow: "hidden" }}>
        {[1,2,3].map(i => (
          <div key={i} style={{ flex: 1, background: i === 1 ? "linear-gradient(135deg,#FFE7C7,#FF8A5B)" : i === 2 ? "linear-gradient(135deg,#D7E8FF,#7C5CFF)" : "linear-gradient(135deg,#E5F7EE,#22C55E)", borderRadius: 6, minWidth: 0 }}></div>
        ))}
      </div>
    );
  } else if (t.type === "Text") {
    preview = (
      <div style={{ height: 110, padding: 14, background: "var(--surface-2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ background: "white", color: "#111", padding: "8px 12px", borderRadius: 14, borderBottomLeftRadius: 4, fontSize: 11, maxWidth: "85%" }}>
          您的驗證碼: <strong>{"{{code}}"}</strong> · 5 分鐘內有效
        </div>
      </div>
    );
  } else {
    preview = (
      <div style={{ height: 110, padding: 12, background: "var(--surface-2)", display: "flex", flexDirection: "column", justifyContent: "center", gap: 6 }}>
        <div style={{ background: "white", color: "#111", padding: "6px 10px", borderRadius: 12, fontSize: 11, alignSelf: "flex-start", maxWidth: "80%" }}>感謝您回購!需要協助嗎?</div>
        <div style={{ display: "flex", gap: 4 }}>
          <span style={{ border: "1px solid #1F73E8", color: "#1F73E8", background: "white", borderRadius: 999, fontSize: 9, padding: "2px 8px" }}>查看訂單</span>
          <span style={{ border: "1px solid #1F73E8", color: "#1F73E8", background: "white", borderRadius: 999, fontSize: 9, padding: "2px 8px" }}>聯絡客服</span>
        </div>
      </div>
    );
  }

  return (
    <div className="card" style={{ cursor: "pointer", overflow: "hidden" }} onClick={onOpen}>
      {preview}
      <div style={{ padding: 12 }}>
        <div className="row" style={{ alignItems: "flex-start", gap: 6 }}>
          <strong style={{ fontSize: 12.5, flex: 1, lineHeight: 1.3 }}>{t.name}</strong>
          <StatusBadge status={t.status} />
        </div>
        <div className="muted mono-sm" style={{ marginTop: 4, fontSize: 10.5 }}>{t.id} · {t.type} · {t.language}</div>
        <div className="row" style={{ marginTop: 10, alignItems: "center", paddingTop: 8, borderTop: "1px solid var(--border-soft)" }}>
          <span className="muted mono-sm">{t.uses.toLocaleString()} uses</span>
          <div className="spacer"></div>
          <span className="muted mono-sm">{t.lastUsed}</span>
        </div>
      </div>
    </div>
  );
}

// ────────────────────────────────────────────────────────────────────
// TEMPLATE / CARD DESIGNER
// ────────────────────────────────────────────────────────────────────

function TemplateEditorScreen({ go }) {
  const [type, setType] = useStateTpl("card");
  const [title, setTitle] = useStateTpl("您的訂單已出貨 📦");
  const [desc, setDesc] = useStateTpl("親愛的 {{first_name}},您的訂單 #{{order_id}} 已交付物流,預計 {{delivery_date}} 送達。");
  const [orientation, setOrientation] = useStateTpl("vertical");
  const [mediaHeight, setMediaHeight] = useStateTpl("medium");

  const bubbles = type === "carousel" ? [
    { kind: "carousel", from: "out", cards: [
      { title: "夏季亞麻襯衫", desc: "NT$ 1,490", bg: "linear-gradient(135deg,#FFE7C7,#FF8A5B)", actions: ["立即購買"] },
      { title: "棉麻寬褲", desc: "NT$ 1,290", bg: "linear-gradient(135deg,#D7E8FF,#7C5CFF)", actions: ["立即購買"] },
      { title: "編織涼鞋", desc: "NT$ 980", bg: "linear-gradient(135deg,#E5F7EE,#22C55E)", actions: ["立即購買"] },
    ]}
  ] : type === "text" ? [
    { kind: "text", from: "out", text: `${title}\n\n${desc}` },
  ] : [
    { kind: "card", from: "out", card: {
      title, desc, media: title, bg: "linear-gradient(135deg,#FFE7C7,#FF8A5B)",
      actions: ["追蹤訂單","聯絡客服"]
    }}
  ];

  return (
    <div className="full-page-builder">
      <div className="builder-main">
        <div className="page-head">
          <div className="title-block">
            <div className="row gap-8" style={{ alignItems: "center", marginBottom: 6 }}>
              <a onClick={() => go("templates")} className="muted mono-sm" style={{ cursor: "pointer" }}>← Templates</a>
              <span className="muted">/</span>
              <span className="mono-sm">編輯範本</span>
            </div>
            <h1>出貨通知 - 物流追蹤</h1>
            <p className="desc">tpl_002 · zh-TW · 已使用 124,820 次 · 上次編輯 2 天前</p>
          </div>
          <div className="actions">
            <button className="btn"><Icons.Copy size={13}/> 複製</button>
            <button className="btn ghost"><Icons.Eye size={13}/> 在手機上測試</button>
            <button className="btn primary"><Icons.Check size={13}/> 儲存並送審</button>
          </div>
        </div>

        {/* Type selector */}
        <div className="card" style={{ marginBottom: 14 }}>
          <div className="card-head"><h3>① 範本類型</h3></div>
          <div className="card-body" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 }}>
            {[
              { id: "text", l: "純文字", desc: "純文字訊息 + 變數", icon: <Icons.Edit size={18} /> },
              { id: "card", l: "Rich Card", desc: "圖片 + 標題 + 描述 + CTA", icon: <Icons.Card size={18} /> },
              { id: "carousel", l: "Carousel", desc: "多張卡片水平滑動", icon: <Icons.Layers size={18} /> },
              { id: "media", l: "Media", desc: "純圖片/影片", icon: <Icons.Image size={18} /> },
            ].map(o => (
              <div key={o.id} className={`option-card ${type === o.id ? "selected" : ""}`} onClick={() => setType(o.id)}>
                <div style={{ color: type === o.id ? "var(--primary)" : "var(--text-2)", marginBottom: 6 }}>{o.icon}</div>
                <h4>{o.l}</h4>
                <p>{o.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="card" style={{ marginBottom: 14 }}>
          <div className="card-head">
            <h3>② 卡片內容</h3>
            <div className="spacer"></div>
            <span className="muted mono-sm">右側即時預覽 →</span>
          </div>
          <div className="card-body">
            <div className="grid-2" style={{ gap: 14 }}>
              <div className="field">
                <label>標題 <span className="req">*</span></label>
                <input className="input" value={title} onChange={(e) => setTitle(e.target.value)} maxLength={80}/>
                <div className="hint">{title.length} / 80 字元</div>
              </div>
              <div className="field">
                <label>方向</label>
                <div className="seg" style={{ width: "fit-content" }}>
                  <button className={orientation === "vertical" ? "active" : ""} onClick={() => setOrientation("vertical")}>直式</button>
                  <button className={orientation === "horizontal" ? "active" : ""} onClick={() => setOrientation("horizontal")}>橫式</button>
                </div>
              </div>
              <div className="field" style={{ gridColumn: "span 2" }}>
                <label>內文 <span className="req">*</span></label>
                <textarea className="input" value={desc} onChange={(e) => setDesc(e.target.value)} rows={3}/>
                <div className="hint">支援變數: {"{{first_name}}"}, {"{{order_id}}"}, {"{{delivery_date}}"}, {"{{tracking_url}}"}</div>
              </div>
              <div className="field">
                <label>媒體高度</label>
                <div className="seg" style={{ width: "fit-content" }}>
                  <button className={mediaHeight === "short" ? "active" : ""} onClick={() => setMediaHeight("short")}>短</button>
                  <button className={mediaHeight === "medium" ? "active" : ""} onClick={() => setMediaHeight("medium")}>中</button>
                  <button className={mediaHeight === "tall" ? "active" : ""} onClick={() => setMediaHeight("tall")}>高</button>
                </div>
              </div>
              <div className="field">
                <label>媒體類型</label>
                <select className="input" defaultValue="image"><option value="image">圖片</option><option>影片</option><option>GIF</option></select>
              </div>
              <div className="field" style={{ gridColumn: "span 2" }}>
                <label>媒體上傳</label>
                <div style={{ border: "1px dashed var(--border-strong)", borderRadius: 8, padding: 18, textAlign: "center", color: "var(--text-3)" }}>
                  <Icons.Upload size={18} />
                  <div style={{ marginTop: 6, fontSize: 12 }}>拖曳檔案,或從 <a style={{ color: "var(--primary)" }}>媒體庫</a> 選擇</div>
                  <div className="mono-sm" style={{ marginTop: 4, fontSize: 10 }}>建議 1440 × 810 px · JPG / PNG / MP4 · &lt;100MB</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card" style={{ marginBottom: 14 }}>
          <div className="card-head">
            <h3>③ CTA 按鈕</h3>
            <div className="spacer"></div>
            <button className="btn sm"><Icons.Plus size={11}/> 新增 (最多 4 個)</button>
          </div>
          <div className="card-body" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {[
              { label: "追蹤訂單", type: "URL", val: "https://shopmart.io/track/{{order_id}}" },
              { label: "聯絡客服", type: "撥打電話", val: "+886-2-2345-6789" },
            ].map((b, i) => (
              <div key={i} style={{ display: "grid", gridTemplateColumns: "auto 1fr 1.2fr 1fr auto", gap: 8, alignItems: "center", padding: 10, background: "var(--surface-2)", borderRadius: 8 }}>
                <span className="mono-sm" style={{ color: "var(--text-3)" }}>≡</span>
                <input className="input" defaultValue={b.label} />
                <select className="input" defaultValue={b.type}><option>URL</option><option>撥打電話</option><option>地點</option><option>傳送回覆</option></select>
                <input className="input" defaultValue={b.val} />
                <button className="icon-btn"><Icons.Trash size={14}/></button>
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <div className="card-head">
            <h3>④ Suggested Replies (快速回覆)</h3>
            <span className="sub">用戶可一鍵點擊回覆,最多 11 個</span>
          </div>
          <div className="card-body">
            <div className="pill-input">
              <span className="pill">查看訂單 <Icons.X size={10}/></span>
              <span className="pill">退換貨 <Icons.X size={10}/></span>
              <span className="pill">聯絡客服 <Icons.X size={10}/></span>
              <span className="pill">收件確認 <Icons.X size={10}/></span>
              <input placeholder="+ 新增建議回覆" />
            </div>
          </div>
        </div>

        <div className="card" style={{ marginTop: 14 }}>
          <div className="card-head">
            <h3>⑤ 進階 · JSON 預覽</h3>
            <span className="sub">送出至 Twilio API 的 payload</span>
            <div className="spacer"></div>
            <button className="btn sm"><Icons.Copy size={12}/> 複製</button>
          </div>
          <div style={{ padding: 14 }}>
            <pre className="codeblock"><span className="c">// POST /v1/Services/IS.../Channels/Messages</span>{`
{
  `}<span className="k">"to"</span>: <span className="s">"rcs:+886912345678"</span>,
  <span className="k">"from"</span>: <span className="s">"rcs:agt_shopmart_official"</span>,
  <span className="k">"contentSid"</span>: <span className="s">"HX2a04b821e8c4d2ef..."</span>,
  <span className="k">"contentVariables"</span>: {"{"}
    <span className="k">"first_name"</span>: <span className="s">"Maya"</span>,
    <span className="k">"order_id"</span>: <span className="s">"SM2026-1042"</span>,
    <span className="k">"delivery_date"</span>: <span className="s">"5/21 (Sat)"</span>
  {"}"},
  <span className="k">"statusCallback"</span>: <span className="s">"https://crm.shopmart.io/webhooks/twilio/dlr"</span>
{`}`}</pre>
          </div>
        </div>
      </div>

      <div className="builder-side">
        <div className="row" style={{ alignItems: "center", marginBottom: 12 }}>
          <strong style={{ fontFamily: "var(--font-sans)", fontSize: 13, flex: 1 }}>即時預覽</strong>
          <div className="seg">
            <button className="active">iPhone</button>
            <button>Android</button>
          </div>
        </div>
        <PhonePreview
          agent={{ name: "ShopMart 官方", initials: "S", color: "#7C5CFF", verified: true }}
          bubbles={bubbles}
          suggestions={["查看訂單","退換貨","聯絡客服","收件確認"]}
        />
      </div>
    </div>
  );
}



// ───── src/raw/screens/audience.jsx ─────
function AudienceScreen() {
  return (
    <div className="content">
      <div className="page-head">
        <div className="title-block">
          <h1>Audience 受眾與聯絡人</h1>
          <p className="desc">管理 Segments、CSV 名單、CRM 同步</p>
        </div>
        <div className="actions">
          <button className="btn"><Icons.Upload size={14}/> 上傳 CSV</button>
          <button className="btn primary"><Icons.Plus size={14}/> 建立 Segment</button>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 14 }}>
        {[
          { label: "Total Contacts", value: "1,284,510", delta: "+8.4k", dir: "up", sub: "近 7 天淨增" },
          { label: "RCS 可達 (verified)", value: "984,210", delta: "76.6%", dir: "up", sub: "of total" },
          { label: "Opted-in (行銷)", value: "748,210", delta: "+2.1%", dir: "up", sub: "vs last month" },
          { label: "Active Segments", value: "24", delta: "6 動態", dir: "flat", sub: "18 靜態 · 6 SQL-based" },
        ].map((k, i) => <Kpi key={i} {...k} spark={[10,14,18,22,26,30,34,38,42,48,52,58]} />)}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1.5fr", gap: 12 }}>
        <div className="card">
          <div className="card-head">
            <h3>Segments</h3>
            <span className="sub">{DATA.segments.length} 組</span>
            <div className="spacer"></div>
            <button className="btn sm"><Icons.Plus size={11}/> 新增</button>
          </div>
          <div>
            {DATA.segments.map((s, i) => (
              <div key={s.id} className="list-item" style={{ cursor: "pointer" }}>
                <div className="col flex-1 gap-4">
                  <strong style={{ fontSize: 12.5 }}>{s.name}</strong>
                  <span className="muted mono-sm">{s.source} · 同步 {s.lastSync}</span>
                </div>
                <div className="col" style={{ alignItems: "flex-end", gap: 4 }}>
                  <span className="mono" style={{ fontWeight: 600 }}>{s.size.toLocaleString()}</span>
                  <span className="mono-sm" style={{ color: s.growth.startsWith("+") ? "var(--success)" : "var(--text-3)" }}>{s.growth}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <div className="card-head">
            <h3>聯絡人 (全部)</h3>
            <div className="spacer"></div>
            <div className="searchbox" style={{ minWidth: 220 }}>
              <Icons.Search size={13}/>
              <input placeholder="搜尋姓名或電話..."/>
            </div>
          </div>
          <table className="data">
            <thead>
              <tr>
                <th style={{ width: 24 }}><input type="checkbox"/></th>
                <th>聯絡人</th>
                <th>電話</th>
                <th>等級</th>
                <th>RCS</th>
                <th>Opt-in</th>
                <th className="right">LTV</th>
                <th>最近活動</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {DATA.contacts.map((c, i) => (
                <tr key={i}>
                  <td><input type="checkbox" /></td>
                  <td>
                    <div className="row gap-8" style={{ alignItems: "center" }}>
                      <Avatar name={c.name} />
                      <strong style={{ fontSize: 12.5 }}>{c.name}</strong>
                    </div>
                  </td>
                  <td><span className="mono">{c.phone}</span></td>
                  <td>
                    <span className={`badge ${c.tier === "VIP" ? "primary" : c.tier === "Gold" ? "warning" : "outline"}`}>{c.tier}</span>
                  </td>
                  <td>
                    {c.rcs ? <span className="badge success"><span className="dot"></span>支援</span>
                           : <span className="badge outline">SMS</span>}
                  </td>
                  <td>
                    {c.optIn ? <span className="badge success">已同意</span> : <span className="badge danger">未同意</span>}
                  </td>
                  <td className="right mono">{c.spend}</td>
                  <td><span className="muted mono-sm">{c.lastSeen}</span></td>
                  <td><button className="icon-btn"><Icons.More size={14}/></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}



// ───── src/raw/screens/analytics.jsx ─────
function AnalyticsScreen() {
  return (
    <div className="content">
      <div className="page-head">
        <div className="title-block">
          <h1>Analytics 分析報表</h1>
          <p className="desc">RCS 全通路成效 · 通道、Agent、活動、地區、裝置維度</p>
        </div>
        <div className="actions">
          <div className="seg">
            <button>今日</button>
            <button>7d</button>
            <button className="active">30d</button>
            <button>90d</button>
          </div>
          <button className="btn"><Icons.Filter size={14}/> 維度</button>
          <button className="btn"><Icons.Download size={14}/> 匯出</button>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 12, marginBottom: 14 }}>
        {DATA.kpis.map((k, i) => <Kpi key={i} {...k} />)}
      </div>

      <div className="chart-frame" style={{ marginBottom: 14 }}>
        <div className="row" style={{ alignItems: "center", marginBottom: 14 }}>
          <strong className="flex-1" style={{ fontFamily: "var(--font-sans)", fontSize: 13 }}>送達 / 開啟 / 點擊 (30d)</strong>
          <div className="legend-row">
            <span><span className="sw" style={{ background: "#7C5CFF" }}></span>Sent</span>
            <span><span className="sw" style={{ background: "#00D1B3" }}></span>Delivered</span>
            <span><span className="sw" style={{ background: "#38BDF8" }}></span>Read</span>
          </div>
        </div>
        <AreaChart
          series={[
            { name: "sent", data: DATA.series30d.sent },
            { name: "delivered", data: DATA.series30d.delivered },
            { name: "read", data: DATA.series30d.read },
          ]}
          colors={["#7C5CFF", "#00D1B3", "#38BDF8"]}
          height={260}
        />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr 1fr", gap: 12, marginBottom: 14 }}>
        <div className="chart-frame">
          <div className="row" style={{ alignItems: "baseline", marginBottom: 12 }}>
            <strong className="flex-1" style={{ fontFamily: "var(--font-sans)", fontSize: 13 }}>轉換漏斗</strong>
            <span className="muted mono-sm">12.1× ROAS</span>
          </div>
          <Funnel rows={DATA.funnel} />
        </div>

        <div className="chart-frame">
          <strong style={{ fontFamily: "var(--font-sans)", fontSize: 13 }}>通道分佈</strong>
          <div style={{ display: "flex", justifyContent: "center", padding: "10px 0 14px" }}>
            <Donut data={DATA.channels} label="1.28M" sub="總傳送量" />
          </div>
          <div className="col gap-6">
            {DATA.channels.map(c => (
              <div key={c.name} className="row" style={{ alignItems: "center", fontSize: 11.5 }}>
                <span style={{ display: "inline-block", width: 8, height: 8, background: c.color, borderRadius: 2, marginRight: 8 }}></span>
                <span className="flex-1">{c.name}</span>
                <span className="mono-sm">{c.value}%</span>
              </div>
            ))}
          </div>
        </div>

        <div className="chart-frame">
          <strong style={{ fontFamily: "var(--font-sans)", fontSize: 13 }}>互動熱區</strong>
          <div style={{ marginTop: 10 }}>
            <Heatmap />
          </div>
          <div style={{ marginTop: 12, padding: 10, background: "var(--surface-2)", borderRadius: 8, fontSize: 11.5 }}>
            <Icons.Sparkles size={12} style={{ color: "var(--primary)", marginRight: 4, verticalAlign: "middle" }} />
            <span className="muted">最佳傳送時段</span>: <strong>週四 19:00–21:00</strong> · CTR 28.4%
          </div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
        {/* Top campaigns */}
        <div className="card">
          <div className="card-head">
            <h3>活動排名 · 30d</h3>
            <div className="spacer"></div>
            <select className="input" defaultValue="rev" style={{ width: 130, padding: "4px 8px", fontSize: 11 }}>
              <option value="rev">依營收</option>
              <option>依 CTR</option>
              <option>依送達率</option>
              <option>依傳送量</option>
            </select>
          </div>
          <table className="data">
            <thead>
              <tr><th>#</th><th>活動</th><th className="right">傳送</th><th className="right">CTR</th><th className="right">營收</th><th></th></tr>
            </thead>
            <tbody>
              {DATA.campaigns.filter(c => c.revenue > 0).sort((a,b) => b.revenue - a.revenue).slice(0, 6).map((c, i) => (
                <tr key={c.id}>
                  <td className="mono muted">{String(i+1).padStart(2,"0")}</td>
                  <td><strong style={{ fontSize: 12 }}>{c.name}</strong></td>
                  <td className="right mono">{(c.sent/1000).toFixed(1)}k</td>
                  <td className="right mono" style={{ color: "var(--text)" }}>{c.ctr}%</td>
                  <td className="right mono" style={{ color: "var(--success)" }}>${(c.revenue/1000).toFixed(1)}k</td>
                  <td><Sparkline data={[8,12,14,18,22,26,30,28,32,34]} width={50} height={18} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Geo */}
        <div className="card">
          <div className="card-head">
            <h3>地區分佈</h3>
            <span className="sub">依國家</span>
          </div>
          <div style={{ padding: 14 }}>
            {[
              { c: "🇹🇼", n: "台灣", val: 924102, pct: 71.9, ctr: 19.4 },
              { c: "🇭🇰", n: "香港", val: 184210, pct: 14.3, ctr: 22.1 },
              { c: "🇸🇬", n: "新加坡", val: 92841, pct: 7.2, ctr: 18.7 },
              { c: "🇺🇸", n: "美國", val: 48210, pct: 3.7, ctr: 12.3 },
              { c: "🇯🇵", n: "日本", val: 28140, pct: 2.2, ctr: 9.8 },
              { c: "🌐", n: "其他", val: 7007, pct: 0.7, ctr: 14.2 },
            ].map((g, i) => (
              <div key={i} style={{ padding: "8px 0", borderBottom: i < 5 ? "1px solid var(--border-soft)" : 0 }}>
                <div className="row" style={{ alignItems: "center", marginBottom: 5 }}>
                  <span style={{ fontSize: 16, marginRight: 8 }}>{g.c}</span>
                  <span className="flex-1" style={{ fontSize: 12, fontWeight: 500 }}>{g.n}</span>
                  <span className="mono-sm" style={{ color: "var(--text-2)", marginRight: 12 }}>CTR {g.ctr}%</span>
                  <span className="mono" style={{ fontWeight: 600, fontSize: 12 }}>{g.val.toLocaleString()}</span>
                </div>
                <div style={{ height: 4, background: "var(--surface-2)", borderRadius: 2 }}>
                  <div style={{ width: `${g.pct}%`, height: "100%", background: "linear-gradient(90deg, var(--primary), var(--accent))", borderRadius: 2 }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Device + Failure breakdown */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1.5fr", gap: 12 }}>
        <div className="card">
          <div className="card-head">
            <h3>裝置分佈</h3>
          </div>
          <div style={{ padding: 14 }}>
            {[
              { n: "Android RCS", v: 68.4, c: "#22C55E" },
              { n: "iPhone RCS (Apple Messaging for Business)", v: 18.2, c: "#7C5CFF" },
              { n: "SMS Fallback", v: 11.4, c: "#38BDF8" },
              { n: "其他", v: 2.0, c: "#5C637A" },
            ].map((d, i) => (
              <div key={i} style={{ padding: "8px 0" }}>
                <div className="row" style={{ alignItems: "center", marginBottom: 4 }}>
                  <span style={{ display: "inline-block", width: 8, height: 8, background: d.c, borderRadius: 2, marginRight: 8 }}></span>
                  <span className="flex-1" style={{ fontSize: 12 }}>{d.n}</span>
                  <span className="mono-sm" style={{ fontWeight: 600 }}>{d.v}%</span>
                </div>
                <div style={{ height: 4, background: "var(--surface-2)", borderRadius: 2 }}>
                  <div style={{ width: `${d.v}%`, height: "100%", background: d.c, borderRadius: 2 }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <div className="card-head">
            <h3>傳送失敗分析</h3>
            <span className="sub">過去 30 天</span>
            <div className="spacer"></div>
            <span className="badge danger"><span className="dot"></span>4.17% 失敗率</span>
          </div>
          <table className="data">
            <thead>
              <tr><th>錯誤碼</th><th>描述</th><th className="right">次數</th><th className="right">佔比</th><th>建議</th></tr>
            </thead>
            <tbody>
              {[
                ["30007", "Recipient unreachable on RCS", 24102, 45.1, "啟用 SMS fallback"],
                ["30022", "Region not supported", 12841, 24.0, "更新 Agent 地區設定"],
                ["30005", "Recipient opted out", 8240, 15.4, "從受眾名單移除"],
                ["30003", "Unverified sender", 4210, 7.9, "完成 Agent 驗證"],
                ["30006", "Template not approved", 2814, 5.3, "重新送審範本"],
                ["其他", "Misc errors", 1219, 2.3, "—"],
              ].map(([code, desc, n, pct, fix], i) => (
                <tr key={i}>
                  <td><span className="mono" style={{ color: "var(--danger)" }}>{code}</span></td>
                  <td>{desc}</td>
                  <td className="right mono">{n.toLocaleString()}</td>
                  <td className="right mono">{pct}%</td>
                  <td><span className="muted mono-sm">{fix}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}



// ───── src/raw/screens/logs.jsx ─────
function LogsScreen() {
  const [selected, setSelected] = useStateLog(0);
  const [filter, setFilter] = useStateLog("all");
  const log = DATA.logs[selected];

  const rows = DATA.logs.filter(l => filter === "all" ? true : l.status === filter);

  return (
    <div className="content">
      <div className="page-head">
        <div className="title-block">
          <h1>Logs 傳送紀錄</h1>
          <p className="desc">即時 message events · 單筆查詢 · 重新傳送</p>
        </div>
        <div className="actions">
          <button className="btn"><Icons.Refresh size={14}/> 即時 (Tail)</button>
          <button className="btn"><Icons.Download size={14}/> 匯出</button>
        </div>
      </div>

      <div className="row" style={{ marginBottom: 12, gap: 8, alignItems: "center" }}>
        <div className="searchbox" style={{ minWidth: 280 }}>
          <Icons.Search size={13}/>
          <input placeholder="搜尋 Message SID、電話、Webhook ID..." defaultValue=""/>
        </div>
        <select className="input" style={{ width: 130, padding: "5px 10px" }} defaultValue="all">
          <option>全部 Agent</option>
          <option>ShopMart 官方</option>
          <option>ShopMart Auth</option>
        </select>
        <div className="tabs">
          {[
            { id: "all", l: "全部", c: DATA.logs.length },
            { id: "delivered", l: "Delivered" },
            { id: "read", l: "Read" },
            { id: "failed", l: "Failed" },
            { id: "fallback_sms", l: "Fallback" },
          ].map(t => (
            <div key={t.id} className={`tab ${filter === t.id ? "active" : ""}`} onClick={() => setFilter(t.id)}>
              {t.l}{t.c && <span className="count">{t.c}</span>}
            </div>
          ))}
        </div>
        <div className="spacer"></div>
        <span className="muted mono-sm"><span className="status-dot success" style={{ marginRight: 4 }}></span> 即時串流 · 234 evt/s</span>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 420px", gap: 12 }}>
        <div className="table-wrap">
          <table className="data">
            <thead>
              <tr>
                <th style={{ width: 110 }}>時間</th>
                <th>收件人</th>
                <th>範本 / Agent</th>
                <th>狀態</th>
                <th className="right">Cost</th>
                <th>Message SID</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((l, i) => (
                <tr key={i} onClick={() => setSelected(DATA.logs.indexOf(l))}
                    style={{ cursor: "pointer", background: DATA.logs.indexOf(l) === selected ? "var(--surface-hover)" : undefined }}>
                  <td><span className="mono-sm">{l.ts}</span></td>
                  <td><span className="mono">{l.to}</span></td>
                  <td>
                    <div className="col gap-4">
                      <span className="mono-sm">{l.template}</span>
                      <span className="muted mono-sm" style={{ fontSize: 10 }}>{l.agent}</span>
                    </div>
                  </td>
                  <td><StatusBadge status={l.status}/></td>
                  <td className="right mono">{l.cost}</td>
                  <td><span className="mono-sm" style={{ color: "var(--text-3)" }}>{l.msgSid}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="row" style={{ padding: "10px 14px", borderTop: "1px solid var(--border)", alignItems: "center", color: "var(--text-3)", fontSize: 11.5 }}>
            <span>{rows.length} of 1,284,510 events · 最新 5 分鐘</span>
            <div className="spacer"></div>
            <span>每頁</span>
            <select style={{ background: "transparent", color: "var(--text-2)", border: "1px solid var(--border)", borderRadius: 4, padding: "2px 4px", marginLeft: 6, marginRight: 12 }}>
              <option>50</option><option>100</option><option>500</option>
            </select>
            <button className="btn sm"><Icons.ChevLeft size={12}/></button>
            <button className="btn sm" style={{ marginLeft: 4 }}><Icons.ChevRight size={12}/></button>
          </div>
        </div>

        {/* Detail panel */}
        <div className="card" style={{ position: "sticky", top: 70, alignSelf: "start", maxHeight: "calc(100vh - 100px)", overflow: "auto" }}>
          <div className="card-head">
            <h3>Message 詳情</h3>
            <div className="spacer"></div>
            <StatusBadge status={log.status} />
          </div>
          <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 12 }}>
            <div>
              <div className="muted mono-sm" style={{ fontSize: 10, marginBottom: 4 }}>MESSAGE SID</div>
              <div className="row" style={{ alignItems: "center", gap: 6 }}>
                <span className="mono" style={{ fontSize: 12 }}>{log.msgSid}</span>
                <button className="icon-btn" style={{ width: 22, height: 22 }}><Icons.Copy size={12}/></button>
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <div>
                <div className="muted mono-sm" style={{ fontSize: 10 }}>TIMESTAMP</div>
                <div className="mono-sm" style={{ color: "var(--text)" }}>2026-05-19 {log.ts}</div>
              </div>
              <div>
                <div className="muted mono-sm" style={{ fontSize: 10 }}>COST</div>
                <div className="mono-sm" style={{ color: "var(--text)" }}>{log.cost} USD</div>
              </div>
              <div>
                <div className="muted mono-sm" style={{ fontSize: 10 }}>TO</div>
                <div className="mono-sm" style={{ color: "var(--text)" }}>{log.to}</div>
              </div>
              <div>
                <div className="muted mono-sm" style={{ fontSize: 10 }}>AGENT</div>
                <div className="mono-sm" style={{ color: "var(--text)" }}>{log.agent}</div>
              </div>
              <div>
                <div className="muted mono-sm" style={{ fontSize: 10 }}>TEMPLATE</div>
                <div className="mono-sm" style={{ color: "var(--primary)" }}>{log.template} →</div>
              </div>
              <div>
                <div className="muted mono-sm" style={{ fontSize: 10 }}>SEGMENTS</div>
                <div className="mono-sm" style={{ color: "var(--text)" }}>{log.segs}</div>
              </div>
            </div>

            {log.error && (
              <div style={{ padding: 10, background: "var(--danger-soft)", borderRadius: 8, color: "var(--danger)", fontSize: 12 }}>
                <div className="mono-sm" style={{ fontWeight: 600, marginBottom: 4 }}>Error {log.code}</div>
                <div>{log.error}</div>
              </div>
            )}

            <div>
              <div className="muted mono-sm" style={{ fontSize: 10, marginBottom: 8 }}>EVENT TIMELINE</div>
              <div style={{ position: "relative", paddingLeft: 16, borderLeft: "1px solid var(--border)" }}>
                {[
                  { t: "12:42:07.812", e: "accepted", c: "var(--text-3)" },
                  { t: "12:42:07.834", e: "queued", c: "var(--text-3)" },
                  { t: "12:42:07.892", e: "sending", c: "var(--info)" },
                  { t: "12:42:07.992", e: "sent → Google RCS", c: "var(--info)" },
                  ...(log.status === "failed" ? [{ t: "12:42:08.041", e: `failed (${log.code})`, c: "var(--danger)" }] :
                      log.status === "fallback_sms" ? [{ t: "12:42:08.041", e: "RCS unavailable, fell back to SMS", c: "var(--warning)" }] :
                      [
                        { t: "12:42:08.041", e: "delivered", c: "var(--success)" },
                        ...(log.status === "read" ? [{ t: "12:43:12.220", e: "read", c: "var(--info)" }] : [])
                      ])
                ].map((ev, i) => (
                  <div key={i} style={{ position: "relative", paddingBottom: 10 }}>
                    <span style={{ position: "absolute", left: -20, top: 4, width: 8, height: 8, borderRadius: 50, background: ev.c, border: "2px solid var(--surface)" }}></span>
                    <div className="mono-sm" style={{ fontSize: 11, color: ev.c, fontWeight: 600 }}>{ev.e}</div>
                    <div className="mono-sm muted" style={{ fontSize: 10 }}>{ev.t}</div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <div className="muted mono-sm" style={{ fontSize: 10, marginBottom: 6 }}>RAW PAYLOAD</div>
              <pre className="codeblock" style={{ fontSize: 10.5, maxHeight: 200 }}>{`{
  "sid": "${log.msgSid}",
  "to": "${log.to}",
  "from": "rcs:${log.agent}",
  "status": "${log.status}",
  "errorCode": ${log.error ? `"${log.code}"` : "null"},
  "templateSid": "${log.template}",
  "numSegments": ${log.segs},
  "price": "${log.cost}",
  "dateCreated": "2026-05-19T${log.ts}Z"
}`}</pre>
            </div>

            <div className="row gap-6">
              <button className="btn flex-1"><Icons.Refresh size={12}/> 重送</button>
              <button className="btn flex-1"><Icons.ExternalLink size={12}/> 開啟對話</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// ───── src/raw/screens/agents.jsx ─────
function AgentsScreen() {
  return (
    <div className="content">
      <div className="page-head">
        <div className="title-block">
          <h1>RCS Agents 品牌代理人</h1>
          <p className="desc">註冊、驗證 RCS Business Messaging agents · 管理寄件人、品牌資產、地區</p>
        </div>
        <div className="actions">
          <button className="btn"><Icons.ExternalLink size={14}/> Carrier 文件</button>
          <button className="btn primary"><Icons.Plus size={14}/> 新 Agent</button>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 14 }}>
        <Kpi label="Total Agents" value={DATA.agents.length.toString()} sub="2 region pending" />
        <Kpi label="Verified" value="3" sub="of 4" delta="+1" dir="up" />
        <Kpi label="Monthly Active Users" value="695k" delta="+12%" dir="up" sub="all agents" />
        <Kpi label="Brand Approval Rate" value="92%" sub="vs industry 78%" delta="+4%" dir="up" />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
        {DATA.agents.map(a => (
          <div className="card" key={a.id}>
            <div style={{ padding: 16, display: "flex", gap: 14 }}>
              <div style={{
                width: 56, height: 56, borderRadius: 14,
                background: `linear-gradient(135deg, ${a.color}, ${a.color}aa)`,
                display: "grid", placeItems: "center", color: "white",
                fontWeight: 700, fontSize: 22, fontFamily: "var(--font-sans)",
                flex: "0 0 auto", position: "relative",
                boxShadow: `0 4px 16px ${a.color}40`,
              }}>
                {a.name.slice(0, 1)}
                {a.verified && (
                  <span style={{
                    position: "absolute", right: -3, bottom: -3,
                    width: 18, height: 18, borderRadius: "50%",
                    background: "#1F73E8", border: "2px solid var(--surface)",
                    color: "white", display: "grid", placeItems: "center"
                  }}>
                    <Icons.Check size={10} stroke={3} />
                  </span>
                )}
              </div>

              <div className="col flex-1 gap-4" style={{ minWidth: 0 }}>
                <div className="row gap-8" style={{ alignItems: "center" }}>
                  <strong style={{ fontSize: 14, fontFamily: "var(--font-sans)" }}>{a.name}</strong>
                  <StatusBadge status={a.status === "in_review" ? "in_review" : "live"} />
                </div>
                <span className="muted mono-sm">{a.id}</span>
                <div className="row gap-8" style={{ marginTop: 8, flexWrap: "wrap" }}>
                  <span className="badge outline">{a.brand}</span>
                  {a.regions.map(r => <span key={r} className="badge primary">{r}</span>)}
                  <span className="badge outline">{a.senders} senders</span>
                </div>
              </div>

              <div className="col" style={{ alignItems: "flex-end", gap: 4 }}>
                <span className="mono" style={{ fontWeight: 600, fontSize: 16 }}>{a.mau ? `${(a.mau/1000).toFixed(0)}k` : "—"}</span>
                <span className="muted mono-sm" style={{ fontSize: 10 }}>MAU</span>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 0, borderTop: "1px solid var(--border-soft)" }}>
              {[
                { l: "Display name", v: a.name },
                { l: "RBM brand", v: a.brand },
                { l: "Logo", v: "✓ 上傳" },
                { l: "隱私政策", v: "✓ 已設" },
              ].map((m, i) => (
                <div key={i} style={{ padding: "10px 14px", borderRight: i < 3 ? "1px solid var(--border-soft)" : 0 }}>
                  <div className="muted mono-sm" style={{ fontSize: 9.5 }}>{m.l.toUpperCase()}</div>
                  <div style={{ fontSize: 12, fontWeight: 500, marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{m.v}</div>
                </div>
              ))}
            </div>

            <div style={{ padding: "10px 14px", borderTop: "1px solid var(--border-soft)", display: "flex", gap: 6 }}>
              <button className="btn sm"><Icons.Settings size={11}/> 設定</button>
              <button className="btn sm"><Icons.Send size={11}/> 測試訊息</button>
              <button className="btn sm"><Icons.Eye size={11}/> 預覽資料</button>
              <div className="spacer"></div>
              <button className="icon-btn"><Icons.More size={14}/></button>
            </div>
          </div>
        ))}

        {/* Add card */}
        <div style={{
          border: "1.5px dashed var(--border-strong)",
          borderRadius: "var(--r-lg)",
          display: "grid", placeItems: "center",
          padding: 40, cursor: "pointer",
          color: "var(--text-3)"
        }}>
          <div style={{ textAlign: "center" }}>
            <Icons.Plus size={24} />
            <div style={{ marginTop: 8, fontWeight: 600, fontSize: 13 }}>註冊新 Agent</div>
            <div style={{ fontSize: 11, marginTop: 2 }}>提交 Google RBM / Apple MfB 審核</div>
          </div>
        </div>
      </div>

      {/* Verification checklist */}
      <div className="card" style={{ marginTop: 14 }}>
        <div className="card-head">
          <h3>驗證進度 · ShopMart 促銷活動</h3>
          <div className="spacer"></div>
          <StatusBadge status="in_review" />
        </div>
        <div style={{ padding: 14 }}>
          <div style={{ height: 6, background: "var(--surface-2)", borderRadius: 3, marginBottom: 14 }}>
            <div style={{ width: "60%", height: "100%", background: "linear-gradient(90deg, var(--primary), var(--accent))", borderRadius: 3 }}></div>
          </div>
          {[
            { l: "品牌資料 (名稱、Logo、顏色)", s: "done" },
            { l: "RCS Agent description 與分類", s: "done" },
            { l: "範例訊息 (5+)", s: "done" },
            { l: "隱私政策 / TOS URL", s: "done" },
            { l: "聯絡資訊 (客服 email/phone)", s: "done" },
            { l: "Carrier 審核 — TW (Chunghwa, Taiwan Mobile, FET)", s: "pending" },
            { l: "Google RBM Brand 驗證", s: "pending" },
            { l: "Live launch", s: "todo" },
          ].map((item, i) => (
            <div key={i} className="row" style={{ alignItems: "center", padding: "8px 0", borderBottom: i < 7 ? "1px solid var(--border-soft)" : 0 }}>
              <span style={{
                width: 18, height: 18, borderRadius: "50%",
                background: item.s === "done" ? "var(--success)" : item.s === "pending" ? "var(--warning)" : "var(--surface-3)",
                color: item.s === "todo" ? "var(--text-3)" : "white",
                display: "grid", placeItems: "center",
                fontSize: 10, fontWeight: 700, marginRight: 10
              }}>{item.s === "done" ? "✓" : item.s === "pending" ? "·" : i+1}</span>
              <span className="flex-1" style={{ fontSize: 12.5 }}>{item.l}</span>
              <StatusBadge status={item.s === "done" ? "approved" : item.s === "pending" ? "pending" : "draft"} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}



// ───── src/raw/screens/webhooks.jsx ─────
function WebhooksScreen() {
  const [tab, setTab] = useStateWh("webhooks");

  return (
    <div className="content">
      <div className="page-head">
        <div className="title-block">
          <h1>Webhook & API 設定</h1>
          <p className="desc">事件訂閱、API 金鑰、IP 白名單與安全</p>
        </div>
        <div className="actions">
          <button className="btn"><Icons.ExternalLink size={14}/> API 文件</button>
        </div>
      </div>

      <div className="tabs" style={{ marginBottom: 14 }}>
        {[
          { id: "webhooks", l: "Webhooks", c: DATA.webhooks.length },
          { id: "keys", l: "API Keys", c: 3 },
          { id: "events", l: "事件參考" },
          { id: "security", l: "安全與 IP" },
        ].map(t => (
          <div key={t.id} className={`tab ${tab === t.id ? "active" : ""}`} onClick={() => setTab(t.id)}>
            {t.l}{t.c !== undefined && <span className="count">{t.c}</span>}
          </div>
        ))}
      </div>

      {tab === "webhooks" && <WebhooksList />}
      {tab === "keys" && <ApiKeys />}
      {tab === "events" && <EventReference />}
      {tab === "security" && <SecurityPane />}
    </div>
  );
}

function WebhooksList() {
  return (
    <div>
      <div className="row" style={{ alignItems: "center", marginBottom: 12 }}>
        <span className="muted mono-sm">{DATA.webhooks.length} active webhook endpoints · 99.4% delivery 24h</span>
        <div className="spacer"></div>
        <button className="btn primary"><Icons.Plus size={14}/> 新 Webhook</button>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {DATA.webhooks.map(wh => (
          <div className="card" key={wh.id}>
            <div style={{ padding: 14, display: "grid", gridTemplateColumns: "1fr auto", gap: 14, alignItems: "center" }}>
              <div className="col gap-4" style={{ minWidth: 0 }}>
                <div className="row gap-8" style={{ alignItems: "center" }}>
                  <Icons.Webhook size={14} style={{ color: "var(--primary)" }} />
                  <strong style={{ fontSize: 13 }}>{wh.name}</strong>
                  <StatusBadge status={wh.status} />
                </div>
                <div className="row gap-4" style={{ alignItems: "center", marginTop: 2, minWidth: 0 }}>
                  <span className="mono-sm" style={{ color: "var(--text-2)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{wh.url}</span>
                  <button className="icon-btn" style={{ width: 22, height: 22, flex: "0 0 auto" }}><Icons.Copy size={11}/></button>
                </div>
                <div className="row gap-4" style={{ marginTop: 8, flexWrap: "wrap" }}>
                  {wh.events.map(e => <span key={e} className="badge outline mono-sm" style={{ fontSize: 9.5 }}>{e}</span>)}
                </div>
              </div>
              <div className="col" style={{ alignItems: "flex-end", gap: 6 }}>
                <div className="row gap-12">
                  <div style={{ textAlign: "right" }}>
                    <div className="mono-sm muted" style={{ fontSize: 10 }}>SUCCESS</div>
                    <div className="mono" style={{ fontWeight: 600, color: wh.successRate > 99 ? "var(--success)" : "var(--warning)" }}>{wh.successRate}%</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div className="mono-sm muted" style={{ fontSize: 10 }}>LAST</div>
                    <div className="mono-sm">{wh.lastDelivered}</div>
                  </div>
                </div>
                <div className="row gap-6">
                  <button className="btn sm"><Icons.Eye size={11}/> 紀錄</button>
                  <button className="btn sm"><Icons.Send size={11}/> 測試</button>
                  <button className="btn sm"><Icons.Edit size={11}/> 編輯</button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Recent deliveries */}
      <div className="card" style={{ marginTop: 14 }}>
        <div className="card-head">
          <h3>最近 Webhook 事件</h3>
          <div className="spacer"></div>
          <button className="btn sm"><Icons.Refresh size={12}/></button>
        </div>
        <table className="data">
          <thead>
            <tr>
              <th>時間</th>
              <th>Endpoint</th>
              <th>事件</th>
              <th>狀態</th>
              <th className="right">延遲</th>
              <th>HTTP</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {[
              { ts: "12:42:08", ep: "Delivery Receipt → CRM", e: "message.read", st: "success", lat: "84ms", code: "200" },
              { ts: "12:42:07", ep: "Inbound RCS → Helpdesk", e: "message.received", st: "success", lat: "142ms", code: "200" },
              { ts: "12:42:07", ep: "Delivery Receipt → CRM", e: "message.delivered", st: "success", lat: "92ms", code: "200" },
              { ts: "12:42:06", ep: "Delivery Receipt → CRM", e: "message.failed", st: "retry", lat: "5.2s", code: "503" },
              { ts: "12:42:05", ep: "Conversion → DataLake", e: "postback.cta_clicked", st: "success", lat: "210ms", code: "200" },
              { ts: "12:42:04", ep: "Inbound RCS → Helpdesk", e: "message.received", st: "success", lat: "98ms", code: "200" },
            ].map((d, i) => (
              <tr key={i}>
                <td className="mono-sm">{d.ts}</td>
                <td><strong style={{ fontSize: 12 }}>{d.ep}</strong></td>
                <td><span className="mono-sm">{d.e}</span></td>
                <td>
                  {d.st === "success" ? <span className="badge success"><span className="dot"></span>200 OK</span>
                   : d.st === "retry" ? <span className="badge warning"><span className="dot"></span>retry</span>
                   : <span className="badge danger">failed</span>}
                </td>
                <td className="right mono-sm">{d.lat}</td>
                <td><span className="mono" style={{ color: d.code === "200" ? "var(--success)" : "var(--danger)" }}>{d.code}</span></td>
                <td><button className="icon-btn"><Icons.Eye size={13}/></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ApiKeys() {
  const keys = [
    { name: "Production Server", id: "SK1a04...e9b2", role: "Full Access", created: "2025-08-14", lastUsed: "2 sec ago", env: "live" },
    { name: "Staging Test Bot", id: "SKtest_4b9...2c1", role: "Send Only", created: "2025-11-02", lastUsed: "12 min ago", env: "test" },
    { name: "Analytics Read-Only", id: "SKread_92a...c7e", role: "Read Only", created: "2026-02-21", lastUsed: "3 hours ago", env: "live" },
  ];
  return (
    <div>
      <div className="row" style={{ alignItems: "center", marginBottom: 12 }}>
        <div className="env-pill" style={{ marginRight: 12 }}>
          <span className="live-dot"></span> Live 環境
        </div>
        <span className="muted mono-sm">Account SID · <code>AC2a04b821e8c4d2ef1a04b821e8c4d2ef</code></span>
        <div className="spacer"></div>
        <button className="btn primary"><Icons.Plus size={14}/> 建立 API Key</button>
      </div>

      <div className="card" style={{ marginBottom: 14 }}>
        <table className="data">
          <thead>
            <tr><th>名稱</th><th>金鑰 SID</th><th>權限</th><th>環境</th><th>建立日期</th><th>最後使用</th><th></th></tr>
          </thead>
          <tbody>
            {keys.map((k, i) => (
              <tr key={i}>
                <td><strong style={{ fontSize: 12.5 }}>{k.name}</strong></td>
                <td>
                  <div className="row gap-4" style={{ alignItems: "center" }}>
                    <Icons.Lock size={11} style={{ color: "var(--text-3)" }} />
                    <span className="mono">{k.id}</span>
                    <button className="icon-btn" style={{ width: 22, height: 22 }}><Icons.Copy size={11}/></button>
                  </div>
                </td>
                <td><span className="badge outline">{k.role}</span></td>
                <td>{k.env === "live" ? <span className="badge success">{k.env}</span> : <span className="badge warning">{k.env}</span>}</td>
                <td><span className="muted mono-sm">{k.created}</span></td>
                <td><span className="mono-sm">{k.lastUsed}</span></td>
                <td className="right">
                  <button className="btn sm">Rotate</button>
                  <button className="btn sm danger" style={{ marginLeft: 4 }}>Revoke</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="card">
        <div className="card-head">
          <h3>快速開始 · cURL</h3>
          <div className="spacer"></div>
          <button className="btn sm"><Icons.Copy size={12}/> 複製</button>
        </div>
        <div style={{ padding: 14 }}>
          <pre className="codeblock"><span className="c"># 傳送 RCS Rich Card</span>{`
`}<span className="p">curl</span>{` -X POST https://content.twilio.com/v1/Messages \\
  -u $ACCOUNT_SID:$AUTH_TOKEN \\
  --data-urlencode `}<span className="s">{`"To=rcs:+886912345678"`}</span>{` \\
  --data-urlencode `}<span className="s">{`"From=rcs:agt_shopmart_official"`}</span>{` \\
  --data-urlencode `}<span className="s">{`"ContentSid=HX2a04b821e8c4d2ef"`}</span>{` \\
  --data-urlencode `}<span className="s">{`'ContentVariables={"first_name":"Maya","order_id":"SM2026-1042"}'`}</span></pre>
        </div>
      </div>
    </div>
  );
}

function EventReference() {
  const events = [
    { name: "message.queued", desc: "訊息已接收並加入傳送佇列" },
    { name: "message.sending", desc: "正透過 Google RBM / Apple MfB 傳送" },
    { name: "message.sent", desc: "已成功送出至上游 carrier" },
    { name: "message.delivered", desc: "成功送達使用者裝置" },
    { name: "message.read", desc: "使用者已讀訊息 (RCS 雙勾)" },
    { name: "message.failed", desc: "傳送失敗,含 errorCode 與重試資訊" },
    { name: "message.received", desc: "用戶端傳入訊息 (含 inbound text/media/postback)" },
    { name: "message.fallback_sent", desc: "RCS 不可達,已 fallback 至 SMS" },
    { name: "postback.cta_clicked", desc: "用戶點擊 Rich Card / Carousel CTA" },
    { name: "postback.suggested_reply", desc: "用戶點擊 Suggested Reply" },
    { name: "agent.verified", desc: "Agent 經 carrier 驗證通過" },
    { name: "audience.synced", desc: "Segment 重新同步完成" },
  ];
  return (
    <div className="card">
      <table className="data">
        <thead><tr><th style={{ width: "30%" }}>事件名稱</th><th>說明</th><th></th></tr></thead>
        <tbody>
          {events.map((e, i) => (
            <tr key={i}>
              <td><span className="mono" style={{ color: "var(--primary)" }}>{e.name}</span></td>
              <td>{e.desc}</td>
              <td className="right"><button className="btn sm"><Icons.ExternalLink size={11}/> 範例 payload</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function SecurityPane() {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr", gap: 12 }}>
      <div className="card">
        <div className="card-head"><h3>IP 白名單</h3><span className="sub">允許呼叫 API 的伺服器 IP</span></div>
        <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 8 }}>
          {[
            { ip: "203.74.221.18", label: "Production · Singapore", added: "2025-08-14" },
            { ip: "203.74.221.19", label: "Production · Singapore", added: "2025-08-14" },
            { ip: "13.124.88.0/24", label: "AWS Seoul CIDR", added: "2025-09-22" },
            { ip: "10.0.4.0/22", label: "VPN · 內部開發機", added: "2026-01-08" },
          ].map((r, i) => (
            <div key={i} className="row" style={{ padding: 10, background: "var(--surface-2)", borderRadius: 8, alignItems: "center" }}>
              <Icons.Globe size={14} style={{ color: "var(--text-3)", marginRight: 8 }} />
              <div className="col flex-1 gap-4">
                <span className="mono" style={{ fontSize: 12 }}>{r.ip}</span>
                <span className="muted mono-sm">{r.label}</span>
              </div>
              <span className="muted mono-sm">{r.added}</span>
              <button className="btn sm danger" style={{ marginLeft: 10 }}><Icons.Trash size={11}/></button>
            </div>
          ))}
          <button className="btn"><Icons.Plus size={13}/> 新增 IP / CIDR</button>
        </div>
      </div>

      <div className="card">
        <div className="card-head"><h3>Webhook 簽章驗證</h3></div>
        <div style={{ padding: 14 }}>
          <div className="field" style={{ marginBottom: 12 }}>
            <label>簽章演算法</label>
            <select className="input" defaultValue="hmac-sha256"><option>hmac-sha256</option><option>hmac-sha1</option></select>
          </div>
          <div className="field" style={{ marginBottom: 12 }}>
            <label>共用密鑰</label>
            <div className="input-row">
              <input className="input mono" type="password" defaultValue="whsec_2a04b821e8c4d2ef1a04b821e8c4d2ef" />
              <button className="btn" style={{ borderLeft: 0, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}><Icons.Eye size={12}/></button>
            </div>
            <div className="hint">在所有 webhook header `X-Twilio-Signature` 中驗證</div>
          </div>
          <div className="row gap-8" style={{ alignItems: "center", padding: 10, background: "var(--surface-2)", borderRadius: 8 }}>
            <span className="switch on"></span>
            <span style={{ fontSize: 12 }} className="flex-1">強制 TLS 1.3 + 簽章驗證</span>
          </div>
          <div className="row gap-8" style={{ alignItems: "center", padding: 10, background: "var(--surface-2)", borderRadius: 8, marginTop: 8 }}>
            <span className="switch on"></span>
            <span style={{ fontSize: 12 }} className="flex-1">失敗自動重試 (指數退避,最多 5 次)</span>
          </div>
        </div>
      </div>
    </div>
  );
}



// ───── src/raw/app.jsx ─────
const DEFAULTS = /*EDITMODE-BEGIN*/{
  "primaryColor": "#7C5CFF",
  "theme": "dark",
  "density": "compact",
  "previewDevice": "iPhone",
  "sidebarCollapsed": false
}/*EDITMODE-END*/;

const NAV = [
  { group: "MAIN", items: [
    { id: "dashboard", l: "Dashboard 總覽", icon: "Dashboard" },
    { id: "conversations", l: "對話收件匣", icon: "Inbox", badge: "6" },
    { id: "campaigns", l: "Campaigns 活動", icon: "Megaphone" },
    { id: "templates", l: "Templates 範本", icon: "Card" },
    { id: "audience", l: "Audience 受眾", icon: "Users" },
  ]},
  { group: "INSIGHTS", items: [
    { id: "analytics", l: "Analytics 報表", icon: "Chart" },
    { id: "logs", l: "Logs 紀錄", icon: "Logs" },
  ]},
  { group: "PLATFORM", items: [
    { id: "agents", l: "RCS Agents", icon: "Agent" },
    { id: "webhooks", l: "Webhooks / API", icon: "Webhook" },
    { id: "settings", l: "設定", icon: "Settings" },
  ]},
];

const CRUMBS = {
  dashboard:        ["首頁", "Dashboard"],
  conversations:    ["首頁", "Conversations Inbox"],
  campaigns:        ["首頁", "Campaigns"],
  campaign_new:     ["首頁", "Campaigns", "新活動"],
  templates:        ["首頁", "Templates"],
  template_edit:    ["首頁", "Templates", "編輯範本"],
  audience:         ["首頁", "Audience"],
  analytics:        ["首頁", "Analytics"],
  logs:             ["首頁", "Logs"],
  agents:           ["首頁", "RCS Agents"],
  webhooks:         ["首頁", "Webhooks / API"],
  settings:         ["首頁", "Settings"],
};

function App() {
  const [route, setRoute] = useState("dashboard");
  const [t, setTweak] = useTweaks(DEFAULTS);
  const [collapsed, setCollapsed] = useState(t.sidebarCollapsed);
  const [newMsgOpen, setNewMsgOpen] = useState(false);
  const [newMsgPreset, setNewMsgPreset] = useState({ to: "", type: "card" });

  // expose globally so any child screen can pop the modal
  window.openNewMessage = (preset = {}) => {
    setNewMsgPreset({ to: preset.to || "", type: preset.type || "card" });
    setNewMsgOpen(true);
  };

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", t.theme);
    document.documentElement.style.setProperty("--primary", t.primaryColor);
    document.documentElement.style.setProperty("--primary-hover", lighten(t.primaryColor, 12));
    document.documentElement.style.setProperty("--primary-soft", hexA(t.primaryColor, 0.14));
    document.documentElement.style.setProperty("--primary-ring", hexA(t.primaryColor, 0.35));
  }, [t.theme, t.primaryColor]);

  const screen = (() => {
    switch (route) {
      case "dashboard":     return <DashboardScreen go={setRoute}/>;
      case "conversations": return <ConversationsScreen/>;
      case "campaigns":     return <CampaignsScreen go={setRoute}/>;
      case "campaign_new":  return <CampaignBuilderScreen go={setRoute}/>;
      case "templates":     return <TemplatesScreen go={setRoute}/>;
      case "template_edit": return <TemplateEditorScreen go={setRoute}/>;
      case "audience":      return <AudienceScreen/>;
      case "analytics":     return <AnalyticsScreen/>;
      case "logs":          return <LogsScreen/>;
      case "agents":        return <AgentsScreen/>;
      case "webhooks":      return <WebhooksScreen/>;
      case "settings":      return <SettingsPlaceholder/>;
      default:              return <DashboardScreen go={setRoute}/>;
    }
  })();

  const isFlush = route === "conversations" || route === "campaign_new" || route === "template_edit";

  return (
    <div className="app" data-collapsed={collapsed}>
      <Sidebar route={route} setRoute={setRoute} collapsed={collapsed} />
      <div className="main">
        <Topbar route={route} setRoute={setRoute}
                onToggleSidebar={() => setCollapsed(v => !v)}
                onNewMessage={() => window.openNewMessage()}
                theme={t.theme} setTheme={(v) => setTweak("theme", v)} />
        {screen}
      </div>

      <TweaksPanel title="Tweaks">
        <TweakSection label="外觀">
          <TweakRadio label="主題" value={t.theme} options={[
            { value: "dark", label: "Dark" },
            { value: "light", label: "Light" },
          ]} onChange={(v) => setTweak("theme", v)} />
          <TweakColor label="主色" value={t.primaryColor}
                      options={["#7C5CFF","#00D1B3","#F22F46","#38BDF8","#22C55E","#F5A524"]}
                      onChange={(v) => setTweak("primaryColor", v)} />
          <TweakRadio label="資料密度" value={t.density} options={[
            { value: "compact", label: "緊湊" },
            { value: "comfortable", label: "舒適" },
          ]} onChange={(v) => setTweak("density", v)} />
        </TweakSection>
        <TweakSection label="預覽">
          <TweakRadio label="手機機型" value={t.previewDevice} options={[
            { value: "iPhone", label: "iPhone" },
            { value: "Android", label: "Android" },
          ]} onChange={(v) => setTweak("previewDevice", v)} />
        </TweakSection>
        <TweakSection label="導覽">
          <TweakToggle label="側欄收合" value={collapsed} onChange={(v) => { setCollapsed(v); setTweak("sidebarCollapsed", v); }} />
        </TweakSection>
      </TweaksPanel>

      <NewMessageModal open={newMsgOpen}
                       onClose={() => setNewMsgOpen(false)}
                       initialTo={newMsgPreset.to}
                       initialType={newMsgPreset.type} />
    </div>
  );
}

function Sidebar({ route, setRoute, collapsed }) {
  return (
    <aside className="sidebar" data-collapsed={collapsed}>
      <div className="sidebar-brand">
        <div className="brand-mark">
          <Icons.Logo />
        </div>
        <div className="brand-text">
          ShopMart RCS
          <span className="sub">Twilio · Console</span>
        </div>
      </div>

      <div className="sidebar-workspace">
        <div className="ws-avatar">SM</div>
        <div className="ws-name">ShopMart 台灣</div>
        <Icons.ChevDown size={12} className="ws-chev" />
      </div>

      <nav className="sidebar-nav">
        {NAV.map(g => (
          <div key={g.group} className="nav-group">
            <div className="nav-group-label">{g.group}</div>
            {g.items.map(item => {
              const Ico = Icons[item.icon];
              const isActive = route === item.id ||
                (item.id === "campaigns" && route === "campaign_new") ||
                (item.id === "templates" && route === "template_edit");
              return (
                <div key={item.id}
                     className={`nav-item ${isActive ? "active" : ""}`}
                     onClick={() => setRoute(item.id)}>
                  <Ico className="ico" />
                  <span className="label">{item.l}</span>
                  {item.badge && <span className="badge">{item.badge}</span>}
                </div>
              );
            })}
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-credit">
          <div className="credit-row">
            <span className="k">RCS 月度配額</span>
            <span className="v">68%</span>
          </div>
          <div className="credit-bar"><span style={{ width: "68%" }}></span></div>
          <div className="credit-foot">
            <span>1.28M / 1.88M</span>
            <span>$23,847</span>
          </div>
        </div>
        <div className="sidebar-user">
          <div className="avatar">MK</div>
          <div className="col flex-1 gap-4" style={{ minWidth: 0 }}>
            <span className="name">Maya Kuo</span>
            <span className="role">Marketing Lead</span>
          </div>
          <Icons.ChevDown size={12} style={{ color: "var(--text-3)" }} />
        </div>
      </div>
    </aside>
  );
}

function Topbar({ route, setRoute, onToggleSidebar, onTweaks, theme, setTheme }) {
  const crumbs = CRUMBS[route] || ["首頁"];
  return (
    <header className="topbar">
      <button className="icon-btn" onClick={onToggleSidebar} title="切換側欄"><Icons.Sidebar size={15}/></button>
      <div className="crumbs">
        {crumbs.map((c, i) => (
          <React.Fragment key={i}>
            <span className={i === 0 ? "home" : i === crumbs.length - 1 ? "now" : ""}>{c}</span>
            {i < crumbs.length - 1 && <Icons.ChevRight size={11} className="sep" />}
          </React.Fragment>
        ))}
      </div>
      <span className="env-pill" title="Live environment">
        <span className="live-dot"></span> LIVE
      </span>
      <div className="searchbox">
        <Icons.Search size={13} />
        <input placeholder="搜尋活動、聯絡人、Message SID..."/>
        <span className="kbd">⌘K</span>
      </div>
      <div className="topbar-actions">
        <button className="icon-btn" title="新建" onClick={() => setRoute("campaign_new")}><Icons.Plus size={15}/></button>
        <button className="icon-btn" title="切換主題" onClick={() => setTheme(theme === "dark" ? "light" : "dark")}>
          {theme === "dark" ? <Icons.Sun size={15}/> : <Icons.Moon size={15}/>}
        </button>
        <button className="icon-btn" title="通知"><Icons.Bell size={15}/><span className="dot"></span></button>
        <button className="icon-btn" title="求救"><Icons.Help size={15}/></button>
      </div>
    </header>
  );
}

function SettingsPlaceholder() {
  return (
    <div className="content">
      <div className="page-head">
        <div className="title-block">
          <h1>設定</h1>
          <p className="desc">Workspace 一般設定 · 成員 · 計費 · 整合</p>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {[
          { i: "Users", t: "成員與權限", d: "4 名管理員 · 12 名 Agent · 2 個自訂角色" },
          { i: "Coin", t: "計費與發票", d: "USD $23,847 本月 · 信用卡 ****4242" },
          { i: "Globe", t: "地區與時區", d: "Asia/Taipei (+08:00) · zh-TW 主要" },
          { i: "Bell", t: "通知偏好", d: "Slack #rcs-alerts · Email Maya" },
          { i: "Lock", t: "安全與 SSO", d: "SAML 2.0 已啟用 · 強制 2FA" },
          { i: "Link", t: "外部整合", d: "Snowflake · Segment · Klaviyo · Linear" },
        ].map((c, i) => {
          const Ico = Icons[c.i];
          return (
            <div key={i} className="card" style={{ padding: 16, cursor: "pointer" }}>
              <Ico size={20} style={{ color: "var(--primary)", marginBottom: 10 }} />
              <div style={{ fontWeight: 600, fontSize: 14, fontFamily: "var(--font-sans)" }}>{c.t}</div>
              <div className="muted" style={{ fontSize: 12, marginTop: 4 }}>{c.d}</div>
              <div className="row" style={{ marginTop: 12, color: "var(--primary)", fontSize: 11.5, fontWeight: 500 }}>
                管理 <Icons.ChevRight size={12} style={{ marginLeft: 4 }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── color helpers ────────────────────────────────────────────────
function hexA(hex, a) {
  const h = hex.replace("#", "");
  const r = parseInt(h.substr(0,2), 16);
  const g = parseInt(h.substr(2,2), 16);
  const b = parseInt(h.substr(4,2), 16);
  return `rgba(${r},${g},${b},${a})`;
}
function lighten(hex, pct) {
  const h = hex.replace("#", "");
  let r = parseInt(h.substr(0,2), 16);
  let g = parseInt(h.substr(2,2), 16);
  let b = parseInt(h.substr(4,2), 16);
  r = Math.min(255, Math.round(r + (255 - r) * pct / 100));
  g = Math.min(255, Math.round(g + (255 - g) * pct / 100));
  b = Math.min(255, Math.round(b + (255 - b) * pct / 100));
  return `#${[r,g,b].map(x => x.toString(16).padStart(2, "0")).join("")}`;
}

ReactDOM.createRoot(document.getElementById("root")).render(<App />);

